import { ProjectSettingsComponent } from '../view-project-new/funnel/project-settings.component';
import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild, ElementRef, QueryList, ViewChildren, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatDialog, MatSelectChange, MatStepper } from '@angular/material';
import { AbstractControl, FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkflowDataService } from 'src/@core/services/job/workflow-data.service';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/@core/services/notification.service';
import { ThemeService } from 'src/@core/services/theme.service';
import { LayoutService } from 'src/@core/services/theme/layout.service';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { API_AUTH, REFRESH_GOOGLE_TOKEN, API_SEND_SINGLE_WHATSAPP_MSG, API_WHATSAPP_AGENT, API_WHATSAPP_SESSION, API_WHATSAPP_STATUS, API_WHATSAPP_QR, API_WHATSAPP_AGENT_SEND, API_WHATSAPP_LIST_TEMPLATES, API_WHATSAPP_LIST_WABAs, API_WHATSAPP_UPLOAD_IMAGE, PROJECT_API_KEY, API_SERRI_LIST_TEMPLATES, API_SERRI_LIST_ACCOUNTS, API_SERRI_TEMPLATE_PLACEHOLDERS } from 'src/@core/services/util/api.endpoints';
import { gapi } from 'gapi-script';
import { GoogleAccountPopupComponent } from '../google-account-popup/google-account-popup.component';
import { TestAgentDialogComponent } from '../view-project-new/view-project-details-new/test-agent-dialog.component';
import { environment } from 'src/environments/environment';
import { ScriptEditorDialogComponent } from './script-editor-dialog/script-editor-dialog.component';
import { WaTemplateLibraryDialogComponent } from './wa-template-library-dialog/wa-template-library-dialog.component';
import { SerriCreateTemplateDialogComponent } from 'src/app/modules/whatsapp/whatsapp-templates/serri-create-template-dialog/serri-create-template-dialog.component';
import { PhoneNumbersComponent } from '../../../phone-numbers/phone-numbers.component';
import { AssignedLeadUser } from '../entity-leads/models/entity-leads.types';
import { OutcomeReviewCopilotComponent } from '../outcome-review-copilot/outcome-review-copilot.component';

declare const intlTelInput: any;

interface UserToken {
  userId: string;
  email: string;
  googleRefreshToken: string;
}

interface WhatsAppResponse {
  message: string;
  qr_code_url: string;
  session_id: string;
  success: boolean;
}

/**
 * One placeholder of a WhatsApp template, as described by serriTemplatePlaceholders.
 * `index` is the flattened 1..N position across the whole template and stays the
 * ordering key; `component_index` is the number inside the token as it is written
 * in its own component. A body {{1}} and a button-URL {{1}} therefore share
 * component_index 1 but carry indexes 1 and 2 — `source` + `component_index` is
 * what actually tells them apart.
 */
interface TemplatePlaceholder {
  index: number;
  component_index: number;
  /** Which button the token belongs to. 0-based, so null — not 0 — means absent. */
  button_index: number | null;
  source: string;
  placeholder: string;
  button_text: string;
}

@Component({
  selector: 'hour4u-admin-workflow-stepper',
  templateUrl: './workflow-stepper.component.html',
  styleUrls: ['./workflow-stepper.component.scss']
})
export class WorkflowStepperComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('stepper', { static: true }) stepper: MatStepper;
  @ViewChildren('phoneInput') phoneInputs!: QueryList<ElementRef>;
  phoneInputInstances: any[] = [];

  loaderColor = 'primary';
  diameter = 30;
  mode = 'indeterminate';

  agentConfigurationForm: FormGroup;
  agentBindForm: FormGroup;
  scriptFormGroup: FormGroup;
  workflowOutcomeForm: FormGroup;
  campaignConfigForm: FormGroup;

  showStepper: boolean = true;
  isLoading: boolean = false;
  /** Set when user clicks Next/Save with an invalid form so errors become visible. */
  private validationAttemptedSteps = new Set<number>();
  agentsList: any[] = [];
  outboundAgents: any[] = [];
  inboundAgents: any[] = [];
  whatsappAgents: any[] = [];
  selectedAgent: any = null;
  workflowData: any;
  selectedFiles: File[] = [];
  profile = this.appService.getCurrentAccount();
  existingAccounts: UserToken[] = [];
  CLIENT_ID: string = environment.googleClientId;
  googleScope: string = environment.googleScope;
  // calendarIntegrated: boolean = false;
  inputFocusedStates: boolean[] = [];
  aiEditInProgress: boolean = false;
  isRecording: boolean = false;
  isTranscribing: boolean = false;
  private mediaRecorder: any;
  private audioChunks: any[] = [];
  private recordTimeout: any;
  previousFinalPrompt: string = '';

  // WhatsApp related properties
  whatsappResponse: WhatsAppResponse;
  showWhatsappQRPopup: boolean = false;
  qrCodeUrl: SafeResourceUrl | string = '';
  whatsappSessionId: string = '';
  whatsappStatus: any = null;
  isWhatsappConnected: boolean = false;
  private whatsappStatusInterval: any;

  // WhatsApp template related properties
  whatsappProviderType: string = ''; // 'meta_api', 'interakt', 'go_bridge'
  whatsappTemplates: any[] = [];
  whatsappTemplatesLoading: { [key: string]: boolean } = {}; // Track loading per action
  wabaList: any[] = [];
  // WhatsApp image upload properties
  whatsappImageUrls: { [key: string]: string } = {}; // Store imageUrl per action (key: outcomeIndex_actionIndex)
  whatsappImageUploading: { [key: string]: boolean } = {}; // Track upload status per action

  appearanceList = [
    { value: 'blue', label: 'Blue' },
    { value: 'red', label: 'Red' },
    { value: 'green', label: 'Green' }
  ];

  callActions = [
    { value: 'Send Email' },
    { value: 'Schedule Meeting' },
    { value: 'Call again' },
    { value: 'Send WhatsApp Message' },
    { value: 'ai hand off', label: 'AI Hand off' },
    // { value: 'Send SMS' }
  ];

  callActionsNew = [
    // { value: 'Send Email' },
    // { value: 'Schedule Meeting' },
    // { value: 'Send SMS' },
    { value: 'Call again' },
  ];

  /**
   * Lead/call fields the BE can substitute into a WhatsApp template placeholder.
   * Saved on each callAction as template_variables[].dynamic_field.
   */
  waDynamicFields = [
    { value: 'client_name', label: 'Client name' },
    { value: 'client_number', label: 'Client phone number' },
    { value: 'client_email', label: 'Client email' },
    { value: 'people_id', label: 'People ID' },
    { value: 'project_id', label: 'Project ID' },
    { value: 'project_name', label: 'Project name' },
    { value: 'entity_name', label: 'Company name' },
    { value: 'agent_name', label: 'Agent name' },
    { value: 'outcome_name', label: 'Outcome name' }
  ];

  /** Preset header names for outcome webhook API key auth. */
  webhookApiKeyHeaderOptions = [
    { value: 'X-AUTH-KEY', label: 'X-AUTH-KEY' },
    { value: 'x-api-key', label: 'x-api-key' }
  ];

  /** Follow-up delay unit dropdown (saved as "X m" | "X h" | "X d") */
  followUpDelayUnitOptions = [
    { value: 'm', label: 'Minutes' },
    { value: 'h', label: 'Hours' },
    { value: 'd', label: 'Days' }
  ];

  /**
   * Follow-up action step types for the generic follow_up_actions chain.
   * Values match the BE contract (lowercase).
   */
  followUpTypeOptions = [
    { value: 'send whatsapp message', label: 'Send WhatsApp Message' },
    { value: 'call again', label: 'Call Again' },
    { value: 'send email', label: 'Send Email' },
    { value: 'schedule meeting', label: 'Schedule Meeting' },
    { value: 'ai hand off', label: 'AI Hand off' }
  ];

  /** Step 4 — Goal KPIs & duration (campaignConfig) option lists */
  allowedChannelOptions = [
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'call', label: 'Call' },
    { value: 'email', label: 'Email' },
    { value: 'sms', label: 'SMS' }
  ];

  aggressionModeOptions = [
    { value: 'auto', label: 'Auto' },
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' }
  ];

  /** Calling-window dropdown options (30-min steps). Value stays "HH:mm" (24h). */
  timeOptions: { value: string; label: string }[] = [];

  /** HOA project STT/LLM (optional multipart keys: sttProvider, sttModel, llmModel) */
  readonly sttProviderOptions: { value: string; label: string }[] = [
    { value: 'deepgram', label: 'Deepgram' },
    { value: 'sarvam', label: 'Sarvam' },
    { value: 'soniox', label: 'Soniox' }
  ];
  readonly sttModelsByProvider: { [provider: string]: string[] } = {
    deepgram: ['nova-2', 'nova-3', 'nova-3-general', 'nova-3-medical'],
    sarvam: ['saaras:v3'],
    soniox: ['stt-rt-v4']
  };
  readonly defaultSttProvider = 'deepgram';
  readonly defaultSttModel = 'nova-3';

  selectedProject: any;
  selectedWorkflowType: string | null = null; // Store the workflow type from query params
  phoneNumbers: any[] = []; // Array to store phone numbers for plivoCallerId dropdown

  // Agent type selection
  agentType: string = 'outbound'; // Default to outbound
  agentTypes = [
    { value: 'outbound', label: 'Outbound Agent' },
    { value: 'inbound', label: 'Inbound Agent' }
  ];

  // Inbound agent specific properties
  inboundBearerToken: string = '';
  inboundConfigs: any[] = [];

  // Voice mapping and available voices
  availableVoices: any[] = [];
  voiceMapping = {
    // ElevenLabs voices
    'shyam_en_male': { provider: 'elevenlabs', voiceId: 'qSV5UqvHBC0Widy71Esh', name: 'Shyam' },
    'monika_en_female': { provider: 'elevenlabs', voiceId: 'ZUrEGyu8GFMwnHbvLhv2', name: 'Monika' },
    'shyam_hi_male': { provider: 'elevenlabs', voiceId: 'qSV5UqvHBC0Widy71Esh', name: 'Shyam' },
    'monika_hi_female': { provider: 'elevenlabs', voiceId: 'ZUrEGyu8GFMwnHbvLhv2', name: 'Monika' },

    // Google voices
    'google_en_male': { provider: 'google', voiceId: 'en-IN-Chirp3-HD-Puck', name: 'Puck' },
    'google_en_female': { provider: 'google', voiceId: 'en-IN-Chirp3-HD-Sulafat', name: 'Sulafat' },
    'google_hi_male': { provider: 'google', voiceId: 'hi-IN-Chirp3-HD-Puck', name: 'Puck' },
    'google_hi_female': { provider: 'google', voiceId: 'hi-IN-Chirp3-HD-Sulafat', name: 'Sulafat' },
    'google_ta_male': { provider: 'google', voiceId: 'ta-IN-Chirp3-HD-Algenib', name: 'Puck' },
    'google_ta_female': { provider: 'google', voiceId: 'ta-IN-Chirp3-HD-Sulafat', name: 'Sulafat' },
    'google_mr_male': { provider: 'google', voiceId: 'mr-IN-Chirp3-HD-Puck', name: 'Puck' },
    'google_mr_female': { provider: 'google', voiceId: 'mr-IN-Chirp3-HD-Sulafat', name: 'Sulafat' },

    // Sarvam voices
    'hitesh_en_male': { provider: 'sarvam', voiceId: 'hitesh', name: 'Hitesh' },
    'anushka_en_female': { provider: 'sarvam', voiceId: 'simran', name: 'Simran' },
    'abhilash_hi_male': { provider: 'sarvam', voiceId: 'abhilash', name: 'Abhilash' },
    'manisha_hi_female': { provider: 'sarvam', voiceId: 'simran', name: 'Simran' },
    'hitesh_ta_male': { provider: 'sarvam', voiceId: 'hitesh', name: 'Hitesh' },
    'anushka_ta_female': { provider: 'sarvam', voiceId: 'anushka', name: 'Anushka' },
    'abhilash_mr_male': { provider: 'sarvam', voiceId: 'abhilash', name: 'Abhilash' },
    'manisha_mr_female': { provider: 'sarvam', voiceId: 'manisha', name: 'Manisha' },

    // Smallest voices
    'anmol_en_male': { provider: 'smallest', voiceId: 'voice_RfJxHsDeod', name: 'Anmol' },
    'adity_en_female': { provider: 'smallest', voiceId: 'aditi', name: 'Adity' },
    'juhi_en_female_2': { provider: 'smallest', voiceId: 'voice_VRlFu49gQv', name: 'Juhi' },
    'anmol_hi_male': { provider: 'smallest', voiceId: 'voice_RfJxHsDeod', name: 'Anmol' },
    'adity_hi_female': { provider: 'smallest', voiceId: 'aditi', name: 'Adity' },
    'juhi_hi_female_2': { provider: 'smallest', voiceId: 'voice_VRlFu49gQv', name: 'Juhi' },
    'vijay_ta_male': { provider: 'smallest', voiceId: 'vijay', name: 'Vijay' },
    'vidya_ta_female': { provider: 'smallest', voiceId: 'vidya', name: 'Vidya' },

    // Gemini voices (all female, available in both English and Hindi)
    'aoede_en_female': { provider: 'gemini', voiceId: 'Aoede', name: 'Aoede' },
    'aoede_hi_female': { provider: 'gemini', voiceId: 'Aoede', name: 'Aoede' },
    'despina_en_female': { provider: 'gemini', voiceId: 'Despina', name: 'Despina' },
    'despina_hi_female': { provider: 'gemini', voiceId: 'Despina', name: 'Despina' },
    'kore_en_female': { provider: 'gemini', voiceId: 'Kore', name: 'Kore' },
    'kore_hi_female': { provider: 'gemini', voiceId: 'Kore', name: 'Kore' },
    'leda_en_female': { provider: 'gemini', voiceId: 'Leda', name: 'Leda' },
    'leda_hi_female': { provider: 'gemini', voiceId: 'Leda', name: 'Leda' }
  };

  constructor(
    private _formBuilder: FormBuilder,
    private workflowDataService: WorkflowDataService,
    private router: Router,
    private appService: AppService,
    private jobService: JobService,
    private route: ActivatedRoute,
    private notify: NotificationService,
    public themeService: ThemeService,
    private enterpriseAdminService: EnterpriseAdminService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    // Set loading state immediately to prevent empty form flash
    this.isLoading = true;

    // ✅ Retrieve stored data
    this.workflowData = this.workflowDataService.getWorkflowData();

    // if (!this.workflowData || this.workflowData.length === 0) {
    //   console.error('No workflow data found, redirecting back.');
    //   this.router.navigate(['/job']); // Redirect if no data
    //   return;
    // }

    console.log("Received Workflow Data:", this.workflowData);
    this.initClientGoogle();
    this.initializeForms();
    console.log("Profile", this.profile.entity.email, this.profile.entity.entityMeta.name);

    // ✅ Fetch agents list FIRST, then fetch project details
    this.getAllAgentsList();
    this.getPhoneNumbers(); // Fetch phone numbers for plivoCallerId dropdown

    // Initialize available voices based on default language
    this.updateAvailableVoices('hi'); // Default to Hindi

    // Read workflow type from query params
    this.route.queryParams.subscribe(queryParams => {
      this.selectedWorkflowType = queryParams['workflowType'] || null;
      this.requestedStep = queryParams['step'] || null;
      console.log('Selected workflow type:', this.selectedWorkflowType);
    });

    this.route.params.subscribe(data => {
      console.log(data)
      if (data.projectId) {
        // ✅ Wait for agentsList to populate (with timeout fallback)
        const projectIdToLoad = data.projectId;
        let agentsWaitTimeout: any = null;
        let agentsCheckInterval: any = null;

        const loadProject = () => {
          if (agentsCheckInterval) clearInterval(agentsCheckInterval);
          if (agentsWaitTimeout) clearTimeout(agentsWaitTimeout);
          this.getProjectDetailsById(projectIdToLoad);
        };

        if (this.agentsList.length > 0) {
          // Agents already loaded, proceed immediately
          loadProject();
        } else {
          // Wait for agents list to load first (max 5 seconds)
          agentsCheckInterval = setInterval(() => {
            if (this.agentsList.length > 0) {
              loadProject();
            }
          }, 100);

          // Timeout fallback - proceed anyway after 5 seconds
          agentsWaitTimeout = setTimeout(() => {
            if (agentsCheckInterval) clearInterval(agentsCheckInterval);
            console.warn('⚠️ Agents list not loaded after 5 seconds, proceeding anyway');
            loadProject();
          }, 5000);
        }
      }
      //      this.selectedAction = data.action;
    })
  }

  private updateToolbarNavigation(project: any) {
    if (!project) {
      return;
    }
    const projectId = project.project_id;
    const projectName = project.project_name || 'Project';

    this.layoutService.setProjectDetails({ project_name: projectName });

    this.layoutService.setPageNavigator([
      { label: 'Projects', route: '/job', icon: 'assets/cube.svg' },
      { label: projectName, route: projectId ? `/job/view-new-project/${projectId}` : undefined },
      { label: 'Workflow setup' }
    ]);
  }

  ngAfterViewInit() {
    this.initIntlTelInputs();  // Ensure inputs are initialized on first load

    this.phoneInputs.changes.subscribe(() => {
      this.initIntlTelInputs();  // Re-initialize if inputs are added/removed
    });
  }

  private initIntlTelInputs(): void {
    this.phoneInputs.forEach((inputRef: ElementRef, index: number) => {
      if (!this.phoneInputInstances[index]) {
        const iti = intlTelInput(inputRef.nativeElement, {
          initialCountry: "in",
          separateDialCode: true,
          preferredCountries: ["in", "us", "gb", "au", "jp"],
          utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
        });
        console.log(iti.utilsScript)
        this.phoneInputInstances[index] = iti;
      }
    });
  }

  initClientGoogle() {
    gapi.load('client:auth2', () => {
      gapi.auth2
        .init({
          client_id: this.CLIENT_ID,
          cookiepolicy: 'single_host_origin',
          scope: this.googleScope,
          access_type: 'offline',
        })
        .then(() => {
          console.log('Google API client initialized');
        })
        .catch((error) => {
          console.error('Error initializing Google API client:', error);
        });
    });
  };

  initializeForms() {
    this.agentConfigurationForm = this._formBuilder.group({
      id: [''],
      entityId: this.profile.entity.id,
      userId: this.profile.entity.email,
      userName: this.profile.user.userMeta.name,
      projectId: this.workflowData.project_id,
      agentId: this.workflowData.agent_id,
      agentName: this.workflowData.agent_name,
      userPrompt: [''],
      userQuestions: this._formBuilder.array([this._formBuilder.control('')]),
      userVariables: this._formBuilder.array([]),
      projectName: [''],
      callAgentName: [''],
      whatsappAgentName: [''],
      language: ['hi'],
      voice: ['monika_hi_female'], // Default voice selection
      tts: ['elevenlabs'], // Hidden field - set automatically based on voice selection
      plivoCallerIds: [[]],
      autoCall: [false],
      websiteLink: [''],
      transferNumber: [''],
      entityEmail: this.profile.entity.email,
      voiceId: [''],
      sttProvider: [this.defaultSttProvider],
      sttModel: [this.defaultSttModel],
      llmModel: ['', [Validators.maxLength(128)]],


      //description: ['', [Validators.required, Validators.maxLength(200)]],
    });

    this.agentBindForm = this._formBuilder.group({
      enableOutbound: [false],
      enableInbound: [false],
      enableWhatsapp: [false],
      callAgentOutboundId: [''],
      callAgentInboundId: [''],
      whatsappAgentId: ['']
    });

    // Set default voiceId based on default voice selection
    const defaultVoice = this.agentConfigurationForm.get('voice').value;
    if (defaultVoice && this.voiceMapping[defaultVoice] && this.voiceMapping[defaultVoice].voiceId) {
      this.agentConfigurationForm.get('voiceId').setValue(this.voiceMapping[defaultVoice].voiceId);
    }

    this.scriptFormGroup = this._formBuilder.group({
      finalPrompt: [''],
      initialGreeting: [''],
      editAI: [''],
      whatsappChatPrompt: [''],
      whatsappDefaultMessage: ['']
    });

    this.workflowOutcomeForm = this._formBuilder.group({
      outcomes: this._formBuilder.array([this.getOutComesArray()])
    });

    this.timeOptions = this.buildTimeOptions(30);

    this.campaignConfigForm = this._formBuilder.group({
      campaign_goal: ['', [Validators.required]],
      goal_prompt: [''],
      goal_outcomes: [[]],
      allowed_channels: [['whatsapp', 'call']],
      max_touchpoints: [8, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
      // mat-datepicker (native adapter) holds a Date object; serialized to YYYY-MM-DD on save.
      campaign_start_date: [null],
      campaign_end_date: [null],
      target_quantity: [100, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
      aggression_mode: ['auto'],
      ai_autonomy: [true],
      calling_window_start: ['09:00'],
      calling_window_end: ['21:00']
    });
  }

  /** Outcome names defined in step 3 — used as options for goal_outcomes. */
  get definedOutcomeNames(): string[] {
    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
    if (!outcomes) {
      return [];
    }
    const names = outcomes.controls
      .map((c) => {
        const ctrl = c.get('outcome_name');
        return ctrl && ctrl.value ? String(ctrl.value).trim() : '';
      })
      .filter((name) => !!name);
    // De-duplicate while preserving order
    return names.filter((name, index) => names.indexOf(name) === index);
  }

  /** Build "HH:mm" dropdown options at the given minute step (value 24h, label 12h). */
  private buildTimeOptions(stepMinutes: number): { value: string; label: string }[] {
    const pad = (n: number) => String(n).padStart(2, '0');
    const opts: { value: string; label: string }[] = [];
    for (let mins = 0; mins < 24 * 60; mins += stepMinutes) {
      const h = Math.floor(mins / 60);
      const m = mins % 60;
      const period = h < 12 ? 'AM' : 'PM';
      const h12 = h % 12 === 0 ? 12 : h % 12;
      opts.push({ value: `${pad(h)}:${pad(m)}`, label: `${h12}:${pad(m)} ${period}` });
    }
    return opts;
  }

  /** Parse a "YYYY-MM-DD" string (or Date) into a local Date for mat-datepicker. */
  private parseDateString(value: any): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    const m = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) {
      const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  /** Format a mat-datepicker Date into "YYYY-MM-DD" (local, no timezone shift). */
  private toDateString(value: any): string {
    if (!value) {
      return '';
    }
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) {
      return '';
    }
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  /** Hydrate the campaignConfig form from a saved project (handles snake/camel keys). */
  patchCampaignConfig(cfg: any) {
    if (!cfg || typeof cfg !== 'object') {
      return;
    }
    this.campaignConfigForm.patchValue({
      campaign_goal: cfg.campaign_goal || '',
      goal_prompt: cfg.goal_prompt || '',
      goal_outcomes: Array.isArray(cfg.goal_outcomes) ? cfg.goal_outcomes : [],
      allowed_channels: Array.isArray(cfg.allowed_channels) ? cfg.allowed_channels : ['whatsapp', 'call'],
      max_touchpoints: cfg.max_touchpoints != null ? cfg.max_touchpoints : 8,
      campaign_start_date: this.parseDateString(cfg.campaign_start_date),
      campaign_end_date: this.parseDateString(cfg.campaign_end_date),
      target_quantity: cfg.target_quantity != null ? cfg.target_quantity : 100,
      aggression_mode: cfg.aggression_mode || 'auto',
      ai_autonomy: typeof cfg.ai_autonomy === 'boolean' ? cfg.ai_autonomy : true,
      calling_window_start: cfg.calling_window_start || '09:00',
      calling_window_end: cfg.calling_window_end || '21:00'
    });
  }

  getSttModelOptions(): string[] {
    const p =
      this.agentConfigurationForm &&
      this.agentConfigurationForm.get('sttProvider') &&
      this.agentConfigurationForm.get('sttProvider').value;
    const key = typeof p === 'string' && this.sttModelsByProvider[p] ? p : this.defaultSttProvider;
    return this.sttModelsByProvider[key] || this.sttModelsByProvider[this.defaultSttProvider];
  }

  onSttProviderChange(event: MatSelectChange) {
    const prov = event.value;
    const models = this.sttModelsByProvider[prov] || this.sttModelsByProvider[this.defaultSttProvider];
    const cur = this.agentConfigurationForm.get('sttModel').value;
    if (models.indexOf(cur) === -1) {
      this.agentConfigurationForm.get('sttModel').setValue(models[0] || this.defaultSttModel);
    }
  }

  private hydrateSttLlmFromProject(project: any): { sttProvider: string; sttModel: string; llmModel: string } {
    if (!project) {
      return {
        sttProvider: this.defaultSttProvider,
        sttModel: this.defaultSttModel,
        llmModel: ''
      };
    }
    let sttProvider = String(project.stt_provider || project.sttProvider || '').trim().toLowerCase();
    let sttModel = String(project.stt_model || project.sttModel || '').trim();
    let llmModel = String(project.llm_model || project.llmModel || '').trim().slice(0, 128);

    if (!sttProvider && project.stt === 'sarvam') {
      sttProvider = 'sarvam';
      if (!sttModel) {
        sttModel = 'saaras:v3';
      }
    }

    if (!sttProvider || !this.sttModelsByProvider[sttProvider]) {
      sttProvider = this.defaultSttProvider;
    }
    const allowed = this.sttModelsByProvider[sttProvider] || [];
    if (!sttModel || allowed.indexOf(sttModel) === -1) {
      sttModel =
        sttProvider === this.defaultSttProvider
          ? this.defaultSttModel
          : allowed[0] || this.defaultSttModel;
    }

    return { sttProvider, sttModel, llmModel };
  }

  private markSttLlmFieldsPristine(): void {
    ['sttProvider', 'sttModel', 'llmModel'].forEach((name) => {
      const c = this.agentConfigurationForm.get(name);
      if (c) {
        c.markAsPristine();
      }
    });
  }

  private appendSttLlmToFormData(formData: FormData): void {
    const sttP = this.agentConfigurationForm.get('sttProvider');
    const sttM = this.agentConfigurationForm.get('sttModel');
    const llm = this.agentConfigurationForm.get('llmModel');
    const provider =
      sttP && sttP.value != null && String(sttP.value).trim() !== ''
        ? String(sttP.value).trim()
        : this.defaultSttProvider;
    const model =
      sttM && sttM.value != null && String(sttM.value).trim() !== ''
        ? String(sttM.value).trim()
        : this.defaultSttModel;
    const llmModel =
      llm && llm.value != null
        ? String(llm.value).trim().slice(0, 128)
        : '';

    // Always include in HOA project save payload (same as tts/voiceId/language etc.)
    formData.append('sttProvider', provider);
    formData.append('sttModel', model);
    formData.append('llmModel', llmModel);
  }

  private notifyHoaProjectSaveError(error: HttpErrorResponse, fallbackMessage: string): void {
    if (error && error.status === 400) {
      this.notify.showMessage(
        'Invalid combo of sttProvider/sttModel or llmModel too long.',
        4000
      );
    } else {
      this.notify.showMessage(fallbackMessage, 2000);
    }
  }

  // --- Outcome-definition review copilot (step 3) -------------------------
  // Opens a chat that reviews names/descriptions against the call script,
  // asks clarifying questions, and returns a proposed set. Apply patches the
  // form only — nothing is saved until the user saves the step as usual.
  outcomeRewriteSnapshot: Array<{ name: string; description: string }> = null;
  outcomeRewriteCount = 0;

  /** An outcome needs a name before AI has anything to define. */
  get canRewriteOutcomeDefinitions(): boolean {
    if (!this.workflowOutcomeForm) {
      return false;
    }
    const finalPrompt = this.scriptFormGroup && this.scriptFormGroup.get('finalPrompt')
      ? this.scriptFormGroup.get('finalPrompt').value : '';
    if (!finalPrompt || !String(finalPrompt).trim()) {
      return false;
    }
    return this.outcomes.controls.some(
      (control: any) => !!(control.get('outcome_name').value || '').trim()
    );
  }

  /** Says why the button is off, rather than leaving a dead control unexplained. */
  get outcomeRewriteTooltip(): string {
    const finalPrompt = this.scriptFormGroup && this.scriptFormGroup.get('finalPrompt')
      ? this.scriptFormGroup.get('finalPrompt').value : '';
    if (!finalPrompt || !String(finalPrompt).trim()) {
      return 'Add the call script in the previous step first — the definitions are written against it.';
    }
    if (!this.canRewriteOutcomeDefinitions) {
      return 'Name at least one outcome first.';
    }
    return 'Opens a review chat that aligns outcome definitions with your call script '
      + 'so the post-call classifier can tell them apart. Nothing saves until you Apply.';
  }

  openOutcomeReviewCopilot(): void {
    if (!this.canRewriteOutcomeDefinitions) {
      return;
    }

    const rows = this.outcomes.controls
      .map((control: any) => ({
        outcome_name: (control.get('outcome_name').value || '').trim(),
        outcome_description: control.get('outcome_description').value || ''
      }))
      .filter(row => !!row.outcome_name);

    if (!rows.length) {
      return;
    }

    const projectId = this.selectedProject && this.selectedProject.project_id
      ? this.selectedProject.project_id
      : (this.workflowData && this.workflowData.project_id) || undefined;

    const dialogRef = this.dialog.open(OutcomeReviewCopilotComponent, {
      width: '880px',
      maxWidth: '96vw',
      maxHeight: '92vh',
      panelClass: 'outcome-review-copilot-dialog',
      disableClose: false,
      autoFocus: false,
      data: {
        entityId: this.entityId,
        projectId,
        direction: this.isInboundAgentType() ? 'inbound' : 'outbound',
        finalPrompt: this.scriptFormGroup.get('finalPrompt').value || '',
        outcomes: rows
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result || !result.outcomes || !result.outcomes.length) {
        return;
      }
      this.applyReviewedOutcomeDefinitions(result.outcomes);
      if (result.saveToProject) {
        this.saveOutcomes().catch(() => { });
      }
    });
  }

  /** Restore names + descriptions as they were before the last Apply. */
  undoOutcomeRewrite(): void {
    if (!this.outcomeRewriteSnapshot) {
      return;
    }
    const outcomes = this.outcomes;
    while (outcomes.length) {
      outcomes.removeAt(0);
    }
    this.outcomeRewriteSnapshot.forEach(row => {
      const group = this.getOutComesArray();
      group.get('outcome_name').setValue(row.name);
      group.get('outcome_description').setValue(row.description);
      outcomes.push(group);
    });
    this.outcomeRewriteSnapshot = null;
    this.outcomeRewriteCount = 0;
    this.cdr.detectChanges();
    this.notify.showMessage('Definitions restored.', 2000);
  }

  /**
   * Apply a full proposed outcome set from the review chat.
   * Matched names keep notify flags / call actions; new names get defaults;
   * names missing from the proposal are removed after confirm when needed.
   */
  private applyReviewedOutcomeDefinitions(proposed: any[]): void {
    const normalised = (proposed || [])
      .map(row => ({
        outcome_name: (row.outcome_name || row.name || '').trim(),
        outcome_description: row.outcome_description || row.description || ''
      }))
      .filter(row => !!row.outcome_name);

    if (!normalised.length) {
      this.notify.showMessage('AI returned no outcomes to apply.', 3000);
      return;
    }

    const proposedNames = new Set(normalised.map(r => r.outcome_name.toLowerCase()));
    const existingByName = new Map<string, any>();
    this.outcomes.controls.forEach((control: any) => {
      const name = (control.get('outcome_name').value || '').trim().toLowerCase();
      if (name) {
        existingByName.set(name, control);
      }
    });

    const removedNames: string[] = [];
    this.outcomes.controls.forEach((control: any) => {
      const name = (control.get('outcome_name').value || '').trim();
      if (name && !proposedNames.has(name.toLowerCase())) {
        removedNames.push(name);
      }
    });

    if (removedNames.length) {
      const ok = window.confirm(
        `Apply will remove ${removedNames.length} outcome`
        + (removedNames.length === 1 ? '' : 's')
        + ` not in the proposal (${removedNames.join(', ')}). Continue?`
      );
      if (!ok) {
        return;
      }
    }

    const snapshot = this.outcomes.controls.map((control: any) => ({
      name: control.get('outcome_name').value || '',
      description: control.get('outcome_description').value || ''
    }));

    const outcomes = this.outcomes;
    while (outcomes.length) {
      outcomes.removeAt(0);
    }

    let changed = 0;
    normalised.forEach(row => {
      const key = row.outcome_name.toLowerCase();
      const existing = existingByName.get(key);
      let group: FormGroup;
      if (existing) {
        group = existing as FormGroup;
        const prevDesc = group.get('outcome_description').value || '';
        const prevName = (group.get('outcome_name').value || '').trim();
        if (prevDesc !== row.outcome_description || prevName !== row.outcome_name) {
          changed++;
        }
        group.get('outcome_name').setValue(row.outcome_name);
        group.get('outcome_description').setValue(row.outcome_description);
        group.get('outcome_description').markAsDirty();
      } else {
        group = this.getOutComesArray();
        group.get('outcome_name').setValue(row.outcome_name);
        group.get('outcome_description').setValue(row.outcome_description);
        changed++;
      }
      outcomes.push(group);
    });

    if (removedNames.length) {
      changed += removedNames.length;
    }

    this.outcomeRewriteSnapshot = snapshot;
    this.outcomeRewriteCount = changed || normalised.length;
    this.cdr.detectChanges();
    this.notify.showMessage(
      `${this.outcomeRewriteCount} outcome definition`
      + (this.outcomeRewriteCount === 1 ? '' : 's')
      + ' updated. Review them before saving.',
      3000
    );
  }

  get outcomes() {
    return this.workflowOutcomeForm.get('outcomes') as FormArray;
  }

  addMoreQuestions() {
    const userQuestionsArray = this.agentConfigurationForm.get('userQuestions') as FormArray;
    userQuestionsArray.push(this._formBuilder.control(''));
  }

  addMoreOutcomes() {
    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
    outcomes.push(this.getOutComesArray());
  }
  removeQuestion(index: number) {
    this.userQuestions.removeAt(index);
  }

  getOutComesArray() {
    let f = this._formBuilder.group({
      outcome_name: ['', [Validators.required]],
      outcome_appearance: [''],
      outcome_description: [''],
      notify: [false],
      notify_google_sheet: [false],
      notify_via_webhook: [false],
      webhook_same_as_previous: [false],
      add_in_other_project: [false],
      do_not_consider_for_analysis: [false],
      project_url: [''],
      automatic_call: [false],
      assign_users: [[]],
      webhook: this.buildWebhookFormGroup(null),
      conditions: this._formBuilder.array([this.getConditionsArray()]),
      callActions: this._formBuilder.array([]),
    });
    this.bindAddInOtherProjectHandlers(f);
    this.bindWebhookNotifyHandlers(f);
    return f;
  }

  /** Nested webhook config for an outcome (URL, API key, field mappings). */
  private buildWebhookFormGroup(webhook: any): FormGroup {
    const raw = webhook && typeof webhook === 'object' ? webhook : {};
    const fields = Array.isArray(raw.fields) ? raw.fields : [];
    return this._formBuilder.group({
      url: [String(raw.url || '').trim()],
      method: ['POST'],
      api_key_header: [String(raw.api_key_header || 'X-AUTH-KEY').trim() || 'X-AUTH-KEY'],
      api_key: [String(raw.api_key || '')],
      fields: this._formBuilder.array(
        fields.length
          ? fields.map((f: any) => this.getWebhookFieldGroup(f))
          : [this.getWebhookFieldGroup(null)]
      )
    });
  }

  getWebhookFieldGroup(field?: any): FormGroup {
    const raw = field && typeof field === 'object' ? field : {};
    return this._formBuilder.group({
      key: [String(raw.key || '').trim()],
      value: [String(raw.value || '').trim()]
    });
  }

  getWebhookFields(outcome: AbstractControl): FormArray {
    return (outcome.get('webhook.fields') as FormArray) || this._formBuilder.array([]);
  }

  addWebhookField(outcomeIndex: number): void {
    const outcome = this.outcomes.at(outcomeIndex) as FormGroup;
    if (!outcome) {
      return;
    }
    this.getWebhookFields(outcome).push(this.getWebhookFieldGroup(null));
  }

  removeWebhookField(outcomeIndex: number, fieldIndex: number): void {
    const fields = this.getWebhookFields(this.outcomes.at(outcomeIndex));
    if (!fields || fields.length <= 1) {
      if (fields && fields.length === 1) {
        fields.at(0).patchValue({ key: '', value: '' });
      }
      return;
    }
    fields.removeAt(fieldIndex);
  }

  /**
   * Walk prior outcomes (skipping gaps) and return the webhook value from the
   * nearest previous outcome that has Notify via webhook enabled.
   */
  private findLastPreviousWebhookConfig(outcomeIndex: number): any | null {
    for (let i = outcomeIndex - 1; i >= 0; i--) {
      const prev = this.outcomes.at(i) as FormGroup;
      const notifyCtrl = prev.get('notify_via_webhook');
      if (!prev || !notifyCtrl || notifyCtrl.value !== true) {
        continue;
      }
      const webhook = prev.get('webhook');
      return webhook ? webhook.value : null;
    }
    return null;
  }

  /** Replace this outcome's webhook FormGroup contents from a raw webhook object. */
  private replaceWebhookFormValue(outcomeForm: FormGroup, webhook: any): void {
    const target = outcomeForm.get('webhook') as FormGroup;
    if (!target) {
      return;
    }
    const raw = webhook && typeof webhook === 'object' ? webhook : {};
    target.patchValue(
      {
        url: String(raw.url || '').trim(),
        method: 'POST',
        api_key_header: String(raw.api_key_header || 'X-AUTH-KEY').trim() || 'X-AUTH-KEY',
        api_key: String(raw.api_key || '')
      },
      { emitEvent: false }
    );
    const fieldsArr = target.get('fields') as FormArray;
    if (!fieldsArr) {
      return;
    }
    const nextFields = Array.isArray(raw.fields) ? raw.fields : [];
    while (fieldsArr.length) {
      fieldsArr.removeAt(0);
    }
    if (nextFields.length) {
      nextFields.forEach((f: any) => fieldsArr.push(this.getWebhookFieldGroup(f)));
    } else {
      fieldsArr.push(this.getWebhookFieldGroup(null));
    }
    this.syncWebhookValidators(outcomeForm);
  }

  /**
   * When "Same as previous outcome" is checked, copy webhook config from the
   * last prior outcome that had Notify via webhook on. Gaps are skipped.
   * If none match, clear to empty defaults.
   */
  onWebhookSameAsPreviousChange(outcomeIndex: number): void {
    const outcomeForm = this.outcomes.at(outcomeIndex) as FormGroup;
    if (!outcomeForm) {
      return;
    }
    const flag = outcomeForm.get('webhook_same_as_previous');
    if (!flag || flag.value !== true) {
      return;
    }
    const previous = this.findLastPreviousWebhookConfig(outcomeIndex);
    this.replaceWebhookFormValue(outcomeForm, previous);
  }

  private syncWebhookValidators(outcomeForm: FormGroup): void {
    const enabled = outcomeForm.get('notify_via_webhook');
    const urlCtrl = outcomeForm.get('webhook.url');
    if (!enabled || !urlCtrl) {
      return;
    }
    if (enabled.value === true) {
      urlCtrl.setValidators([Validators.required, Validators.pattern(/^https?:\/\/.+/i)]);
    } else {
      urlCtrl.clearValidators();
    }
    urlCtrl.updateValueAndValidity({ emitEvent: false });
  }

  private clearWebhookForm(outcomeForm: FormGroup): void {
    const webhook = outcomeForm.get('webhook') as FormGroup;
    if (!webhook) {
      return;
    }
    webhook.patchValue(
      { url: '', method: 'POST', api_key_header: 'X-AUTH-KEY', api_key: '' },
      { emitEvent: false }
    );
    const fields = webhook.get('fields') as FormArray;
    if (fields) {
      while (fields.length > 1) {
        fields.removeAt(fields.length - 1);
      }
      if (fields.length === 1) {
        fields.at(0).patchValue({ key: '', value: '' }, { emitEvent: false });
      } else if (fields.length === 0) {
        fields.push(this.getWebhookFieldGroup(null));
      }
    }
    const sameAsPrev = outcomeForm.get('webhook_same_as_previous');
    if (sameAsPrev) {
      sameAsPrev.setValue(false, { emitEvent: false });
    }
  }

  private bindWebhookNotifyHandlers(outcomeForm: FormGroup): void {
    const enabled = outcomeForm.get('notify_via_webhook');
    if (!enabled || outcomeForm['_webhookNotifySubscription']) {
      return;
    }
    this.syncWebhookValidators(outcomeForm);
    outcomeForm['_webhookNotifySubscription'] = enabled.valueChanges.subscribe(() => {
      if (enabled.value !== true) {
        this.clearWebhookForm(outcomeForm);
      }
      this.syncWebhookValidators(outcomeForm);
    });
  }

  private serializeWebhookFields(fields: any[]): Array<{ key: string; value: string }> {
    if (!Array.isArray(fields)) {
      return [];
    }
    return fields
      .map((f: any) => ({
        key: String((f && f.key) || '').trim(),
        value: String((f && f.value) || '').trim()
      }))
      .filter((f) => !!f.key);
  }

  private sanitizeWebhookForSave(outcome: any): any {
    // webhook_same_as_previous is UI-only — never persist it.
    if (outcome.notify_via_webhook !== true) {
      return {
        notify_via_webhook: false,
        webhook: {
          url: '',
          method: 'POST',
          api_key_header: 'X-AUTH-KEY',
          api_key: '',
          fields: []
        }
      };
    }
    const raw = outcome.webhook && typeof outcome.webhook === 'object' ? outcome.webhook : {};
    const header = String(raw.api_key_header || 'X-AUTH-KEY').trim() || 'X-AUTH-KEY';
    return {
      notify_via_webhook: true,
      webhook: {
        url: String(raw.url || '').trim(),
        method: 'POST',
        api_key_header: header,
        api_key: String(raw.api_key || ''),
        fields: this.serializeWebhookFields(raw.fields)
      }
    };
  }

  /** Entity id for the project dropdown inside "Add in other project". */
  get entityId(): string {
    return this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : '';
  }

  /** Store the picked project's id in `project_url` — the outcome's target project. */
  onOutcomeProjectChange(outcomeIndex: number, projectId: string | null): void {
    const outcomeForm = this.outcomes.at(outcomeIndex) as FormGroup;
    if (!outcomeForm) {
      return;
    }
    const projectUrl = outcomeForm.get('project_url');
    if (!projectUrl) {
      return;
    }
    projectUrl.setValue(projectId || '');
    projectUrl.markAsTouched();
    projectUrl.markAsDirty();
  }

  /** Users this outcome hands its leads to, as picked in the outcome's role/user picker. */
  onOutcomeAssignUsersChange(outcomeIndex: number, users: AssignedLeadUser[]): void {
    const outcomeForm = this.outcomes.at(outcomeIndex) as FormGroup;
    const assignUsers = outcomeForm && outcomeForm.get('assign_users');
    if (!assignUsers) {
      return;
    }
    assignUsers.setValue(this.normalizeAssignUsers(users));
    assignUsers.markAsDirty();
  }

  /** `assign_users` as the backend reads it: unique `{ user_id, user_name }` entries. */
  private normalizeAssignUsers(value: any): AssignedLeadUser[] {
    const entries = Array.isArray(value) ? value : [];
    const seen = new Set<string>();
    const users: AssignedLeadUser[] = [];
    entries.forEach((entry: any) => {
      const userId = String((entry && (entry.user_id || entry.userId)) || '').trim();
      if (!userId || seen.has(userId)) {
        return;
      }
      seen.add(userId);
      users.push({ user_id: userId, user_name: String((entry && (entry.user_name || entry.userName)) || '').trim() });
    });
    return users;
  }

  /** `project_url` is only required while the outcome pushes the lead into another project. */
  private syncAddInOtherProjectValidators(outcomeForm: FormGroup): void {
    const enabled = outcomeForm.get('add_in_other_project');
    const projectUrl = outcomeForm.get('project_url');
    if (!enabled || !projectUrl) {
      return;
    }
    if (enabled.value === true) {
      projectUrl.setValidators([Validators.required]);
    } else {
      projectUrl.clearValidators();
    }
    projectUrl.updateValueAndValidity({ emitEvent: false });
  }

  private bindAddInOtherProjectHandlers(outcomeForm: FormGroup): void {
    const enabled = outcomeForm.get('add_in_other_project');
    if (!enabled || outcomeForm['_addInOtherProjectSubscription']) {
      return;
    }
    this.syncAddInOtherProjectValidators(outcomeForm);
    outcomeForm['_addInOtherProjectSubscription'] = enabled.valueChanges.subscribe(() => {
      const projectUrl = outcomeForm.get('project_url');
      const automaticCall = outcomeForm.get('automatic_call');
      if (enabled.value !== true) {
        if (projectUrl) {
          projectUrl.setValue('', { emitEvent: false });
        }
        if (automaticCall) {
          automaticCall.setValue(false, { emitEvent: false });
        }
      }
      this.syncAddInOtherProjectValidators(outcomeForm);
    });
  }

  getConditionsArray() {
    let f = this._formBuilder.group({
      condition: [''],
    });
    return f;
  }

  normalizeCallActionValue(v: any): string {
    if (v == null || v === '') {
      return '';
    }
    const s = String(v).trim();
    if (s.toLowerCase() === 'send whatsapp message') {
      return 'Send WhatsApp Message';
    }
    return s;
  }

  /** Default true — allows WhatsApp sends inside the 24h free-flow window. */
  private resolveSendMessageViaFreeFlow(action: any): boolean {
    if (typeof action.send_message_via_free_flow === 'boolean') {
      return action.send_message_via_free_flow;
    }
    return true;
  }

  setWhatsAppFreeFlow(actionForm: FormGroup, enabled: boolean): void {
    if (!actionForm || !actionForm.get('send_message_via_free_flow')) {
      return;
    }
    actionForm.get('send_message_via_free_flow').setValue(enabled);
    if (!enabled) {
      this.ensureWhatsAppTemplatesLoaded(actionForm);
      if (!actionForm.get('template_name').value) {
        this.openWhatsAppTemplateLibrary(actionForm, actionForm);
      }
    } else {
      actionForm.get('template_name').setValue('', { emitEvent: false });
      actionForm.get('template_id').setValue('', { emitEvent: false });
      this.clearTemplateVariables(actionForm);
    }
    this.syncWhatsAppActionValidators(actionForm);
  }

  setFollowUpStepFreeFlow(callAction: FormGroup, stepCtrl: FormGroup, enabled: boolean): void {
    if (!stepCtrl || !stepCtrl.get('send_message_via_free_flow')) {
      return;
    }
    stepCtrl.get('send_message_via_free_flow').setValue(enabled);
    if (!enabled) {
      this.ensureWhatsAppTemplatesLoaded(callAction);
      if (!stepCtrl.get('template_name').value) {
        this.openWhatsAppTemplateLibrary(callAction, stepCtrl);
      }
    } else {
      stepCtrl.get('template_name').setValue('', { emitEvent: false });
      stepCtrl.get('template_id').setValue('', { emitEvent: false });
    }
    this.onFollowUpStepFreeFlowChange(callAction, stepCtrl);
  }

  openWhatsAppTemplateLibrary(templatesParentForm: FormGroup, targetForm: FormGroup): void {
    if (!templatesParentForm || !targetForm) {
      return;
    }

    const entityId = this.profile && this.profile.entity && this.profile.entity.id
      ? this.profile.entity.id
      : '';
    if (!entityId) {
      this.notify.showMessage('Entity ID is missing.', 3000);
      return;
    }

    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls
      && this.agentConfigurationForm.controls['id']
      ? this.agentConfigurationForm.controls['id'].value
      : '';

    const openDialog = (whatsappPhoneNumber: string, providerType: string) => {
      const dialogRef = this.dialog.open(WaTemplateLibraryDialogComponent, {
        width: '640px',
        maxHeight: '90vh',
        panelClass: 'wa-template-library-dialog',
        disableClose: false,
        data: {
          entityId,
          projectId,
          whatsappPhoneNumber,
          providerType: providerType || 'serri',
          selectedName: targetForm.get('template_name').value,
          getTemplateValue: (t: any) => this.getMatSelectTemplateValue(t),
        },
      });

      dialogRef.afterClosed().subscribe((selected: any) => {
        if (!selected) {
          return;
        }
        if (selected.createNew) {
          this.openCreateWhatsAppTemplate(templatesParentForm, targetForm);
          return;
        }
        const value = this.getMatSelectTemplateValue(selected);
        targetForm.get('template_name').setValue(value);
        const tid = selected.template_id != null ? selected.template_id : selected.id;
        targetForm.get('template_id').setValue(tid != null ? String(tid) : '', { emitEvent: false });
        targetForm.get('template_name').markAsTouched();

        const existing = templatesParentForm['_templates'] || [];
        const hasTemplate = existing.some((t: any) => this.getMatSelectTemplateValue(t) === value);
        if (!hasTemplate) {
          templatesParentForm['_templates'] = [...existing, selected];
        }

        // The picked template decides which {{n}} placeholders need a mapping.
        this.syncTemplateVariablesForTarget(targetForm, templatesParentForm);

        if (templatesParentForm === targetForm) {
          this.syncWhatsAppActionValidators(templatesParentForm);
        } else {
          const fu = templatesParentForm.get('follow_up_actions') as FormGroup;
          this.applyFollowUpActionStepValidators(targetForm, fu.get('enabled').value === true);
        }
        this.cdr.markForCheck();
      });
    };

    const providerType = this.getWhatsAppProviderTypeForAction();
    const projectPhone = this.resolveSerriWhatsappPhoneFromProject();

    if (projectPhone) {
      openDialog(projectPhone, providerType || 'serri');
      return;
    }

    const params = new URLSearchParams({ entity_id: entityId });
    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    this.http.get(`${API_SERRI_LIST_ACCOUNTS}?${params.toString()}`, { headers }).subscribe({
      next: (response: any) => {
        const phone = this.extractSerriPhoneFromAccountsResponse(response);
        openDialog(phone, phone ? 'serri' : (providerType || 'serri'));
      },
      error: () => {
        openDialog('', providerType || 'serri');
      }
    });
  }

  getTemplatePickerLabel(targetForm: FormGroup, templatesParentForm: FormGroup): string {
    const name = targetForm && targetForm.get('template_name') ? targetForm.get('template_name').value : '';
    if (!name) {
      return 'Choose a template…';
    }
    const template = this.findTemplateByName(templatesParentForm, name);
    return template ? (template.name || template.template_name || template.label || name) : String(name);
  }

  getTemplatePreviewForTarget(targetForm: FormGroup, templatesParentForm: FormGroup): string {
    const name = targetForm && targetForm.get('template_name') ? targetForm.get('template_name').value : '';
    if (!name) {
      return '';
    }
    const template = this.findTemplateByName(templatesParentForm, name);
    return this.getTemplatePreviewBody(template);
  }

  getTemplateCategoryForTarget(targetForm: FormGroup, templatesParentForm: FormGroup): string {
    const name = targetForm && targetForm.get('template_name') ? targetForm.get('template_name').value : '';
    if (!name) {
      return '';
    }
    const template = this.findTemplateByName(templatesParentForm, name);
    if (!template) {
      return 'Template';
    }
    const cat = template.category || template.template_category || 'UTILITY';
    if (typeof cat === 'string' && cat.length) {
      return cat.charAt(0) + cat.slice(1).toLowerCase();
    }
    return 'Template';
  }

  clearWhatsAppTemplate(templatesParentForm: FormGroup, targetForm: FormGroup): void {
    if (!targetForm) {
      return;
    }
    targetForm.get('template_name').setValue('', { emitEvent: false });
    targetForm.get('template_id').setValue('', { emitEvent: false });
    targetForm.get('template_name').markAsTouched();
    this.clearTemplateVariables(targetForm);
    if (templatesParentForm === targetForm) {
      this.syncWhatsAppActionValidators(templatesParentForm);
    } else if (templatesParentForm) {
      const fu = templatesParentForm.get('follow_up_actions') as FormGroup;
      this.applyFollowUpActionStepValidators(targetForm, fu && fu.get('enabled').value === true);
    }
    this.cdr.markForCheck();
  }

  hasWhatsAppTemplateSelected(targetForm: FormGroup): boolean {
    return !!(targetForm && targetForm.get('template_name') && targetForm.get('template_name').value);
  }

  openCreateWhatsAppTemplate(templatesParentForm?: FormGroup, targetForm?: FormGroup): void {
    const entityId = this.profile && this.profile.entity && this.profile.entity.id
      ? this.profile.entity.id
      : '';

    if (!entityId) {
      this.notify.showMessage('Entity ID is missing.', 3500);
      return;
    }

    const projectPhone = this.resolveSerriWhatsappPhoneFromProject();
    if (projectPhone) {
      this.launchSerriCreateTemplateDialog(entityId, projectPhone, templatesParentForm, targetForm);
      return;
    }

    const params = new URLSearchParams({ entity_id: entityId });
    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    this.http.get(`${API_SERRI_LIST_ACCOUNTS}?${params.toString()}`, { headers }).subscribe({
      next: (response: any) => {
        const phone = this.extractSerriPhoneFromAccountsResponse(response);
        if (!phone) {
          this.notify.showMessage('No Serri WhatsApp number found. Connect Serri from WhatsApp settings.', 3500);
          return;
        }
        this.launchSerriCreateTemplateDialog(entityId, phone, templatesParentForm, targetForm);
      },
      error: () => {
        this.notify.showMessage('Failed to load Serri WhatsApp accounts.', 3500);
      }
    });
  }

  private resolveSerriWhatsappPhoneFromProject(): string {
    const fromProject = this.selectedProject && this.selectedProject.whatsapp_phone_number
      ? String(this.selectedProject.whatsapp_phone_number).trim()
      : '';
    if (fromProject) {
      return fromProject;
    }
    const fromAgentForm = this.agentConfigurationForm && this.agentConfigurationForm.get('whatsapp_phone_number')
      ? String(this.agentConfigurationForm.get('whatsapp_phone_number').value || '').trim()
      : '';
    return fromAgentForm;
  }

  private extractSerriPhoneFromAccountsResponse(response: any): string {
    let accounts: any[] = [];
    if (response && response.success && response.data && Array.isArray(response.data)) {
      accounts = response.data;
    } else if (Array.isArray(response)) {
      accounts = response;
    }
    if (!accounts.length) {
      return '';
    }
    const first = accounts[0];
    return String(first.whatsapp_phone_number || first.phone_number || '').trim();
  }

  private launchSerriCreateTemplateDialog(
    entityId: string,
    selectedSerriPhone: string,
    templatesParentForm?: FormGroup,
    targetForm?: FormGroup
  ): void {
    const dialogRef = this.dialog.open(SerriCreateTemplateDialogComponent, {
      width: '640px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      data: {
        entityId,
        selectedSerriPhone
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result || !result.success) {
        return;
      }
      if (templatesParentForm) {
        this.ensureWhatsAppTemplatesLoaded(templatesParentForm);
      }
      if (templatesParentForm && targetForm) {
        setTimeout(() => this.openWhatsAppTemplateLibrary(templatesParentForm, targetForm), 500);
      }
    });
  }

  private findTemplateByName(templatesParentForm: FormGroup, selectedName: string): any {
    const templates = this.getTemplatesForAction(templatesParentForm);
    const sv = String(selectedName);
    for (let i = 0; i < templates.length; i++) {
      if (this.getMatSelectTemplateValue(templates[i]) === sv) {
        return templates[i];
      }
    }
    return null;
  }

  private getTemplatePreviewBody(template: any): string {
    if (!template) {
      return '';
    }
    if (typeof template.text === 'string' && template.text.trim()) {
      return template.text.trim();
    }
    if (typeof template.sample_text === 'string' && template.sample_text.trim()) {
      return template.sample_text.trim();
    }
    if (typeof template.body === 'string' && template.body.trim()) {
      return template.body.trim();
    }
    if (Array.isArray(template.components)) {
      const body = template.components.find((c: any) => c.type === 'BODY' || c.type === 'body');
      if (body && body.text) {
        return body.text;
      }
    }
    return '';
  }

  // ---------------------------------------------------------------------------
  // WhatsApp template variables ({{1}}, {{2}} … → lead field + fallback)
  // ---------------------------------------------------------------------------

  /** Placeholders per Serri template_id, from serriTemplatePlaceholders. */
  private serriPlaceholderCache: { [templateId: string]: TemplatePlaceholder[] } = {};
  private serriPlaceholderInFlight: { [templateId: string]: boolean } = {};

  private buildTemplateVariableGroup(variable: any = {}): FormGroup {
    const v = variable && typeof variable === 'object' ? variable : {};
    const idx = Math.max(1, Math.floor(Number(v.index)) || 1);
    const token = String(v.placeholder || '');
    return this._formBuilder.group({
      index: [idx],
      // Which component the token lives in and how it is written there. `source`
      // and `component_index` are persisted alongside `index`; 0/'' means we don't
      // know yet (a config saved before this existed), and serializeTemplateVariables()
      // then omits them so the BE falls back to the old index-only path.
      source: [String(v.source || '')],
      component_index: [this.resolveComponentIndex(v.component_index, token)],
      button_index: [this.normalizeButtonIndex(v.button_index)],
      placeholder: [token],
      button_text: [String(v.button_text || '')],
      // Optional on purpose — an unmapped variable must never block saving the
      // workflow; serializeTemplateVariables() just drops the empty row.
      dynamic_field: [v.dynamic_field || ''],
      fallback_value: [v.fallback_value != null ? String(v.fallback_value) : '']
    });
  }

  private buildTemplateVariablesArray(variables: any): FormArray {
    const list = Array.isArray(variables) ? variables : [];
    return this._formBuilder.array(
      list.map((v: any) => this.buildTemplateVariableGroup(v))
    );
  }

  /**
   * The number inside the token, scoped to its own component. serriTemplatePlaceholders
   * will start sending `component_index` directly; until that ships we read it out of
   * the `{{n}}` placeholder. Returns 0 when neither is available.
   */
  private resolveComponentIndex(componentIndex: any, placeholder: string): number {
    const explicit = Math.floor(Number(componentIndex));
    if (explicit > 0) {
      return explicit;
    }
    const match = /{{\s*(\d+)\s*}}/.exec(String(placeholder || ''));
    return match ? Math.floor(Number(match[1])) : 0;
  }

  /**
   * Which button a button_url token belongs to. Optional — the BE reads it off the
   * live template when absent — but persisting it means a failed template lookup
   * can't misaddress the button. Button indexes are 0-based, so `null` (not 0) is
   * the "not supplied" marker.
   */
  private normalizeButtonIndex(value: any): number | null {
    if (value == null || value === '') {
      return null;
    }
    const n = Math.floor(Number(value));
    return isNaN(n) || n < 0 ? null : n;
  }

  /**
   * Build one placeholder descriptor. `placeholder` is kept exactly as the BE
   * wrote it, because it is scoped to its own component — a button-URL token is
   * `{{1}}` even when its template-wide index is 2. Only when the BE gives us
   * nothing do we fall back to deriving the token from the index.
   */
  private makeTemplatePlaceholder(raw: any, fallbackIndex: number): TemplatePlaceholder {
    const item = raw && typeof raw === 'object' ? raw : {};
    const index = Math.floor(Number(item.index != null ? item.index : fallbackIndex));
    const token = String(item.placeholder || '').trim() || '{{' + index + '}}';
    return {
      index: index,
      component_index: this.resolveComponentIndex(item.component_index, token),
      button_index: this.normalizeButtonIndex(item.button_index),
      source: String(item.source || '').trim().toLowerCase(),
      placeholder: token,
      button_text: String(item.button_text || '').trim()
    };
  }

  /**
   * Fallback placeholder detection, used when serriTemplatePlaceholders hasn't
   * answered (or the provider isn't Serri). Prefers provider-supplied variable
   * metadata on the template row, else scans the body text for {{n}} tokens.
   */
  private extractTemplatePlaceholders(template: any): TemplatePlaceholder[] {
    if (!template) {
      return [];
    }

    const out: TemplatePlaceholder[] = [];
    const push = (raw: any, fallbackIndex: number) => {
      const ph = this.makeTemplatePlaceholder(raw, fallbackIndex);
      if (ph.index > 0 && !out.some(p => p.index === ph.index)) {
        out.push(ph);
      }
    };

    const meta = Array.isArray(template.variables)
      ? template.variables
      : Array.isArray(template.template_variables)
        ? template.template_variables
        : Array.isArray(template.body_variables)
          ? template.body_variables
          : null;
    if (meta) {
      for (let i = 0; i < meta.length; i++) {
        push(meta[i], i + 1);
      }
      out.sort((a, b) => a.index - b.index);
      return out;
    }

    const body = this.getTemplatePreviewBody(template);
    if (!body) {
      return [];
    }
    const re = /{{\s*(\d+)\s*}}/g;
    let match = re.exec(body);
    while (match) {
      push({ index: match[1], source: 'body', placeholder: match[0] }, 0);
      match = re.exec(body);
    }
    out.sort((a, b) => a.index - b.index);
    return out;
  }

  /**
   * Normalize a serriTemplatePlaceholders response into placeholder descriptors.
   * Accepts either an explicit list or a plain count, wrapped or unwrapped.
   */
  private parseSerriTemplatePlaceholders(response: any): TemplatePlaceholder[] {
    const payload = response && response.data != null ? response.data : response;
    if (payload == null) {
      return [];
    }

    const out: TemplatePlaceholder[] = [];
    const push = (raw: any, fallbackIndex: number) => {
      const ph = this.makeTemplatePlaceholder(raw, fallbackIndex);
      if (ph.index > 0 && !out.some(p => p.index === ph.index)) {
        out.push(ph);
      }
    };
    const pushCount = (c: any) => {
      const total = Math.floor(Number(c));
      for (let i = 1; i <= total; i++) {
        push({ index: i, source: 'body' }, i);
      }
    };
    const pushList = (list: any[]) => {
      for (let i = 0; i < list.length; i++) {
        push(list[i], i + 1);
      }
    };

    if (typeof payload === 'number') {
      pushCount(payload);
    } else if (Array.isArray(payload)) {
      pushList(payload);
    } else if (typeof payload === 'object') {
      const list = Array.isArray(payload.placeholders)
        ? payload.placeholders
        : Array.isArray(payload.variables)
          ? payload.variables
          : Array.isArray(payload.template_variables)
            ? payload.template_variables
            : null;
      if (list) {
        pushList(list);
      } else {
        const count = payload.placeholders != null
          ? payload.placeholders
          : payload.placeholder_count != null
            ? payload.placeholder_count
            : payload.variable_count != null
              ? payload.variable_count
              : payload.count != null
                ? payload.count
                : payload.total;
        if (count != null) {
          pushCount(count);
        }
      }
    }

    out.sort((a, b) => a.index - b.index);
    return out;
  }

  /**
   * Ask the BE how many placeholders the selected Serri template needs.
   * Cached per template_id; failures fall back to scanning the body text.
   */
  private ensureSerriTemplatePlaceholders(targetForm: FormGroup, templatesParentForm: FormGroup): void {
    const provider = String(this.getWhatsAppProviderTypeForAction() || '').toLowerCase();
    if (provider !== 'serri') {
      return;
    }
    const templateIdCtrl = targetForm.get('template_id');
    const templateId = templateIdCtrl ? String(templateIdCtrl.value || '').trim() : '';
    if (!templateId) {
      return;
    }
    if (this.serriPlaceholderCache[templateId] || this.serriPlaceholderInFlight[templateId]) {
      return;
    }
    const entityId = this.profile && this.profile.entity && this.profile.entity.id
      ? this.profile.entity.id
      : '';
    if (!entityId) {
      return;
    }

    this.serriPlaceholderInFlight[templateId] = true;

    const params = new URLSearchParams({ entity_id: entityId, template_id: templateId });
    const templateName = targetForm.get('template_name') ? targetForm.get('template_name').value : '';
    if (templateName) {
      params.append('template_name', String(templateName));
    }
    const phone = this.resolveSerriWhatsappPhoneFromProject();
    if (phone) {
      params.append('whatsapp_phone_number', phone);
    }

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    this.http.get(`${API_SERRI_TEMPLATE_PLACEHOLDERS}?${params.toString()}`, { headers }).subscribe({
      next: (response: any) => {
        this.serriPlaceholderInFlight[templateId] = false;
        this.serriPlaceholderCache[templateId] = this.parseSerriTemplatePlaceholders(response);
        // Re-run now that the authoritative count is known.
        this.syncTemplateVariablesForTarget(targetForm, templatesParentForm);
        this.cdr.markForCheck();
      },
      error: (err: any) => {
        this.serriPlaceholderInFlight[templateId] = false;
        console.error('Error loading Serri template placeholders:', err);
      }
    });
  }

  /**
   * Rebuild a target form's template_variables to match the selected template,
   * keeping any mapping the user already made for the same placeholder index.
   * No-ops while the template is still unresolved so saved values survive.
   */
  private syncTemplateVariablesForTarget(targetForm: FormGroup, templatesParentForm: FormGroup): void {
    if (!targetForm || !targetForm.get('template_variables')) {
      return;
    }
    const arr = targetForm.get('template_variables') as FormArray;
    const name = targetForm.get('template_name') ? targetForm.get('template_name').value : '';
    if (!name) {
      arr['_variableMemory'] = null;
      arr.clear();
      arr.updateValueAndValidity({ emitEvent: false });
      return;
    }

    this.ensureSerriTemplatePlaceholders(targetForm, templatesParentForm);

    const templateIdCtrl = targetForm.get('template_id');
    const templateId = templateIdCtrl ? String(templateIdCtrl.value || '').trim() : '';
    // An empty cached list means the response was unusable — treat it as no answer
    // rather than letting it wipe every row.
    const cachedList = templateId ? this.serriPlaceholderCache[templateId] : null;
    const cached = cachedList && cachedList.length ? cachedList : null;

    // The body-text scan can't see button placeholders, so rebuilding from it while
    // the authoritative list is still on the wire would drop the button row (and the
    // mapping saved against it). Wait for the answer instead.
    if (!cached && templateId && this.serriPlaceholderInFlight[templateId]) {
      return;
    }

    const template = this.findTemplateByName(templatesParentForm, name);
    if (!cached && !template) {
      return;
    }

    // Mappings survive a rebuild that temporarily drops their row: rows present now
    // win, and anything only in memory (e.g. the button row the body scan can't see)
    // is restored once the placeholder list arrives.
    const previous: any = Object.assign({}, this.getTemplateVariableMemory(arr));
    for (let i = 0; i < arr.length; i++) {
      const g = arr.at(i) as FormGroup;
      previous[String(g.get('index').value)] = g.value;
    }
    arr['_variableMemory'] = previous;

    // BE placeholder list wins; body-text scan is the fallback.
    const placeholders = cached ? cached : this.extractTemplatePlaceholders(template);
    arr.clear();
    for (let i = 0; i < placeholders.length; i++) {
      const ph = placeholders[i];
      const prev = previous[String(ph.index)] || {};
      arr.push(this.buildTemplateVariableGroup({
        index: ph.index,
        component_index: ph.component_index,
        button_index: ph.button_index,
        source: ph.source,
        placeholder: ph.placeholder,
        button_text: ph.button_text,
        dynamic_field: prev.dynamic_field || '',
        fallback_value: prev.fallback_value || ''
      }));
    }
    arr.updateValueAndValidity({ emitEvent: false });
  }

  /** Mappings seen on this FormArray before, keyed by placeholder index. */
  private getTemplateVariableMemory(arr: FormArray): any {
    return arr && arr['_variableMemory'] ? arr['_variableMemory'] : {};
  }

  /** Sync the call action and every follow-up step that borrows its template list. */
  private syncTemplateVariablesForAction(actionForm: FormGroup): void {
    if (!actionForm) {
      return;
    }
    this.syncTemplateVariablesForTarget(actionForm, actionForm);
    const steps = this.getFollowUpActionsSteps(actionForm);
    if (!steps) {
      return;
    }
    for (let i = 0; i < steps.length; i++) {
      this.syncTemplateVariablesForTarget(steps.at(i) as FormGroup, actionForm);
    }
  }

  private clearTemplateVariables(targetForm: FormGroup): void {
    if (!targetForm || !targetForm.get('template_variables')) {
      return;
    }
    const arr = targetForm.get('template_variables') as FormArray;
    arr['_variableMemory'] = null;
    arr.clear();
    arr.updateValueAndValidity({ emitEvent: false });
  }

  getTemplateVariableControls(targetForm: FormGroup): any[] {
    if (!targetForm || !targetForm.get('template_variables')) {
      return [];
    }
    return (targetForm.get('template_variables') as FormArray).controls;
  }

  hasTemplateVariables(targetForm: FormGroup): boolean {
    return this.getTemplateVariableControls(targetForm).length > 0;
  }

  /** The token exactly as it appears inside its own component, e.g. `{{1}}`. */
  getTemplateVariableLabel(varCtrl: any): string {
    const token = varCtrl && varCtrl.get('placeholder')
      ? String(varCtrl.get('placeholder').value || '').trim()
      : '';
    if (token) {
      return token;
    }
    const idx = varCtrl && varCtrl.get('index') ? varCtrl.get('index').value : '';
    return '{{' + idx + '}}';
  }

  /**
   * Where the token lives. Body and button-URL placeholders are both written
   * `{{1}}`, so this is what tells the two rows apart.
   */
  getTemplateVariableSourceLabel(varCtrl: any): string {
    const source = varCtrl && varCtrl.get('source')
      ? String(varCtrl.get('source').value || '').trim().toLowerCase()
      : '';
    const buttonText = varCtrl && varCtrl.get('button_text')
      ? String(varCtrl.get('button_text').value || '').trim()
      : '';
    let label: string;
    if (source === 'button_url' || source === 'button') {
      label = 'Button URL';
    } else if (source === 'header') {
      label = 'Header';
    } else if (source === 'body') {
      label = 'Body';
    } else if (source) {
      label = source.replace(/_/g, ' ');
    } else {
      label = 'Body';
    }
    return buttonText ? label + ' · ' + buttonText : label;
  }

  /** Template-wide position the BE maps the value by — unique across sources. */
  getTemplateVariableIndexLabel(varCtrl: any): string {
    const idx = varCtrl && varCtrl.get('index') ? varCtrl.get('index').value : '';
    return idx ? 'Variable ' + idx : '';
  }

  /** Advisory only — an unmapped variable shows a hint but still saves. */
  hasUnmappedTemplateVariables(targetForm: FormGroup): boolean {
    const controls = this.getTemplateVariableControls(targetForm);
    for (let i = 0; i < controls.length; i++) {
      const ctrl = controls[i].get('dynamic_field');
      if (ctrl && !ctrl.value) {
        return true;
      }
    }
    return false;
  }

  /**
   * Strip empty rows and coerce types before sending to the BE. Rows keep the
   * order the API returned them in, and `index` stays the flattened 1..N ordering
   * key so configs saved before this still resolve. `source` + `component_index`
   * are added on top — they are what separates body {{1}} from button-URL {{1}} —
   * and are omitted when unknown so those older rows fall back to the index path.
   */
  private serializeTemplateVariables(list: any): any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    const out: any[] = [];
    for (let i = 0; i < list.length; i++) {
      const v = list[i] || {};
      const field = String(v.dynamic_field || '').trim();
      if (!field) {
        continue;
      }
      const entry: any = {
        index: Math.max(1, Math.floor(Number(v.index)) || (i + 1)),
        dynamic_field: field,
        fallback_value: v.fallback_value != null ? String(v.fallback_value) : ''
      };
      const source = String(v.source || '').trim();
      if (source) {
        entry.source = source;
      }
      const componentIndex = this.resolveComponentIndex(v.component_index, v.placeholder);
      if (componentIndex > 0) {
        entry.component_index = componentIndex;
      }
      const buttonIndex = this.normalizeButtonIndex(v.button_index);
      if (buttonIndex !== null) {
        entry.button_index = buttonIndex;
      }
      out.push(entry);
    }
    return out;
  }

  private getWhatsAppProviderTypeForAction(): string {
    return this.whatsappProviderType ||
      (this.selectedProject && this.selectedProject.whatsapp_provider_type) ||
      '';
  }

  isWhatsAppFreeFlowEnabled(actionForm: FormGroup): boolean {
    if (!actionForm || !actionForm.get('send_message_via_free_flow')) {
      return true;
    }
    return actionForm.get('send_message_via_free_flow').value !== false;
  }

  shouldShowWhatsAppTemplateSelector(actionForm: FormGroup): boolean {
    return !!(actionForm && !this.isWhatsAppFreeFlowEnabled(actionForm));
  }

  isFollowUpStepFreeFlowEnabled(stepCtrl: FormGroup): boolean {
    if (!stepCtrl || !stepCtrl.get('send_message_via_free_flow')) {
      return true;
    }
    return stepCtrl.get('send_message_via_free_flow').value !== false;
  }

  shouldShowFollowUpStepTemplateSelector(callAction: FormGroup, stepCtrl: FormGroup): boolean {
    return !!(stepCtrl && !this.isFollowUpStepFreeFlowEnabled(stepCtrl));
  }

  onFollowUpStepFreeFlowChange(callAction: FormGroup, stepCtrl: FormGroup): void {
    if (this.isFollowUpStepFreeFlowEnabled(stepCtrl)) {
      stepCtrl.get('template_name').setValue('', { emitEvent: false });
      stepCtrl.get('template_id').setValue('', { emitEvent: false });
      this.clearTemplateVariables(stepCtrl);
    } else {
      this.ensureWhatsAppTemplatesLoaded(callAction);
    }
    const fu = callAction.get('follow_up_actions') as FormGroup;
    this.applyFollowUpActionStepValidators(stepCtrl, fu.get('enabled').value === true);
  }

  onFollowUpStepTemplateSelected(callAction: FormGroup, stepCtrl: FormGroup, templateName: string): void {
    const id = this.getTemplateIdForSelectedName(callAction, templateName);
    stepCtrl.get('template_id').setValue(id, { emitEvent: false });
    this.syncTemplateVariablesForTarget(stepCtrl, callAction);
  }

  private syncWhatsAppActionValidators(actionForm: FormGroup): void {
    if (!actionForm) {
      return;
    }

    const providerType = this.getWhatsAppProviderTypeForAction();
    const freeFlow = this.isWhatsAppFreeFlowEnabled(actionForm);

    actionForm.get('whatsapp_message').clearValidators();
    actionForm.get('whatsapp_prompt').clearValidators();
    actionForm.get('template_name').clearValidators();

    if (!freeFlow) {
      if (providerType === 'meta_api' || providerType === 'interakt' || providerType === 'serri') {
        actionForm.get('template_name').setValidators([Validators.required]);
      }
    }

    actionForm.get('whatsapp_message').updateValueAndValidity({ emitEvent: false });
    actionForm.get('whatsapp_prompt').updateValueAndValidity({ emitEvent: false });
    actionForm.get('template_name').updateValueAndValidity({ emitEvent: false });
  }

  private ensureWhatsAppTemplatesLoaded(actionForm: FormGroup): void {
    const entityId = this.profile && this.profile.entity && this.profile.entity.id
      ? this.profile.entity.id
      : null;
    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls
      && this.agentConfigurationForm.controls['id']
      ? this.agentConfigurationForm.controls['id'].value
      : null;

    if (!entityId || !projectId) {
      return;
    }

    const providerType = this.getWhatsAppProviderTypeForAction();
    if (providerType) {
      if (providerType === 'serri') {
        const whatsappPhoneNumber = this.selectedProject && this.selectedProject.whatsapp_phone_number
          ? this.selectedProject.whatsapp_phone_number
          : '';
        if (whatsappPhoneNumber) {
          this.loadSerriTemplates(entityId, whatsappPhoneNumber, actionForm);
        }
      } else if (providerType === 'meta_api') {
        this.loadMetaTemplates(entityId, actionForm);
      } else if (providerType === 'interakt') {
        this.loadInteraktTemplates(entityId, projectId, actionForm);
      }
      return;
    }

    this.checkWhatsAppProviderAndLoadTemplates(actionForm);
  }

  private bindWhatsAppFreeFlowHandlers(actionForm: FormGroup): void {
    if (actionForm['_freeFlowSubscription']) {
      return;
    }

    actionForm['_freeFlowSubscription'] = actionForm.get('send_message_via_free_flow').valueChanges.subscribe((enabled: boolean) => {
      if (enabled !== false) {
        actionForm.get('template_name').setValue('', { emitEvent: false });
        actionForm.get('template_id').setValue('', { emitEvent: false });
      } else {
        this.ensureWhatsAppTemplatesLoaded(actionForm);
      }
      this.syncWhatsAppActionValidators(actionForm);
    });
  }

  // ---------------------------------------------------------------------------
  // Generic follow-up actions (follow_up_actions) — multi-step chain that can
  // mix step types (whatsapp / call again / email / schedule meeting).
  // ---------------------------------------------------------------------------

  /** Parse a "<amount> <unit>" delay string (e.g. "24 h") into amount + unit. */
  private parseDelayString(
    value: any,
    defaultAmount = 24,
    defaultUnit = 'h'
  ): { amount: number; unit: string } {
    if (value != null && typeof value === 'string') {
      const m = value.trim().match(/^(\d+)\s*([mhd])$/i);
      if (m) {
        const amt = parseInt(m[1], 10);
        const u = m[2].toLowerCase();
        if (!isNaN(amt) && amt >= 1 && (u === 'm' || u === 'h' || u === 'd')) {
          return { amount: amt, unit: u };
        }
      }
    }
    return { amount: defaultAmount, unit: defaultUnit };
  }

  /** Convert an ISO datetime to the value an <input type="datetime-local"> expects. */
  private isoToDatetimeLocal(value: any): string {
    if (!value || typeof value !== 'string') {
      return '';
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return '';
    }
    const pad = (n: number) => String(n).padStart(2, '0');
    return (
      d.getFullYear() +
      '-' + pad(d.getMonth() + 1) +
      '-' + pad(d.getDate()) +
      'T' + pad(d.getHours()) +
      ':' + pad(d.getMinutes())
    );
  }

  private buildFollowUpActionStepGroup(step: any = {}): FormGroup {
    const s = step && typeof step === 'object' ? step : {};
    const type = String(s.follow_up_type || 'send whatsapp message').toLowerCase();
    const delay = this.parseDelayString(s.delay, 24, 'h');
    return this._formBuilder.group({
      follow_up_type: [type, [Validators.required]],
      delay_amount: [delay.amount, [Validators.required, Validators.min(1)]],
      delay_unit: [delay.unit, [Validators.required]],
      send_message_via_free_flow: [this.resolveSendMessageViaFreeFlow(s)],
      template_name: [s.template_name || ''],
      template_id: [s.template_id != null ? String(s.template_id) : ''],
      template_variables: this.buildTemplateVariablesArray(s.template_variables),
      // send email
      email_subject: [s.email_subject || ''],
      email_content: [s.email_content || ''],
      // schedule meeting
      task_datetime: [this.isoToDatetimeLocal(s.task_datetime)],
      gmeet_title: [s.gmeet_title || ''],
      refresh_token: [s.refresh_token || ''],
      calendarIntegrated: [!!s.refresh_token]
    });
  }

  private buildFollowUpActionsGroup(fu: any): FormGroup {
    const fuData = fu && typeof fu === 'object' ? fu : {};
    const enabled = fuData.enabled === true;
    let rawSteps = Array.isArray(fuData.steps) ? fuData.steps : [];
    if (enabled && rawSteps.length === 0) {
      rawSteps = [{ follow_up_type: 'send whatsapp message', delay: '24 h' }];
    }
    const stepsArray = this._formBuilder.array(
      rawSteps.map((s: any) => {
        const stepFg = this.buildFollowUpActionStepGroup(s);
        return stepFg;
      })
    );
    const group = this._formBuilder.group({
      enabled: [enabled],
      steps: stepsArray
    });
    // Apply per-type validators to any pre-built steps.
    for (let i = 0; i < stepsArray.length; i++) {
      const stepFg = stepsArray.at(i) as FormGroup;
      this.applyFollowUpActionStepValidators(stepFg, enabled);
    }
    return group;
  }

  private bindFollowUpStepsHandlers(callActionForm: FormGroup): void {
    const steps = this.getFollowUpActionsSteps(callActionForm);
    if (!steps) {
      return;
    }
    for (let i = 0; i < steps.length; i++) {
      const stepFg = steps.at(i) as FormGroup;
      if (String(stepFg.get('follow_up_type').value || '').toLowerCase() === 'send whatsapp message') {
        this.bindFollowUpStepFreeFlowHandlers(stepFg, callActionForm);
      }
    }
  }

  getFollowUpActionsSteps(callActionForm: FormGroup): FormArray {
    const fu = callActionForm.get('follow_up_actions') as FormGroup;
    return fu ? (fu.get('steps') as FormArray) : null;
  }

  getFollowUpActionStepControls(callActionForm: FormGroup): any[] {
    const arr = this.getFollowUpActionsSteps(callActionForm);
    return arr && arr.controls ? arr.controls : [];
  }

  getFollowUpActionStepCount(callActionForm: FormGroup): number {
    const arr = this.getFollowUpActionsSteps(callActionForm);
    return arr ? arr.length : 0;
  }

  getFollowUpActionStepLabel(index: number): string {
    return 'Step ' + (index + 1);
  }

  addFollowUpActionStep(callActionForm: FormGroup): void {
    const fu = callActionForm.get('follow_up_actions') as FormGroup;
    const steps = fu.get('steps') as FormArray;
    const stepFg = this.buildFollowUpActionStepGroup({
      follow_up_type: 'send whatsapp message',
      delay: '24 h'
    });
    steps.push(stepFg);
    this.bindFollowUpStepFreeFlowHandlers(stepFg, callActionForm);
    this.applyFollowUpActionStepValidators(stepFg, fu.get('enabled').value === true);
  }

  removeFollowUpActionStep(callActionForm: FormGroup, stepIndex: number): void {
    const fu = callActionForm.get('follow_up_actions') as FormGroup;
    const steps = fu.get('steps') as FormArray;
    if (steps.length <= 1) {
      return;
    }
    steps.removeAt(stepIndex);
  }

  /** Toggle the whole follow_up_actions chain on/off. */
  onFollowUpActionsToggle(callActionForm: FormGroup): void {
    const fu = callActionForm.get('follow_up_actions') as FormGroup;
    const enabled = fu.get('enabled').value === true;
    const steps = fu.get('steps') as FormArray;
    if (enabled && steps.length === 0) {
      this.addFollowUpActionStep(callActionForm);
      return;
    }
    for (let i = 0; i < steps.length; i++) {
      const stepFg = steps.at(i) as FormGroup;
      if (enabled && String(stepFg.get('follow_up_type').value || '').toLowerCase() === 'send whatsapp message') {
        this.bindFollowUpStepFreeFlowHandlers(stepFg, callActionForm);
        if (!this.isFollowUpStepFreeFlowEnabled(stepFg)) {
          this.ensureWhatsAppTemplatesLoaded(callActionForm);
        }
      }
      this.applyFollowUpActionStepValidators(stepFg, enabled);
    }
  }

  /** Re-apply validators for a step when its type changes. */
  onFollowUpActionTypeChange(callActionForm: FormGroup, stepCtrl: FormGroup): void {
    const fu = callActionForm.get('follow_up_actions') as FormGroup;
    const enabled = fu.get('enabled').value === true;
    if (String(stepCtrl.get('follow_up_type').value || '').toLowerCase() === 'send whatsapp message') {
      this.bindFollowUpStepFreeFlowHandlers(stepCtrl, callActionForm);
      if (!this.isFollowUpStepFreeFlowEnabled(stepCtrl)) {
        this.ensureWhatsAppTemplatesLoaded(callActionForm);
      }
    }
    this.applyFollowUpActionStepValidators(stepCtrl, enabled);
  }

  private bindFollowUpStepFreeFlowHandlers(stepCtrl: FormGroup, callActionForm: FormGroup): void {
    if (stepCtrl['_freeFlowSubscription']) {
      return;
    }
    stepCtrl['_freeFlowSubscription'] = stepCtrl.get('send_message_via_free_flow').valueChanges.subscribe(() => {
      this.onFollowUpStepFreeFlowChange(callActionForm, stepCtrl);
    });
  }

  private applyFollowUpActionStepValidators(stepFg: FormGroup, enabled: boolean): void {
    const type = String(stepFg.get('follow_up_type').value || '').toLowerCase();
    const fields = ['template_name', 'email_subject', 'email_content', 'task_datetime', 'gmeet_title'];
    // Clear everything first, then set what the active type requires.
    fields.forEach((name) => {
      const c = stepFg.get(name);
      if (c) {
        c.clearValidators();
      }
    });
    const da = stepFg.get('delay_amount');
    const du = stepFg.get('delay_unit');
    if (enabled) {
      da.setValidators([Validators.required, Validators.min(1)]);
      du.setValidators([Validators.required]);
      if (type === 'send whatsapp message') {
        if (!this.isFollowUpStepFreeFlowEnabled(stepFg) && this.shouldShowTemplateSelector()) {
          stepFg.get('template_name').setValidators([Validators.required]);
        }
      } else if (type === 'send email') {
        stepFg.get('email_subject').setValidators([Validators.required]);
        stepFg.get('email_content').setValidators([Validators.required]);
      } else if (type === 'schedule meeting') {
        stepFg.get('task_datetime').setValidators([Validators.required]);
        stepFg.get('gmeet_title').setValidators([Validators.required]);
      }
    } else {
      da.clearValidators();
      du.clearValidators();
    }
    [da, du, ...fields.map((n) => stepFg.get(n))].forEach((c) => {
      if (c) {
        c.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  /** Link a Google calendar for a "schedule meeting" follow-up step. */
  async handleFollowUpStepCalendarLink(stepCtrl: FormGroup): Promise<void> {
    try {
      this.isLoading = true;
      const userTokens = await this.fetchUserTokens(this.profile.user.id);
      if (userTokens.length > 0) {
        this.existingAccounts = userTokens;
        const dialogRef = this.dialog.open(GoogleAccountPopupComponent, {
          panelClass: 'add-edit-staff-dialog',
          disableClose: true,
          autoFocus: true,
          width: '400px',
          data: {
            existingAccounts: this.existingAccounts,
            projectId: this.agentConfigurationForm.controls['id'].value
          }
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result && typeof result === 'object') {
            this.applyFollowUpStepExistingAccount(stepCtrl, result);
          } else if (result) {
            this.linkFollowUpStepWithNewAccount(stepCtrl);
          } else {
            this.isLoading = false;
          }
        });
        this.isLoading = false;
      } else {
        await this.linkFollowUpStepWithNewAccount(stepCtrl);
      }
    } catch (error) {
      console.error('Error handling follow-up calendar link:', error);
      this.isLoading = false;
      this.notify.showMessage('Error checking existing accounts!', 2000);
    }
  }

  private async linkFollowUpStepWithNewAccount(stepCtrl: FormGroup): Promise<void> {
    const authInstance = gapi.auth2.getAuthInstance();
    try {
      const response = await authInstance.grantOfflineAccess({ prompt: 'consent' });
      const event = await this.http.post<{ idToken: string; refreshToken: string; email: string }>(
        API_AUTH + '/v1/google/exchange-token',
        { code: response.code, allowFreeDomain: true }
      ).toPromise();

      if (event && event.refreshToken) {
        this.saveRefreshToken(this.profile.user.id, event.email, event.refreshToken);
        stepCtrl.patchValue({ calendarIntegrated: true, refresh_token: event.refreshToken });
        this.cdr.detectChanges();

        await this.jobService.updateProject({
          entityId: this.profile.entity.id,
          userId: this.profile.user.id,
          userName: this.profile.user.userMeta.name,
          projectId: this.agentConfigurationForm.controls['id'].value,
          googleCalendarToken: event.refreshToken
        }).toPromise();

        this.isLoading = false;
        this.notify.showMessage('Google account linked successfully!', 2000);
      } else {
        throw new Error('Refresh token not received');
      }
    } catch (error) {
      console.error('Error:', error);
      this.isLoading = false;
      this.notify.showMessage('Error while linking calendar!', 2000);
    }
  }

  private async applyFollowUpStepExistingAccount(stepCtrl: FormGroup, account: UserToken): Promise<void> {
    try {
      this.isLoading = true;
      await this.jobService.updateProject({
        entityId: this.profile.entity.id,
        userId: this.profile.user.id,
        userName: this.profile.user.userMeta.name,
        projectId: this.agentConfigurationForm.controls['id'].value,
        googleCalendarToken: account.googleRefreshToken
      }).toPromise();
      stepCtrl.patchValue({ calendarIntegrated: true, refresh_token: account.googleRefreshToken });
      this.isLoading = false;
      this.notify.showMessage('Google account linked successfully!', 2000);
    } catch (error) {
      console.error('Error linking existing account:', error);
      this.isLoading = false;
      this.notify.showMessage('Error while linking calendar!', 2000);
    }
  }

  /** Serialize a follow_up_actions form value into the BE contract shape. */
  private serializeFollowUpActions(fu: any): { enabled: boolean; steps: any[] } {
    if (!fu || fu.enabled !== true || !Array.isArray(fu.steps)) {
      return { enabled: false, steps: [] };
    }
    const steps = fu.steps.map((st: any) => {
      const type = String(st.follow_up_type || '').toLowerCase();
      const amount = Math.max(1, Math.floor(Number(st.delay_amount)) || 1);
      let unit = String(st.delay_unit || 'h').toLowerCase();
      if (unit !== 'm' && unit !== 'h' && unit !== 'd') {
        unit = 'h';
      }
      const out: any = {
        follow_up_type: type,
        delay: amount + ' ' + unit
      };
      if (type === 'send whatsapp message') {
        out.send_message_via_free_flow = st.send_message_via_free_flow !== false;
        if (out.send_message_via_free_flow) {
          delete out.template_name;
          delete out.template_id;
        } else {
          out.template_name = st.template_name || '';
          out.template_id = st.template_id != null ? String(st.template_id).trim() : '';
          out.template_variables = this.serializeTemplateVariables(st.template_variables);
        }
      } else if (type === 'call again') {
        // No extra payload — `delay` ("Run this step after") fully defines when the
        // call fires. The previous `call_delay` retry field was redundant and removed.
      } else if (type === 'send email') {
        out.email_subject = st.email_subject || '';
        out.email_content = st.email_content || '';
      } else if (type === 'schedule meeting') {
        out.task_datetime = st.task_datetime
          ? new Date(st.task_datetime).toISOString()
          : '';
        out.gmeet_title = st.gmeet_title || '';
        out.refresh_token = st.refresh_token || '';
      }
      return out;
    });
    return { enabled: true, steps };
  }

  sanitizeExpectedOutcomesForSave(outcomes: any[]): any[] {
    if (!Array.isArray(outcomes)) {
      return outcomes;
    }
    return outcomes.map((outcome) => {
      const callActions = (outcome.callActions || []).map((a: any) => {
        const next: any = Object.assign({}, a);
        // Generic follow-up chain — available on every call action.
        next.follow_up_actions = this.serializeFollowUpActions(next.follow_up_actions);
        delete next.follow_up_whatsapp;
        const isWa = this.normalizeCallActionValue(next.call_action) === 'Send WhatsApp Message';
        const isCallAgain = this.normalizeCallActionValue(next.call_action) === 'Call again';
        if (isCallAgain) {
          const amount = Math.max(1, Math.floor(Number(next.delay_amount)) || 1);
          let unit = String(next.delay_unit || 'h').toLowerCase();
          if (unit !== 'm' && unit !== 'h' && unit !== 'd') {
            unit = 'h';
          }
          next.delay = amount + ' ' + unit;
          delete next.delay_amount;
          delete next.delay_unit;
        }
        if (!isWa) {
          delete next.send_message_via_free_flow;
          delete next.template_variables;
          return next;
        }
        next.send_message_via_free_flow = a.send_message_via_free_flow !== false;
        if (next.send_message_via_free_flow) {
          delete next.template_name;
          delete next.template_id;
          delete next.template_variables;
        } else {
          delete next.whatsapp_message;
          delete next.whatsapp_prompt;
          delete next.image_url;
          delete next.use_ai_generated;
          next.template_id = (next.template_id != null ? String(next.template_id) : '').trim();
          next.template_variables = this.serializeTemplateVariables(a.template_variables);
        }
        return next;
      });
      // "Add in other project" — only carry the project URL / auto-call flag when it's enabled.
      const addInOtherProject = outcome.add_in_other_project === true;
      const webhookPayload = this.sanitizeWebhookForSave(outcome);
      const next: any = Object.assign({}, outcome, {
        callActions: callActions,
        add_in_other_project: addInOtherProject,
        do_not_consider_for_analysis: outcome.do_not_consider_for_analysis === true,
        project_url: addInOtherProject ? String(outcome.project_url || '').trim() : '',
        automatic_call: addInOtherProject ? outcome.automatic_call === true : false,
        assign_users: this.normalizeAssignUsers(outcome.assign_users),
        notify_via_webhook: webhookPayload.notify_via_webhook,
        webhook: webhookPayload.webhook
      });
      // UI-only helper — do not persist with expected outcomes.
      delete next.webhook_same_as_previous;
      return next;
    });
  }

  /** Parse main Call again delay from saved payload or legacy numeric hours. */
  private parseCallAgainDelay(action: any): { amount: number; unit: string } {
    if (action && action.delay_amount != null && action.delay_unit) {
      return {
        amount: Math.max(1, Math.floor(Number(action.delay_amount)) || 1),
        unit: String(action.delay_unit || 'h').toLowerCase()
      };
    }
    if (action && action.delay != null && action.delay !== '') {
      const raw = String(action.delay).trim();
      if (/^\d+$/.test(raw)) {
        return { amount: Math.max(1, parseInt(raw, 10)), unit: 'h' };
      }
      return this.parseDelayString(action.delay, 24, 'h');
    }
    return { amount: 24, unit: 'h' };
  }

  private syncCallAgainDelayValidators(actionForm: FormGroup, enabled: boolean): void {
    if (!actionForm) {
      return;
    }
    const amount = actionForm.get('delay_amount');
    const unit = actionForm.get('delay_unit');
    const delay = actionForm.get('delay');
    if (!amount || !unit || !delay) {
      return;
    }
    if (enabled) {
      amount.setValidators([Validators.required, Validators.min(1)]);
      unit.setValidators([Validators.required]);
      delay.clearValidators();
    } else {
      amount.clearValidators();
      unit.clearValidators();
      delay.clearValidators();
    }
    amount.updateValueAndValidity({ emitEvent: false });
    unit.updateValueAndValidity({ emitEvent: false });
    delay.updateValueAndValidity({ emitEvent: false });
  }

  getActionsArray(action: any = {}) {
    const callAgainDelay = this.parseCallAgainDelay(action);
    let f = this._formBuilder.group({
      call_action: [this.normalizeCallActionValue(action.call_action) || '', [Validators.required]], // Set default values from action
      from_email: [action.from_email || ''],
      calendarIntegrated: [action.calendarIntegrated || false],
      email_subject: [action.email_subject || ''],
      email_content: [action.email_content || ''],
      refresh_token: [action.refresh_token || ''],
      delay: [action.delay || null],
      delay_amount: [callAgainDelay.amount],
      delay_unit: [callAgainDelay.unit],
      whatsapp_message: [action.whatsapp_message || ''],
      send_message_via_free_flow: [this.resolveSendMessageViaFreeFlow(action)],
      use_ai_generated: [action.use_ai_generated || false],
      whatsapp_prompt: [action.whatsapp_prompt || ''],
      template_name: [action.template_name || ''], // Template name for WhatsApp templates
      template_id: [
        action.template_id != null && action.template_id !== '' ? String(action.template_id) : '',
        []
      ],
      // Placeholder → lead-field mapping for the selected WhatsApp template
      template_variables: this.buildTemplateVariablesArray(action.template_variables),
      image_url: [action.image_url || ''], // Image URL for WhatsApp message attachment
      follow_up_actions: this.buildFollowUpActionsGroup(action.follow_up_actions),
      // when_to_trigger: [''],
      // add_link_to_calendar: [''],
      // days: this._formBuilder.array(this.getDaysArray()), // Days as FormArray
      // slots: this._formBuilder.array([]), // Slots as FormArray  
      // appointment_time: [''],
      // allow_booking_on_same_day_as_call: [''],
      // receive_booking_appointment_notifications_via_email: [''],
      // phone_number: [''],
      // sms_content: [''],
      // emails_list: ['']
    });

    // Watch for changes in call_action field
    f.get('call_action').valueChanges.subscribe((value) => {
      if (value === 'Send Email') {
        f.get('from_email').setValidators([Validators.required]);
        f.get('email_subject').setValidators([Validators.required]);
        f.get('email_content').setValidators([Validators.required]);
        f.get('refresh_token').setValidators([Validators.required]);
        f.get('calendarIntegrated').clearValidators(); // Remove required from calendarIntegrated
        f.get('delay').clearValidators();
        f.get('whatsapp_message').clearValidators();
        this.syncCallAgainDelayValidators(f, false);
      } else if (value === 'Schedule Meeting') {
        f.get('calendarIntegrated').setValidators([Validators.required]);
        f.get('refresh_token').setValidators([Validators.required]);
        f.get('from_email').setValidators([Validators.required]);
        f.get('email_subject').clearValidators(); // Remove required from email fields
        f.get('email_content').clearValidators();
        f.get('delay').clearValidators();
        f.get('whatsapp_message').clearValidators();
        this.syncCallAgainDelayValidators(f, false);
      } else if (value === 'Call again') {
        this.syncCallAgainDelayValidators(f, true);
        f.get('from_email').clearValidators();
        f.get('refresh_token').clearValidators();
        f.get('calendarIntegrated').clearValidators();
        f.get('email_subject').clearValidators(); // Remove required from email fields
        f.get('email_content').clearValidators();
        f.get('whatsapp_message').clearValidators();
      } else if (value === 'Send WhatsApp Message') {
        const currentProviderType = this.getWhatsAppProviderTypeForAction();

        f.get('from_email').clearValidators();
        f.get('email_subject').clearValidators();
        f.get('email_content').clearValidators();
        f.get('refresh_token').clearValidators();
        f.get('calendarIntegrated').clearValidators();
        f.get('delay').clearValidators();
        this.syncCallAgainDelayValidators(f, false);

        this.syncWhatsAppActionValidators(f);
        this.bindWhatsAppFreeFlowHandlers(f);

        if (currentProviderType) {
          this.whatsappProviderType = currentProviderType;
          const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : null;
          const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls && this.agentConfigurationForm.controls['id'] ? this.agentConfigurationForm.controls['id'].value : null;

          if (entityId && projectId && !this.isWhatsAppFreeFlowEnabled(f)) {
            this.ensureWhatsAppTemplatesLoaded(f);
          }
        } else {
          setTimeout(() => {
            if (!this.isWhatsAppFreeFlowEnabled(f)) {
              this.checkWhatsAppProviderAndLoadTemplates(f);
            }
          }, 100);
        }
      } else {
        // If it's neither, clear all special validators
        f.get('email_subject').clearValidators();
        f.get('email_content').clearValidators();
        f.get('calendarIntegrated').clearValidators();
        f.get('delay').clearValidators();
        this.syncCallAgainDelayValidators(f, false);
        f.get('refresh_token').clearValidators();
        f.get('from_email').clearValidators();
        f.get('whatsapp_message').clearValidators();
        f.get('whatsapp_prompt').clearValidators();
      }

      // Update validation state
      f.get('email_subject').updateValueAndValidity();
      f.get('email_content').updateValueAndValidity();
      f.get('calendarIntegrated').updateValueAndValidity();
      f.get('whatsapp_message').updateValueAndValidity();
      if (f.get('delay_amount')) {
        f.get('delay_amount').updateValueAndValidity({ emitEvent: false });
      }
      if (f.get('delay_unit')) {
        f.get('delay_unit').updateValueAndValidity({ emitEvent: false });
      }
    });

    this.bindFollowUpStepsHandlers(f);

    if (this.normalizeCallActionValue(action.call_action) === 'Call again') {
      this.syncCallAgainDelayValidators(f, true);
    }

    return f;
  }

  getCallActionCount(outcome: FormGroup | any): number {
    if (!outcome) {
      return 0;
    }
    const callActions = outcome.get('callActions') as FormArray;
    return callActions ? callActions.length : 0;
  }

  deleteOutcome(index: number) {
    this.outcomes.removeAt(index);
  }

  addMoreConditions(outcomeIndex: number) {
    const conditions = this.outcomes.at(outcomeIndex).get('conditions') as FormArray;
    conditions.push(this._formBuilder.group({ condition: [''] }));
  }

  deleteCondition(outcomeIndex: number, conditionIndex: number) {
    const conditions = this.outcomes.at(outcomeIndex).get('conditions') as FormArray;
    conditions.removeAt(conditionIndex);
  }

  addMoreActions(outcomeIndex) {
    if (outcomeIndex === undefined || outcomeIndex === null) {
      console.error('Outcome index is undefined or null');
      return;
    }

    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;

    if (!outcomes || outcomes.length <= outcomeIndex) {
      console.error(`Outcomes FormArray is not defined or Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const selectedOutcome = outcomes.at(outcomeIndex);

    if (!selectedOutcome) {
      console.error(`Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const callActions = selectedOutcome.get('callActions') as FormArray;

    if (!callActions) {
      console.error('Conditions FormArray is not defined in the selected outcome');
      return;
    }

    callActions.push(this.getActionsArray());
  }

  deleteCallAction(outcomeIndex: number, actionIndex: number) {
    const actions = this.outcomes.at(outcomeIndex).get('callActions') as FormArray;
    actions.removeAt(actionIndex);
  }

  // Check WhatsApp provider type and load templates
  checkWhatsAppProviderAndLoadTemplates(actionForm: FormGroup) {
    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls && this.agentConfigurationForm.controls['id'] ? this.agentConfigurationForm.controls['id'].value : null;
    const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : null;

    if (!projectId || !entityId) {
      console.warn('Project ID or Entity ID not available for template loading');
      return;
    }

    // Check provider type
    this.checkWhatsAppProviderType(entityId, projectId, actionForm);
  }

  checkWhatsAppProviderType(entityId: string, projectId: string, actionForm: FormGroup) {
    const params = new URLSearchParams({
      entity_id: entityId,
      project_id: projectId
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const statusUrl = `${API_WHATSAPP_STATUS}?${params.toString()}`;

    this.http.get(statusUrl, { headers }).subscribe({
      next: (response: any) => {
        if (response && response.provider_type) {
          this.whatsappProviderType = response.provider_type;

          // Update validators based on free-flow + provider type
          if (this.normalizeCallActionValue(actionForm.get('call_action').value) === 'Send WhatsApp Message') {
            this.syncWhatsAppActionValidators(actionForm);
            this.bindWhatsAppFreeFlowHandlers(actionForm);

            if (!actionForm['_templateSubscription']) {
              actionForm['_templateSubscription'] = actionForm.get('template_name').valueChanges.subscribe((templateName: string) => {
                const tid = this.getTemplateIdForSelectedName(actionForm, templateName || '');
                actionForm.get('template_id').setValue(tid, { emitEvent: false });
                if (templateName && response.provider_type === 'interakt') {
                  this.saveWhatsAppTemplateToProject(templateName);
                }
              });
            }
          }

          // Load templates based on provider type
          if (response.provider_type === 'meta_api') {
            this.loadMetaTemplates(entityId, actionForm);
          } else if (response.provider_type === 'interakt') {
            this.loadInteraktTemplates(entityId, projectId, actionForm);
          } else if (response.provider_type === 'serri') {
            // Get whatsapp_phone_number from project details or response
            const whatsappPhoneNumber = this.selectedProject && this.selectedProject.whatsapp_phone_number
              ? this.selectedProject.whatsapp_phone_number
              : (response.whatsapp_phone_number || '');
            if (whatsappPhoneNumber) {
              this.loadSerriTemplates(entityId, whatsappPhoneNumber, actionForm);
            } else {
              console.warn('WhatsApp phone number not available for Serri template loading');
            }
          }
        }
      },
      error: (err: any) => {
        console.error('Error checking WhatsApp provider type:', err);
      }
    });
  }

  loadMetaTemplates(entityId: string, actionForm: FormGroup) {
    // First, get WABAs
    const params = new URLSearchParams({
      entity_id: entityId
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const listWABAsUrl = `${API_WHATSAPP_LIST_WABAs}?${params.toString()}`;

    this.http.get(listWABAsUrl, { headers }).subscribe({
      next: (wabaResponse: any) => {
        if (wabaResponse && wabaResponse.success && wabaResponse.data && Array.isArray(wabaResponse.data) && wabaResponse.data.length > 0) {
          this.wabaList = wabaResponse.data;
          const wabaId = wabaResponse.data[0].waba_id; // Use first WABA

          // Now load templates
          const templateParams = new URLSearchParams({
            entity_id: entityId,
            waba_id: wabaId,
            limit: '100'
          });

          const listTemplatesUrl = `${API_WHATSAPP_LIST_TEMPLATES}?${templateParams.toString()}`;

          this.http.get(listTemplatesUrl, { headers }).subscribe({
            next: (templateResponse: any) => {
              if (templateResponse && templateResponse.success && templateResponse.data && Array.isArray(templateResponse.data)) {
                // Filter only approved templates
                const approvedTemplates = templateResponse.data.filter((t: any) => t.status === 'APPROVED');
                // Store templates in actionForm for access in template
                actionForm['_templates'] = approvedTemplates;
                // Also store in shared property for fallback
                this.whatsappTemplates = approvedTemplates;
                this.backfillWhatsappTemplateIds(actionForm);
              }
            },
            error: (err: any) => {
              console.error('Error loading Meta templates:', err);
            }
          });
        }
      },
      error: (err: any) => {
        console.error('Error loading WABAs:', err);
      }
    });
  }

  loadInteraktTemplates(entityId: string, projectId: string, actionForm: FormGroup) {
    const actionKey = `${entityId}_${projectId}`;
    this.whatsappTemplatesLoading[actionKey] = true;

    // Step 1: Get API key from environment
    const apiKey = environment.interaktApiKey;

    if (!apiKey) {
      this.whatsappTemplatesLoading[actionKey] = false;
      console.error('Interakt API key not found in environment');
      this.notify.showMessage('Interakt API key not configured. Please contact support.', 5000);
      return;
    }

    // Step 2: Call Interakt API directly using fetch to bypass HTTP interceptors
    const interaktApiUrl = 'https://api.interakt.ai/v1/public/track/organization/templates?offset=0&autosubmitted_for=all&approval_status=APPROVED&language=all';

    // Use fetch API to bypass Angular HTTP interceptors that override Authorization header
    fetch(interaktApiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Basic ${apiKey}`,
        'Content-Type': 'application/json'
      }
    })
      .then(async (response) => {
        this.whatsappTemplatesLoading[actionKey] = false;

        if (!response.ok) {
          // Handle HTTP error status
          let errorMessage = 'Failed to load Interakt templates. Please try again.';

          if (response.status === 401) {
            errorMessage = 'Invalid Interakt API key. Please contact support.';
          } else if (response.status === 404) {
            errorMessage = 'Interakt templates not found. Please verify your Interakt configuration.';
          } else if (response.status === 500) {
            errorMessage = 'Interakt API error. Please try again later.';
          }

          this.notify.showMessage(errorMessage, 5000);
          actionForm['_templates'] = [];
          this.whatsappTemplates = [];
          return;
        }

        const responseData = await response.json();

        // Step 3: Extract templates from response (handle different formats)
        let templates = [];

        if (Array.isArray(responseData)) {
          // Format 1: Response is an array
          templates = responseData;
        } else if (responseData && responseData.results && responseData.results.templates && Array.isArray(responseData.results.templates)) {
          // Format 2: Nested object with results.templates
          templates = responseData.results.templates;
        } else if (responseData && responseData.templates && Array.isArray(responseData.templates)) {
          // Format 3: Direct object with templates
          templates = responseData.templates;
        } else if (responseData && responseData.data && Array.isArray(responseData.data)) {
          // Format 4: Direct object with data
          templates = responseData.data;
        }

        // Store templates in actionForm for access in template
        actionForm['_templates'] = templates;
        // Also store in shared property for fallback
        this.whatsappTemplates = templates;
        this.backfillWhatsappTemplateIds(actionForm);
      })
      .catch((error) => {
        this.whatsappTemplatesLoading[actionKey] = false;
        console.error('Error loading Interakt templates:', error);

        // Step 4: Handle network errors
        let errorMessage = 'Network error. Please check your connection and try again.';

        this.notify.showMessage(errorMessage, 5000);

        // Set empty templates on error
        actionForm['_templates'] = [];
        this.whatsappTemplates = [];
      });
  }

  loadSerriTemplates(entityId: string, whatsappPhoneNumber: string, actionForm: FormGroup) {
    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls && this.agentConfigurationForm.controls['id'] ? this.agentConfigurationForm.controls['id'].value : null;
    const actionKey = projectId ? `${entityId}_${projectId}` : `${entityId}_${whatsappPhoneNumber}`;
    this.whatsappTemplatesLoading[actionKey] = true;

    const params = new URLSearchParams({
      entity_id: entityId,
      whatsapp_phone_number: whatsappPhoneNumber,
      page: '1',
      limit: '100'
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const listTemplatesUrl = `${API_SERRI_LIST_TEMPLATES}?${params.toString()}`;

    this.http.get(listTemplatesUrl, { headers }).subscribe({
      next: (response: any) => {
        this.whatsappTemplatesLoading[actionKey] = false;

        let templates = [];

        // Handle Serri response structure: response.data.data contains the templates array
        if (response && response.success && response.data && response.data.data && Array.isArray(response.data.data)) {
          templates = response.data.data;
        } else if (response && response.success && response.data && Array.isArray(response.data)) {
          // Fallback: if data is directly an array
          templates = response.data;
        } else if (response && Array.isArray(response)) {
          // Handle case where response is directly an array
          templates = response;
        } else {
          console.warn('Unexpected Serri templates response format:', response);
          templates = [];
        }

        // Filter only approved templates (similar to Meta templates)
        const approvedTemplates = templates.filter((template: any) =>
          template.status === 'APPROVED' || !template.status // Include if approved or no status field
        );

        // Map Serri template structure: use 'id' as 'template_id' for consistency
        // Serri templates have: id, name, label, category, status, etc.
        const mappedTemplates = approvedTemplates.map((template: any) => ({
          ...template,
          template_id: template.id || template.template_id, // Use id as template_id for Serri
          name: template.name || template.label || 'Template'
        }));

        // Store templates in actionForm for access in template
        actionForm['_templates'] = mappedTemplates;
        // Also store in shared property for fallback
        this.whatsappTemplates = mappedTemplates;
        this.backfillWhatsappTemplateIds(actionForm);
      },
      error: (err: any) => {
        this.whatsappTemplatesLoading[actionKey] = false;
        console.error('Error loading Serri templates:', err);
        this.notify.showMessage('Failed to load Serri templates. Please try again.', 5000);
        actionForm['_templates'] = [];
        this.whatsappTemplates = [];
      }
    });
  }

  /**
   * Save selected WhatsApp template to project
   * @param templateName - The template name from Interakt API (template.name field)
   */
  saveWhatsAppTemplateToProject(templateName: string) {
    if (!templateName) {
      console.warn('Template name is empty, skipping save');
      return;
    }

    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls && this.agentConfigurationForm.controls['id'] ? this.agentConfigurationForm.controls['id'].value : null;
    const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : null;
    const userId = this.profile && this.profile.user && this.profile.user.id ? this.profile.user.id : null;
    const userName = this.profile && this.profile.user && this.profile.user.userMeta && this.profile.user.userMeta.name ? this.profile.user.userMeta.name : '';

    if (!projectId || !entityId || !userId) {
      console.warn('Missing required IDs for saving template:', { projectId, entityId, userId });
      return;
    }

    // Create FormData for the request
    const formData = new FormData();
    formData.append('entityId', entityId);
    formData.append('projectId', projectId);
    formData.append('userId', userId);
    formData.append('userName', userName);
    formData.append('whatsappDefaultTemplate', templateName);

    // Save template to project using updateHoaProject
    this.jobService.updateHoaProject(formData).subscribe({
      next: (response: any) => {
        console.log('WhatsApp template saved to project successfully:', templateName);
        // Optionally show a success message (commented out to avoid too many notifications)
        // this.notify.showMessage('Template saved successfully', 2000);
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error saving WhatsApp template to project:', error);
        this.notify.showMessage('Failed to save template. Please try again.', 3000);
      }
    });
  }

  getTemplatesForAction(actionForm: FormGroup): any[] {
    return actionForm['_templates'] || this.whatsappTemplates || [];
  }

  /** Mat-option [value] for a template row (must match template HTML). */
  getMatSelectTemplateValue(t: any): string {
    const provider = (this.getCurrentWhatsAppProviderType() || '').toLowerCase();
    if (provider === 'serri') {
      return String(t.name != null ? t.name : t.label != null ? t.label : '');
    }
    const v = t.name || t.template_id || t.id;
    return v != null ? String(v) : '';
  }

  /** Resolve template_id from list (Serri: API id mapped to template_id on load). */
  getTemplateIdForSelectedName(actionForm: FormGroup, selectedValue: string): string {
    if (selectedValue == null || selectedValue === '') {
      return '';
    }
    const templates = this.getTemplatesForAction(actionForm);
    const sv = String(selectedValue);
    for (let i = 0; i < templates.length; i++) {
      const t = templates[i];
      if (this.getMatSelectTemplateValue(t) === sv) {
        const tid = t.template_id != null ? t.template_id : t.id;
        return tid != null ? String(tid) : '';
      }
    }
    return '';
  }

  backfillWhatsappTemplateIds(actionForm: FormGroup): void {
    if (!actionForm.get('template_name') || !actionForm.get('template_id')) {
      return;
    }
    const name = actionForm.get('template_name').value;
    if (name) {
      const id = this.getTemplateIdForSelectedName(actionForm, name);
      if (id) {
        actionForm.get('template_id').setValue(id, { emitEvent: false });
      }
    }
    // Templates have just arrived, so the {{n}} placeholders are now resolvable.
    this.syncTemplateVariablesForAction(actionForm);
  }

  onWhatsAppMainTemplateSelected(actionForm: FormGroup, templateName: string): void {
    const id = this.getTemplateIdForSelectedName(actionForm, templateName);
    actionForm.get('template_id').setValue(id, { emitEvent: false });
    this.syncTemplateVariablesForTarget(actionForm, actionForm);
  }

  isTemplatesLoadingForAction(actionForm: FormGroup): boolean {
    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls && this.agentConfigurationForm.controls['id'] ? this.agentConfigurationForm.controls['id'].value : null;
    const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : null;
    if (!projectId || !entityId) return false;
    const actionKey = `${entityId}_${projectId}`;
    return this.whatsappTemplatesLoading[actionKey] || false;
  }

  getCurrentWhatsAppProviderType(): string {
    // Use provider from API if already loaded, otherwise fallback to project details
    return this.whatsappProviderType || (this.selectedProject && this.selectedProject.whatsapp_provider_type) || '';
  }

  shouldShowTemplateSelector(): boolean {
    const provider = this.getCurrentWhatsAppProviderType();
    return provider === 'meta_api' || provider === 'interakt' || provider === 'serri';
  }

  // Check provider type and load templates for all existing WhatsApp actions when project loads
  checkProviderAndLoadTemplatesForExistingActions() {
    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls && this.agentConfigurationForm.controls['id'] ? this.agentConfigurationForm.controls['id'].value : null;
    const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : null;

    if (!projectId || !entityId) {
      return;
    }

    // Check provider type first
    const params = new URLSearchParams({
      entity_id: entityId,
      project_id: projectId
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const statusUrl = `${API_WHATSAPP_STATUS}?${params.toString()}`;

    this.http.get(statusUrl, { headers }).subscribe({
      next: (response: any) => {
        if (response && response.provider_type) {
          this.whatsappProviderType = response.provider_type;

          // Load templates for all existing WhatsApp actions
          const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
          if (outcomes) {
            outcomes.controls.forEach((outcome) => {
              const callActions = outcome.get('callActions') as FormArray;
              if (callActions) {
                callActions.controls.forEach((actionControl) => {
                  const action = actionControl as FormGroup;
                  if (this.normalizeCallActionValue(action.get('call_action').value) === 'Send WhatsApp Message') {
                    if (response.provider_type === 'meta_api') {
                      this.loadMetaTemplates(entityId, action);
                    } else if (response.provider_type === 'interakt') {
                      this.loadInteraktTemplates(entityId, projectId, action);
                    } else if (response.provider_type === 'serri') {
                      // Get whatsapp_phone_number from project details or response
                      const whatsappPhoneNumber = (this.selectedProject && this.selectedProject.whatsapp_phone_number)
                        ? this.selectedProject.whatsapp_phone_number
                        : (response.whatsapp_phone_number || '');
                      if (whatsappPhoneNumber) {
                        this.loadSerriTemplates(entityId, whatsappPhoneNumber, action);
                      } else {
                        console.warn('WhatsApp phone number not available for Serri template loading');
                      }
                    }
                  }
                });
              }
            });
          }
        }
      },
      error: (err: any) => {
        console.error('Error checking WhatsApp provider type for existing actions:', err);
      }
    });
  }

  onNext() {
    // this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
    // return;
    this.isLoading = true;
    if (this.stepper.selectedIndex == 0) {
      // Bind library agents onto the project (replaces voice-stack authoring).
      this.saveAgentBindings(true);
    }

    if (this.stepper.selectedIndex == 1) {
      // Project messaging only — scripts live on Agents.
      this.saveFinalPrompt({ advanceStepper: true });
    }

    if (this.stepper.selectedIndex == 2) {
      if (!this.workflowOutcomeForm.valid) {
        this.markStepValidationAttempted(2);
        this.workflowOutcomeForm.markAllAsTouched();
        this.isLoading = false;
        return;
      } else {
        // Don't set isLoading = false here, let saveOutcomes() handle it
        this.saveOutcomes();
      }
    }

    if (this.stepper.selectedIndex == 3) {
      this.saveFunnelStep();
    }

    if (this.stepper.selectedIndex == 4) {
      if (!this.campaignConfigForm.valid) {
        this.markStepValidationAttempted(4);
        this.campaignConfigForm.markAllAsTouched();
        this.isLoading = false;
        return;
      } else if (this.loopSettings && !this.loopSettings.loopReady) {
        this.notify.showMessage('Fix the loop settings marked in red to continue.', 3000);
        this.isLoading = false;
        return;
      } else if (this.loopSettings) {
        // The loop settings save first; the campaign goals save and leave the screen after.
        this.loopSettings.saveLoop().subscribe(
          () => this.saveCampaignConfig(),
          () => { this.isLoading = false; }
        );
      } else {
        // Don't set isLoading = false here, let saveCampaignConfig() handle it
        this.saveCampaignConfig();
      }
    }
  }

  /** Step 4: every outcome has to sit in a stage; the funnel is saved before moving on to goals. */
  private saveFunnelStep() {
    const settings = this.funnelSettings;
    if (!settings || !settings.funnelReady) {
      this.notify.showMessage('Place every outcome in a stage to continue.', 3000);
      this.isLoading = false;
      return;
    }
    settings.saveFunnel().subscribe(
      () => {
        this.isLoading = false;
        this.refreshSelectedProject();
        this.stepper.selectedIndex = 4;
      },
      () => { this.isLoading = false; }
    );
  }

  async saveProject() {
    this.isLoading = true;
    if (!this.selectedAgent) {
      console.warn("⚠️ Waiting for selectedAgent before saving...");
      this.isLoading = false;
      return;
    }

    try {
      // For inbound agents, save main project AND initial phone config in step 1
      await this.saveMainProject();

      // Also save initial phone config for inbound agents
      if (this.isInboundAgentType()) {
        try {
          await this.saveInboundPhoneConfig();
        } catch (error) {
          console.error('Error saving initial inbound phone config:', error);
          this.notify.showMessage('Error saving initial inbound phone config!', 2000);
        }
      }

      // Continue with outbound flow below...

      // ✅ Convert userVariables from Array → Object
      const userVariablesArray = this.agentConfigurationForm.controls['userVariables'].value;
      const userVariablesObject = {};

      if (Array.isArray(this.selectedAgent.variable_inputs)) {
        this.selectedAgent.variable_inputs.forEach((key, index) => {
          const snakeKey = this.toSnakeCase(key); // Convert "Agent Name" → "agent_name"
          userVariablesObject[snakeKey] = userVariablesArray[index] || ""; // Assign value or empty string
        });
      }

      const formData = new FormData();
      formData.append('entityId', this.profile.entity.id);
      formData.append('agentName', this.selectedAgent.agent_name);
      formData.append('agentId', this.selectedAgent.agent_id);
      formData.append('userId', this.profile.user.id);
      formData.append('userName', this.profile.user.userMeta.name);
      formData.append('projectId', this.selectedProject.project_id);
      formData.append('projectName', this.agentConfigurationForm.controls['projectName'].value);
      formData.append(
        'callAgentName',
        this.agentConfigurationForm.controls['callAgentName'].value || ''
      );
      formData.append(
        'whatsappAgentName',
        this.agentConfigurationForm.controls['whatsappAgentName'].value || ''
      );
      formData.append('projectDescription', this.selectedProject.project_description);
      formData.append('userPrompt', this.agentConfigurationForm.controls['userPrompt'].value);
      formData.append('userQuestions', JSON.stringify(this.agentConfigurationForm.controls['userQuestions'].value));
      formData.append('userVariables', JSON.stringify(userVariablesObject));
      formData.append('language', this.agentConfigurationForm.controls['language'].value || "hi");
      formData.append('voice', this.getGenderFromVoiceSelection());
      formData.append('tts', this.agentConfigurationForm.controls['tts'].value || "elevenlabs");
      formData.append('voiceId', this.getVoiceIdFromSelection());
      const plivoCallerIds = this.agentConfigurationForm.controls['plivoCallerIds'].value || [];
      formData.append('plivoCallerIds', JSON.stringify(Array.isArray(plivoCallerIds) ? plivoCallerIds : []));
      formData.append('autoCall', this.agentConfigurationForm.controls['autoCall'].value ? 'true' : 'false');
      formData.append('websiteLink', this.agentConfigurationForm.controls['websiteLink'].value || '');
      formData.append('entityEmail', this.profile.entity.email || '');
      // Get full phone number with country code from international telephone input
      const phoneInputInstance = this.phoneInputInstances[0];
      let transferNumber = '';
      if (phoneInputInstance && phoneInputInstance.getNumber) {
        transferNumber = phoneInputInstance.getNumber();
      } else {
        transferNumber = this.agentConfigurationForm.controls['transferNumber'].value || '';
      }
      formData.append('transferNumber', transferNumber);

      // Append selected files to formData
      this.selectedFiles.forEach((file, index) => {
        formData.append(`file_${index}`, file, file.name);
      });

      this.appendSttLlmToFormData(formData);

      this.jobService.updateHoaProject(formData).subscribe(
        (data) => {
          this.isLoading = false;
          this.notify.showMessage("Project created successfully!", 2000);
          this.agentConfigurationForm.controls['id'].setValue(data.project_id);
          this.agentConfigurationForm.controls['id'].updateValueAndValidity();
          this.markSttLlmFieldsPristine();
          this.getProjectDetailsById(data.project_details.project_id, true);
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notifyHoaProjectSaveError(error, 'Error while creating project!');
        }
      );
      //this.submitHoaProject(formData);

    } catch (error) {
      this.isLoading = false;
      const he = error as HttpErrorResponse;
      if (!he || he.status !== 400) {
        this.notify.showMessage("Error while saving project!", 2000);
      }
      console.error('Error in saveProject:', error);
    }
  }

  // Update inbound phone config with new system_prompt (called in step 2)
  async updateInboundPhoneConfig() {
    if (!this.inboundBearerToken) {
      await this.getInboundBearerToken();
    }

    const plivoCallerIds = this.agentConfigurationForm.controls['plivoCallerIds'].value || [];
    const phoneNumber = Array.isArray(plivoCallerIds) && plivoCallerIds.length > 0 ? plivoCallerIds[0] : '';
    const updateConfig = {
      phone_number: phoneNumber,
      system_prompt: this.scriptFormGroup.controls['finalPrompt'].value ||
        this.agentConfigurationForm.controls['userPrompt'].value ||
        "You are a helpful AI assistant for customer service calls. You are a female.",
      initial_greeting: this.scriptFormGroup.controls['initialGreeting'].value || ''
    };

    console.log('🔄 Updating inbound phone config with new system_prompt:', updateConfig);

    const url = `${environment.pipecatAPI}/config/phone`;
    const response = await this.http.post(url, updateConfig, {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.inboundBearerToken}`,
        'Content-Type': 'application/json'
      })
    }).toPromise();

    console.log('✅ Phone config updated successfully:', response);
    return response;
  }

  // Save complete inbound phone config (called in step 3)
  async saveInboundPhoneConfig(outcomesOverride?: any[]) {
    if (!this.inboundBearerToken) {
      await this.getInboundBearerToken();
    }

    const sourceOutcomes = Array.isArray(outcomesOverride) && outcomesOverride.length
      ? outcomesOverride
      : this.workflowOutcomeForm.value.outcomes;

    const plivoCallerIds = this.agentConfigurationForm.controls['plivoCallerIds'].value || [];
    const phoneNumber = Array.isArray(plivoCallerIds) && plivoCallerIds.length > 0 ? plivoCallerIds[0] : '';
    const inboundConfig = {
      phone_number: phoneNumber,
      system_prompt: this.scriptFormGroup.controls['finalPrompt'].value ||
        this.agentConfigurationForm.controls['userPrompt'].value ||
        "You are a helpful AI assistant for customer service calls. You are a female.",
      initial_greeting: this.scriptFormGroup.controls['initialGreeting'].value || '',
      agent_gender: this.getGenderFromVoiceSelection(),
      agent_language: this.agentConfigurationForm.controls['language'].value,
      tts_provider: this.agentConfigurationForm.controls['tts'].value,
      agent_type: 'lead_generation',
      voice_id: this.getVoiceIdFromSelection(),
      entity_id: this.profile.entity.id,
      project_id: this.selectedProject.project_id,
      agent_id: this.selectedAgent.agent_id,
      //google_calendar_token: "",
      outcomes: sourceOutcomes.map(outcome => ({
        name: outcome.outcome_name || outcome.name,
        description: outcome.outcome_description || outcome.description
      })),
      user_questions: this.agentConfigurationForm.controls['userQuestions'].value,
      client_name_override: this.profile.user.userMeta.name || "Default Client",
      client_email_override: this.profile.entity.email || "default@example.com"
    };

    console.log('💾 Saving complete inbound phone config:', inboundConfig);

    const response = await this.createOrUpdateInboundConfig(inboundConfig);
    console.log('✅ Complete inbound config saved successfully:', response);
    return response;
  }

  async saveMainProject() {
    // Convert userVariables from Array → Object
    const userVariablesArray = this.agentConfigurationForm.controls['userVariables'].value;
    const userVariablesObject = {};

    if (Array.isArray(this.selectedAgent.variable_inputs)) {
      this.selectedAgent.variable_inputs.forEach((key, index) => {
        const snakeKey = this.toSnakeCase(key);
        userVariablesObject[snakeKey] = userVariablesArray[index] || "";
      });
    }

    const formData = new FormData();
    formData.append('entityId', this.profile.entity.id);
    formData.append('agentName', this.selectedAgent.agent_name);
    formData.append('agentId', this.selectedAgent.agent_id);
    formData.append('userId', this.profile.user.id);
    formData.append('userName', this.profile.user.userMeta.name);
    formData.append('projectId', this.selectedProject.project_id);
    formData.append('projectName', this.agentConfigurationForm.controls['projectName'].value);
    formData.append(
      'callAgentName',
      this.agentConfigurationForm.controls['callAgentName'].value || ''
    );
    formData.append(
      'whatsappAgentName',
      this.agentConfigurationForm.controls['whatsappAgentName'].value || ''
    );
    formData.append('projectDescription', this.selectedProject.project_description);
    formData.append('userPrompt', this.agentConfigurationForm.controls['userPrompt'].value);
    formData.append('userQuestions', JSON.stringify(this.agentConfigurationForm.controls['userQuestions'].value));
    formData.append('userVariables', JSON.stringify(userVariablesObject));
    formData.append('language', this.agentConfigurationForm.controls['language'].value || "hi");
    formData.append('voice', this.getGenderFromVoiceSelection());
    formData.append('tts', this.agentConfigurationForm.controls['tts'].value || "elevenlabs");
    formData.append('voiceId', this.getVoiceIdFromSelection());
    const plivoCallerIds = this.agentConfigurationForm.controls['plivoCallerIds'].value || [];
    formData.append('plivoCallerIds', JSON.stringify(Array.isArray(plivoCallerIds) ? plivoCallerIds : []));
    formData.append('autoCall', this.agentConfigurationForm.controls['autoCall'].value ? 'true' : 'false');
    formData.append('websiteLink', this.agentConfigurationForm.controls['websiteLink'].value || '');
    formData.append('entityEmail', this.profile.entity.email || '');
    formData.append('agentType', this.agentType); // Save agent type

    // Get full phone number with country code from international telephone input
    const phoneInputInstance = this.phoneInputInstances[0];
    let transferNumber = '';
    if (phoneInputInstance && phoneInputInstance.getNumber) {
      transferNumber = phoneInputInstance.getNumber();
    } else {
      transferNumber = this.agentConfigurationForm.controls['transferNumber'].value || '';
    }
    formData.append('transferNumber', transferNumber);

    // Append selected files to formData
    this.selectedFiles.forEach((file, index) => {
      formData.append(`file_${index}`, file, file.name);
    });

    this.appendSttLlmToFormData(formData);

    // Save to main project database
    return new Promise((resolve, reject) => {
      this.jobService.updateHoaProject(formData).subscribe(
        (data) => {
          this.notify.showMessage("Project saved to main database!", 2000);
          this.agentConfigurationForm.controls['id'].setValue(data.project_id);
          this.agentConfigurationForm.controls['id'].updateValueAndValidity();
          this.markSttLlmFieldsPristine();
          resolve(data);
        },
        (error: HttpErrorResponse) => {
          this.notifyHoaProjectSaveError(error, 'Error while saving project to main database!');
          reject(error);
        }
      );
    });
  }

  submitFromWebsiteLink() {
    if (!this.selectedAgent) {
      console.warn("⚠️ No agent selected, cannot proceed.");
      return;
    }

    const userVariablesArray = this.agentConfigurationForm.controls['userVariables'].value;
    const userVariablesObject = {};

    if (Array.isArray(this.selectedAgent.variable_inputs)) {
      this.selectedAgent.variable_inputs.forEach((key, index) => {
        const snakeKey = this.toSnakeCase(key);
        userVariablesObject[snakeKey] = userVariablesArray[index] || "";
      });
    }

    const formData = new FormData();
    formData.append('entityId', this.profile.entity.id);
    formData.append('agentName', this.selectedAgent.agent_name);
    formData.append('agentId', this.selectedAgent.agent_id);
    formData.append('userId', this.profile.user.id);
    formData.append('userName', this.profile.user.userMeta.name);
    formData.append('projectId', this.selectedProject.project_id);
    formData.append('projectName', this.agentConfigurationForm.controls['projectName'].value || '');
    formData.append(
      'callAgentName',
      this.agentConfigurationForm.controls['callAgentName'].value || ''
    );
    formData.append(
      'whatsappAgentName',
      this.agentConfigurationForm.controls['whatsappAgentName'].value || ''
    );
    formData.append('projectDescription', this.selectedProject.project_description || '');
    formData.append('userPrompt', this.agentConfigurationForm.controls['userPrompt'].value || '');
    formData.append('userQuestions', JSON.stringify(this.agentConfigurationForm.controls['userQuestions'].value || []));
    formData.append('userVariables', JSON.stringify(userVariablesObject));
    formData.append('language', this.agentConfigurationForm.controls['language'].value || 'hi');
    formData.append('voice', this.getGenderFromVoiceSelection());
    formData.append('tts', this.agentConfigurationForm.controls['tts'].value || 'elevenlabs');
    formData.append('voiceId', this.getVoiceIdFromSelection());
    const plivoCallerIds = this.agentConfigurationForm.controls['plivoCallerIds'].value || [];
    formData.append('plivoCallerIds', JSON.stringify(Array.isArray(plivoCallerIds) ? plivoCallerIds : []));
    formData.append('autoCall', this.agentConfigurationForm.controls['autoCall'].value ? 'true' : 'false');
    formData.append('websiteLink', this.agentConfigurationForm.controls['websiteLink'].value || '');
    formData.append('entityEmail', this.profile.entity.email || '');
    // Get full phone number with country code from international telephone input
    const phoneInputInstance = this.phoneInputInstances[0];
    let transferNumber = '';
    if (phoneInputInstance && phoneInputInstance.getNumber) {
      transferNumber = phoneInputInstance.getNumber();
    } else {
      transferNumber = this.agentConfigurationForm.controls['transferNumber'].value || '';
    }
    formData.append('transferNumber', transferNumber);

    this.selectedFiles.forEach((file, index) => {
      formData.append(`file_${index}`, file, file.name);
    });

    this.appendSttLlmToFormData(formData);

    this.jobService.updateHoaProject(formData).subscribe(
      (data) => {
        this.markSttLlmFieldsPristine();
        if (data.project_details && data.project_details.website_data) {
          try {
            const websiteData = JSON.parse(data.project_details.website_data);
            const formArray = this.agentConfigurationForm.get('userVariables') as FormArray;

            // ⚠️ Patch values using index (do not overwrite entire array)
            if (formArray.length >= 4) {
              formArray.at(2).setValue((websiteData.pain_points || []).join(", "));
              formArray.at(3).setValue((websiteData.features || []).join(", "));
              formArray.at(4).setValue((websiteData.value_propositions || []).join(", "));
            }

            this.cdr.detectChanges();
            console.log("✅ Patched inputs with website data");
          } catch (err) {
            console.warn("❌ Failed to parse website_data:", err);
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.error("❌ Error while submitting project with website link:", error);
        if (error.status === 400) {
          this.notifyHoaProjectSaveError(error, 'Failed to fetch website data');
        } else {
          this.notify.showMessage("Failed to fetch website data", 2000);
        }
      }
    );
  }

  goToBackStep() {
    this.stepper.previous();
  }

  selectAgent(agent) {
    this.selectedAgent = agent;
  }

  disable(): boolean {
    return this.isLoading || this.aiEditInProgress;
  }

  private markStepValidationAttempted(stepIndex: number): void {
    this.validationAttemptedSteps.add(stepIndex);
  }

  isStepValidationAttempted(stepIndex: number): boolean {
    return this.validationAttemptedSteps.has(stepIndex);
  }

  showFieldError(control: AbstractControl | null | undefined, stepIndex: number): boolean {
    if (!control || control.valid) {
      return false;
    }
    return control.touched || control.dirty || this.isStepValidationAttempted(stepIndex);
  }

  isOutcomePanelInvalid(outcomeIndex: number): boolean {
    const outcome = this.outcomes.at(outcomeIndex) as FormGroup;
    return !!outcome && outcome.invalid;
  }

  nextBtnCTA() {
    let label = "Next";
    if (this.stepper && this.stepper.selectedIndex == 0) {
      label = "Next: Generate script";
    }
    if (this.stepper && this.stepper.selectedIndex == 1) {
      label = "Next: Define outcomes";
    }
    if (this.stepper && this.stepper.selectedIndex == 2) {
      label = "Next: Funnel";
    }
    if (this.stepper && this.stepper.selectedIndex == 3) {
      label = "Next: Goals, KPIs & Loops";
    }
    if (this.stepper && this.stepper.selectedIndex == 4) {
      label = "Save project";
    }
    return label;
  }

  getFolloupActions(index) {
    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
    const callActions = outcomes.controls[index].get('callActions') as FormArray;
    let followupActions = [];
    callActions.controls.forEach(ele => {
      if (ele.value.call_action) {
        followupActions.push(ele.value.call_action);
      }
    })
    return followupActions;
  }

  onFileSelected(event: any) {
    if (event.target.files.length > 0) {
      for (let file of event.target.files) {
        this.selectedFiles.push(file); // ✅ Add file to array
      }
    }
  }

  deleteSelectedFile(index: number) {
    this.selectedFiles.splice(index, 1); // ✅ Remove file from array
  }

  private processAgentSelection(projectResponse: any, agentFromList: any) {
    if (agentFromList) {
      this.selectedAgent = agentFromList;
      // Initialize userVariables controls based on selected agent, then patch project values
      const userVariablesArray = this.agentConfigurationForm.get('userVariables') as FormArray;
      userVariablesArray.clear();
      if (Array.isArray(this.selectedAgent.variable_inputs) && this.selectedAgent.variable_inputs.length > 0) {
        for (let i = 0; i < this.selectedAgent.variable_inputs.length; i++) {
          userVariablesArray.push(new FormControl('', Validators.required));
        }
        this.inputFocusedStates = new Array(this.selectedAgent.variable_inputs.length).fill(false);
      }
      // Don't create any FormControl if variable_inputs is empty or doesn't exist
      // Patch values from project after controls are created
      setTimeout(() => {
        this.populateFormFromProject();
      }, 0);
    } else {
      // ✅ Agent not found in list - fetch it directly or create fallback
      console.warn('⚠️ Agent not found in agentsList, fetching agent details...');
      if (projectResponse.agent_id) {
        this.getAgentById(this.profile.entity.id, projectResponse.agent_id);
      } else {
        // ✅ Fallback: create a minimal agent object from project data
        console.warn('⚠️ No agent_id in project, creating fallback agent object');
        this.selectedAgent = {
          agent_id: projectResponse.agent_id || '8d6de7c3-b66b-4f2b-bf6a-e2da09cd63b6',
          agent_name: projectResponse.agent_name || 'Cora Agent',
          variable_inputs: [] // Empty array as fallback
        };
        // Initialize userVariables - don't create controls for empty variable_inputs
        const userVariablesArray = this.agentConfigurationForm.get('userVariables') as FormArray;
        userVariablesArray.clear();

        // Populate form even with fallback agent
        setTimeout(() => {
          this.populateFormFromProject();
        }, 0);
      }
    }
  }

  /** ?step=funnel opens the Funnel step, ?step=goals opens Goals, KPIs & Loops. */
  private requestedStep: string | null = null;

  /** The two project settings sections sit in their own steps: the funnel builder and the loop. */
  @ViewChild('funnelSettings', { static: false }) funnelSettings: ProjectSettingsComponent;
  @ViewChild('loopSettings', { static: false }) loopSettings: ProjectSettingsComponent;

  /** After a settings save: refresh only the stored project, leaving every form as the person has it. */
  refreshSelectedProject() {
    const id = this.selectedProject && this.selectedProject.project_id;
    if (!id) { return; }
    this.jobService.getProjectById(this.profile.entity.id, id).subscribe((response) => {
      this.selectedProject = response;
    });
  }

  private applyRequestedStep() {
    if ((this.requestedStep === 'goals' || this.requestedStep === 'funnel') && this.stepper) {
      const index = this.requestedStep === 'funnel' ? 3 : 4;
      this.requestedStep = null;
      setTimeout(() => { this.stepper.selectedIndex = index; }, 600);
    }
  }

  getProjectDetailsById(projectId: string, nextScreen?: boolean, preserveScriptFields = false) {
    console.log('Fetching project details...');
    // Don't set isLoading here as it's already set in ngOnInit

    this.jobService.getProjectById(this.profile.entity.id, projectId).subscribe(
      (response) => {
        this.selectedProject = response;
        this.applyRequestedStep();
        console.log('✅ Project details retrieved successfully:', response);
        this.updateToolbarNavigation(response);

        // ✅ Use already-fetched agents list if available to avoid extra API call
        let agentFromList = Array.isArray(this.agentsList) && this.agentsList.length > 0
          ? this.agentsList.find((agent: any) => agent.agent_id === response.agent_id)
          : null;

        // ✅ If agent not found and agents list is empty, wait a bit and retry (agents might still be loading)
        if (!agentFromList && (!this.agentsList || this.agentsList.length === 0)) {
          console.log('⚠️ Agents list empty, waiting for it to load...');
          let retryCount = 0;
          const maxRetries = 10; // 1 second total wait time
          const checkAgents = setInterval(() => {
            retryCount++;
            agentFromList = Array.isArray(this.agentsList) && this.agentsList.length > 0
              ? this.agentsList.find((agent: any) => agent.agent_id === response.agent_id)
              : null;

            if (agentFromList || retryCount >= maxRetries) {
              clearInterval(checkAgents);
              this.processAgentSelection(response, agentFromList);
            }
          }, 100);
        } else {
          // Agents list is populated or agent was found, process immediately
          this.processAgentSelection(response, agentFromList);
        }

        if (response) {
          // ✅ Set form values
          this.agentConfigurationForm.controls['id'].setValue(response.project_id);
          this.agentConfigurationForm.controls['projectName'].setValue(response.project_name);
          this.populateAgentBindForm(response);
          this.agentConfigurationForm.controls['callAgentName'].setValue(
            response.call_agent_name || response.callAgentName
              || response.project_agent_name || response.projectAgentName || ''
          );
          this.agentConfigurationForm.controls['whatsappAgentName'].setValue(
            response.whatsapp_agent_name || response.whatsappAgentName || ''
          );
          this.agentConfigurationForm.controls['userPrompt'].setValue(response.user_prompt);
          this.agentConfigurationForm.controls['userPrompt'].updateValueAndValidity();

          // ✅ Restore agent type from project data
          if (response.agent_type) {
            this.agentType = response.agent_type;
            console.log('🔄 Restored agent type from project:', this.agentType);
            // Update validators dependent on agentType and trigger UI update
            this.updateValidationRules();
          }

          // ✅ Initialize WhatsApp provider type from project details early
          if (response.whatsapp_provider_type) {
            this.whatsappProviderType = response.whatsapp_provider_type;
            console.log('🔄 Restored WhatsApp provider type from project:', this.whatsappProviderType);
          }

          // Check WhatsApp status after project details are loaded
          this.checkWhatsAppStatus();

          // Check provider type and load templates for existing WhatsApp actions
          this.checkProviderAndLoadTemplatesForExistingActions();

          // ✅ Set agentId so mat-select shows the selected agent
          this.agentConfigurationForm.controls['agentId'].setValue(response.agent_id);

          // ✅ Populate userQuestions (Ensure at least one input exists)
          const userQuestionsArray = this.agentConfigurationForm.get('userQuestions') as FormArray;
          userQuestionsArray.clear();

          if (Array.isArray(response.user_questions) && response.user_questions.length > 0) {
            response.user_questions.forEach((question) => {
              userQuestionsArray.push(new FormControl(question));
            });
          } else {
            console.warn("⚠️ No user_questions found. Adding a blank input field.");
            userQuestionsArray.push(new FormControl(''));
          }

          console.log("✅ Updated userQuestions:", userQuestionsArray.value);

          // Skip script hydration when the form already has fresher values (e.g. just saved via updateProject).
          if (!preserveScriptFields) {
            // ✅ Set final prompt
            this.scriptFormGroup.controls['finalPrompt'].setValue(response.final_prompt);
            this.scriptFormGroup.controls['finalPrompt'].updateValueAndValidity();

            // ✅ Set initial greeting if exists
            if (response.initial_greeting) {
              this.scriptFormGroup.controls['initialGreeting'].setValue(response.initial_greeting);
              this.scriptFormGroup.controls['initialGreeting'].updateValueAndValidity();
            }

            // ✅ Set WhatsApp chat prompt if exists
            if (response.whatsapp_chat_prompt) {
              this.scriptFormGroup.controls['whatsappChatPrompt'].setValue(response.whatsapp_chat_prompt);
              this.scriptFormGroup.controls['whatsappChatPrompt'].updateValueAndValidity();
            }

            // ✅ Set WhatsApp default message if exists
            if (response.whatsapp_default_message) {
              this.scriptFormGroup.controls['whatsappDefaultMessage'].setValue(response.whatsapp_default_message);
              this.scriptFormGroup.controls['whatsappDefaultMessage'].updateValueAndValidity();
            }
          }

          // ✅ Hydrate Goal KPIs & duration (campaignConfig) if present
          this.patchCampaignConfig(response.campaign_config || response.campaignConfig);

          if (nextScreen) {
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          }

          this.setDefaultOutcomes();
        }

        // Don't set loading to false here - wait for populateFormFromProject to complete
      },
      (error) => {
        this.isLoading = false;
        console.error('❌ Failed to fetch project details:', error);
      }
    );
  }

  setDefaultOutcomes() {
    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
    outcomes.clear(); // Clear existing outcomes to avoid duplicates

    if (this.selectedProject && this.selectedProject.expected_outcomes.length) {
      console.log("Populating outcomes from selectedProject:", this.selectedProject.expected_outcomes);
      this.pushOutcomes(this.selectedProject.expected_outcomes);
    } else {
      console.warn("No outcomes found in selectedProject to populate.");
    }

    console.log("Final state of workflowOutcomeForm outcomes:", outcomes.value);
  }

  pushOutcomes(outcomesData: any[]) {
    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;

    outcomesData.forEach((outcome, outcomeIndex) => {
      console.log("outcome===", outcome)
      const outcomeForm = this._formBuilder.group({
        outcome_name: [outcome.outcome_name || outcome.name || '', [Validators.required]],
        outcome_appearance: [outcome.outcome_appearance || ''],
        outcome_description: [outcome.outcome_description || outcome.description || '', [Validators.required]],
        notify: [typeof outcome.notify === 'boolean' ? outcome.notify : false],
        notify_google_sheet: [typeof outcome.notify_google_sheet === 'boolean' ? outcome.notify_google_sheet : false],
        notify_via_webhook: [typeof outcome.notify_via_webhook === 'boolean' ? outcome.notify_via_webhook : false],
        webhook_same_as_previous: [false],
        add_in_other_project: [typeof outcome.add_in_other_project === 'boolean' ? outcome.add_in_other_project : false],
        do_not_consider_for_analysis: [typeof outcome.do_not_consider_for_analysis === 'boolean' ? outcome.do_not_consider_for_analysis : false],
        project_url: [outcome.project_url || ''],
        automatic_call: [typeof outcome.automatic_call === 'boolean' ? outcome.automatic_call : false],
        assign_users: [this.normalizeAssignUsers(outcome.assign_users)],
        webhook: this.buildWebhookFormGroup(outcome.webhook),
        conditions: this._formBuilder.array(
          (outcome.conditions || []).map((condition: any) =>
            this._formBuilder.group({
              condition: [condition.condition || ''],
            })
          ) || [] // Handle missing conditions
        ),
        callActions: this._formBuilder.array(
          (outcome.callActions || []).map((action: any, actionIndex: number) => {
            const actionForm = this.getActionsArray(action);
            // Restore image_url if it exists and store in whatsappImageUrls
            if (action.image_url) {
              const actionKey = `${outcomeIndex}_${actionIndex}`;
              this.whatsappImageUrls[actionKey] = action.image_url;
            }
            if (this.normalizeCallActionValue(action.call_action) === 'Send WhatsApp Message') {
              this.syncWhatsAppActionValidators(actionForm);
              this.bindWhatsAppFreeFlowHandlers(actionForm);
              this.backfillWhatsappTemplateIds(actionForm);
              if (!this.isWhatsAppFreeFlowEnabled(actionForm)) {
                this.ensureWhatsAppTemplatesLoaded(actionForm);
              }
            }

            return actionForm;
          }) || [] // Handle missing callActions
        ),
      });
      this.bindAddInOtherProjectHandlers(outcomeForm);
      this.bindWebhookNotifyHandlers(outcomeForm);
      outcomes.push(outcomeForm);
    });
  }

  async saveOutcomes() {
    let obj = {
      entityId: this.profile.entity.id,
      userId: this.profile.user.id,
      userName: this.profile.user.userMeta.name,
      projectId: this.agentConfigurationForm.controls['id'].value,
      expectedOutcomes: this.sanitizeExpectedOutcomesForSave(this.workflowOutcomeForm.value.outcomes)
    };

    console.log(obj)

    // For inbound agents, also save complete phone config in step 3
    if (this.isInboundAgentType()) {
      try {
        await this.saveInboundPhoneConfig(obj.expectedOutcomes);
      } catch (error) {
        console.error('Error saving inbound phone config:', error);
        this.notify.showMessage('Error saving inbound phone config!', 2000);
      }
    }

    this.jobService.updateProject(obj).subscribe(
      (data: any) => {
        this.isLoading = false;
        this.notify.showMessage("Outcomes updated successfully!", 2000);

        // Only rebuild the outcomes from the response when it actually returns them.
        // The updateProject API doesn't reliably echo `expected_outcomes`, so clearing
        // unconditionally wiped the user's outcomes from the UI until a manual refresh.
        // When the response has no outcomes, keep the current form state — it already
        // matches what was just saved.
        if (data && data.expected_outcomes && data.expected_outcomes.length) {
          const outcomesFormArray = this.workflowOutcomeForm.get('outcomes') as FormArray;
          outcomesFormArray.clear();
          this.pushOutcomes(data.expected_outcomes);
        }

        // Advance to the final step — Goal KPIs & duration
        this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notify.showMessage("Error while updating outcomes!", 2000);
      }
    );
  }

  async saveCampaignConfig() {
    const v = this.campaignConfigForm.value;
    const campaignConfig = {
      campaign_goal: v.campaign_goal || '',
      goal_prompt: v.goal_prompt || '',
      goal_outcomes: Array.isArray(v.goal_outcomes) ? v.goal_outcomes : [],
      allowed_channels: Array.isArray(v.allowed_channels) ? v.allowed_channels : [],
      max_touchpoints: Number(v.max_touchpoints) || 0,
      campaign_start_date: this.toDateString(v.campaign_start_date),
      campaign_end_date: this.toDateString(v.campaign_end_date),
      target_quantity: Number(v.target_quantity) || 0,
      aggression_mode: v.aggression_mode || 'auto',
      ai_autonomy: v.ai_autonomy === true,
      calling_window_start: v.calling_window_start || '',
      calling_window_end: v.calling_window_end || ''
    };

    const obj = {
      entityId: this.profile.entity.id,
      userId: this.profile.user.id,
      userName: this.profile.user.userMeta.name,
      projectId: this.agentConfigurationForm.controls['id'].value,
      campaignConfig: campaignConfig
    };

    console.log('Saving campaignConfig:', obj);

    this.jobService.updateProject(obj).subscribe(
      (data: any) => {
        this.isLoading = false;
        this.notify.showMessage("Campaign goals saved successfully!", 2000);
        this.router.navigate(['/job/view-new-project', obj.projectId]);
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notify.showMessage("Error while saving campaign goals!", 2000);
      }
    );
  }

  cancel() {
    this.router.navigate(['/job']);
  }

  private buildFinalPromptUpdatePayload() {
    return {
      entityId: this.profile.entity.id,
      userId: this.profile.user.id,
      userName: this.profile.user.userMeta.name,
      projectId: this.agentConfigurationForm.controls['id'].value,
      finalPrompt: this.scriptFormGroup.controls['finalPrompt'].value,
      initialGreeting: this.scriptFormGroup.controls['initialGreeting'].value,
      whatsappChatPrompt: this.scriptFormGroup.controls['whatsappChatPrompt'].value,
      whatsappDefaultMessage: this.scriptFormGroup.controls['whatsappDefaultMessage'].value
    };
  }

  /** Script fields persist via POST hoaProject (same store GET hoaProject reads from). */
  private buildHoaScriptUpdateFormData(): FormData {
    const payload = this.buildFinalPromptUpdatePayload();
    const formData = new FormData();
    formData.append('entityId', payload.entityId);
    formData.append('userId', payload.userId);
    formData.append('userName', payload.userName);
    formData.append('projectId', payload.projectId);

    const agentId = (this.selectedAgent && this.selectedAgent.agent_id)
      || (this.selectedProject && this.selectedProject.agent_id)
      || this.agentConfigurationForm.controls['agentId'].value;
    const agentName = (this.selectedAgent && this.selectedAgent.agent_name)
      || (this.selectedProject && this.selectedProject.agent_name)
      || this.agentConfigurationForm.controls['agentName'].value;

    if (agentId) {
      formData.append('agentId', agentId);
    }
    if (agentName) {
      formData.append('agentName', agentName);
    }

    formData.append('finalPrompt', payload.finalPrompt || '');
    formData.append('initialGreeting', payload.initialGreeting || '');
    formData.append('whatsappChatPrompt', payload.whatsappChatPrompt || '');
    formData.append('whatsappDefaultMessage', payload.whatsappDefaultMessage || '');
    formData.append(
      'callAgentName',
      this.agentConfigurationForm.controls['callAgentName'].value || ''
    );
    formData.append(
      'whatsappAgentName',
      this.agentConfigurationForm.controls['whatsappAgentName'].value || ''
    );

    return formData;
  }

  private patchLocalProjectScriptFields(payload: ReturnType<WorkflowStepperComponent['buildFinalPromptUpdatePayload']>): void {
    if (!this.selectedProject) {
      return;
    }
    this.selectedProject.final_prompt = payload.finalPrompt;
    this.selectedProject.initial_greeting = payload.initialGreeting;
    this.selectedProject.whatsapp_chat_prompt = payload.whatsappChatPrompt;
    this.selectedProject.whatsapp_default_message = payload.whatsappDefaultMessage;
    this.selectedProject.call_agent_name =
      this.agentConfigurationForm.controls['callAgentName'].value || '';
    this.selectedProject.whatsapp_agent_name =
      this.agentConfigurationForm.controls['whatsappAgentName'].value || '';
  }

  async saveFinalPrompt(options?: { advanceStepper?: boolean; successMessage?: string }): Promise<void> {
    const advanceStepper = options && options.advanceStepper === true;
    const successMessage = (options && options.successMessage) || 'Final prompt updated successfully!';

    this.isLoading = true;
    const obj = this.buildFinalPromptUpdatePayload();

    // For inbound agents, also update phone config with new system_prompt
    if (this.isInboundAgentType()) {
      try {
        await this.updateInboundPhoneConfig();
      } catch (error) {
        console.error('Error updating inbound phone config:', error);
        this.notify.showMessage('Error updating inbound phone config!', 2000);
      }
    }

    return new Promise((resolve, reject) => {
      this.jobService.updateHoaProject(this.buildHoaScriptUpdateFormData()).subscribe(
        () => {
          this.patchLocalProjectScriptFields(obj);
          this.isLoading = false;
          this.notify.showMessage(successMessage, 2000);

          if (advanceStepper) {
            this.getProjectDetailsById(this.agentConfigurationForm.controls['id'].value, true, true);
          }

          resolve();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notifyHoaProjectSaveError(error, 'Error while saving script!');
          reject(error);
        }
      );
    });
  }

  populateFormFromProject() {
    console.log('populateFormFromProject called');
    try {
      if (!this.selectedProject) {
        console.log('No selectedProject');
        this.isLoading = false; // ✅ Ensure loading stops even on early return
        return;
      }
      // Initialize WhatsApp provider type from project details if available
      if (this.selectedProject && this.selectedProject.whatsapp_provider_type) {
        this.whatsappProviderType = this.selectedProject.whatsapp_provider_type;
      }
      if (!this.selectedAgent) {
        console.log('No selectedAgent');
        // ✅ Create fallback agent if missing
        this.selectedAgent = {
          agent_id: this.selectedProject.agent_id || '8d6de7c3-b66b-4f2b-bf6a-e2da09cd63b6',
          agent_name: this.selectedProject.agent_name || 'Cora Agent',
          variable_inputs: []
        };
        console.log('Created fallback agent:', this.selectedAgent);
      }

      // Patch static fields
      const voiceKey = this.getVoiceKeyFromProject(this.selectedProject);
      const sttLlm = this.hydrateSttLlmFromProject(this.selectedProject);
      this.agentConfigurationForm.patchValue({
        projectName: this.selectedProject.project_name,
        callAgentName: this.selectedProject.call_agent_name
          || this.selectedProject.callAgentName
          || this.selectedProject.project_agent_name
          || this.selectedProject.projectAgentName
          || '',
        whatsappAgentName: this.selectedProject.whatsapp_agent_name
          || this.selectedProject.whatsappAgentName
          || '',
        userPrompt: this.selectedProject.user_prompt,
        agentId: this.selectedProject.agent_id,
        agentName: this.selectedProject.agent_name,
        language: this.selectedProject.language,
        voice: voiceKey,
        tts: this.selectedProject.tts || 'elevenlabs',
        voiceId: this.selectedProject.voice_id || (this.voiceMapping[voiceKey] && this.voiceMapping[voiceKey].voiceId || ''),
        sttProvider: sttLlm.sttProvider,
        sttModel: sttLlm.sttModel,
        llmModel: sttLlm.llmModel,
        plivoCallerIds: (() => {
          const ids = this.selectedProject.plivo_caller_ids || this.selectedProject.plivoCallerIds;
          if (!ids) return [];

          // Handle JSON string from backend
          if (typeof ids === 'string') {
            try {
              const parsed = JSON.parse(ids);
              return Array.isArray(parsed) ? parsed : [parsed];
            } catch (e) {
              console.warn('Invalid plivo_caller_ids format:', ids);
              return [];
            }
          }

          // Handle already parsed array
          if (Array.isArray(ids)) return ids;

          // Handle single value
          if (typeof ids === 'object' && ids !== null && ids.value) {
            return [ids.value];
          }

          return [];
        })(),
        autoCall: this.selectedProject.autoCall,
        websiteLink: this.selectedProject.website_link || this.selectedProject.websiteLink,
        entityEmail: this.profile.entity.email,
        transferNumber: this.selectedProject.transfer_number ?
          this.selectedProject.transfer_number.substring(3) : // Remove first 3 chars (country code)
          this.selectedProject.transferNumber
      });

      this.markSttLlmFieldsPristine();

      // Update available voices based on the patched language
      this.updateAvailableVoices(this.selectedProject.language || 'hi');

      // Patch userQuestions
      var userQuestionsArray = this.agentConfigurationForm.get('userQuestions') as FormArray;
      var userQuestionsData = this.selectedProject.user_questions;
      if (typeof userQuestionsData === 'string') {
        try {
          userQuestionsData = JSON.parse(userQuestionsData);
        } catch (e) {
          userQuestionsData = [];
        }
      }
      userQuestionsArray.clear();
      if (Array.isArray(userQuestionsData) && userQuestionsData.length > 0) {
        for (var i = 0; i < userQuestionsData.length; i++) {
          userQuestionsArray.push(new FormControl(userQuestionsData[i]));
        }
      } else {
        userQuestionsArray.push(new FormControl(''));
      }
      console.log('userQuestionsArray after patch:', userQuestionsArray.value);

      // Patch userVariables
      var userVariablesArray = this.agentConfigurationForm.get('userVariables') as FormArray;
      let userVarsObj = this.selectedProject.user_variables;
      if (typeof userVarsObj === 'string') {
        try {
          userVarsObj = JSON.parse(userVarsObj);
        } catch (e) {
          userVarsObj = {};
        }
      }
      if (
        userVariablesArray &&
        this.selectedAgent && this.selectedAgent.variable_inputs &&
        userVarsObj
      ) {
        userVariablesArray.clear();
        for (var j = 0; j < this.selectedAgent.variable_inputs.length; j++) {
          var key = this.selectedAgent.variable_inputs[j];
          var snakeKey = this.toSnakeCase(key);
          var value = '';
          if (userVarsObj.hasOwnProperty(snakeKey)) {
            value = userVarsObj[snakeKey];
          }
          userVariablesArray.push(
            new FormControl(value, Validators.required)
          );
        }
        console.log('userVariablesArray after patch:', userVariablesArray.value);
      }

      // Set loading to false after all form fields are populated
      this.isLoading = false;
    } catch (error) {
      console.error('Error in populateFormFromProject:', error);
      this.isLoading = false; // ✅ Ensure loading stops even on error
    }
  }

  getAgentById(entityId: string, agentId: string) {
    console.log('Fetching agent details...');

    this.enterpriseAdminService.getAgentById(entityId, agentId).subscribe({
      next: (agentData) => {
        if (agentData) {
          this.selectedAgent = agentData;
          console.log('✅ Selected Agent Updated:', this.selectedAgent);

          // ✅ Get userVariables FormArray
          const userVariablesArray = this.agentConfigurationForm.get('userVariables') as FormArray;

          // Always reset and re-create userVariables fields based on selected agent
          userVariablesArray.clear();
          if (Array.isArray(agentData.variable_inputs) && agentData.variable_inputs.length > 0) {
            for (let i = 0; i < agentData.variable_inputs.length; i++) {
              userVariablesArray.push(new FormControl('', Validators.required));
            }
            this.inputFocusedStates = new Array(agentData.variable_inputs.length).fill(false);
          }
          // Don't create any FormControl if variable_inputs is empty or doesn't exist

          // Now patch values from project (if available), after controls are created
          setTimeout(() => {
            this.populateFormFromProject();
          }, 0);
        } else {
          console.warn('⚠️ No agent data received. Creating fallback agent...');
          // ✅ Create fallback agent if no data received
          if (this.selectedProject) {
            this.selectedAgent = {
              agent_id: agentId || this.selectedProject.agent_id || '8d6de7c3-b66b-4f2b-bf6a-e2da09cd63b6',
              agent_name: this.selectedProject.agent_name || 'Cora Agent',
              variable_inputs: []
            };
            const userVariablesArray = this.agentConfigurationForm.get('userVariables') as FormArray;
            userVariablesArray.clear();
            // Don't create FormControl for fallback agent with empty variable_inputs

            // Still populate form with fallback agent
            setTimeout(() => {
              this.populateFormFromProject();
            }, 0);
          } else {
            // ✅ No project data either - just stop loading
            this.isLoading = false;
          }
        }
      },
      error: (error) => {
        console.error('❌ Failed to fetch agent details:', error);
        // ✅ Create fallback agent on error to allow form to load
        if (this.selectedProject) {
          this.selectedAgent = {
            agent_id: agentId || this.selectedProject.agent_id || '8d6de7c3-b66b-4f2b-bf6a-e2da09cd63b6',
            agent_name: this.selectedProject.agent_name || 'Cora Agent',
            variable_inputs: []
          };
          const userVariablesArray = this.agentConfigurationForm.get('userVariables') as FormArray;
          userVariablesArray.clear();
          // Don't create FormControl for fallback agent with empty variable_inputs

          // Populate form with fallback agent
          setTimeout(() => {
            this.populateFormFromProject();
          }, 0);
        } else {
          // ✅ No project data - just stop loading
          this.isLoading = false;
        }
      }
    });
  }

  selectCallAction(callAction: any, outcomeIndex: number, actionIndex: number) {
    const actions = this.outcomes.at(outcomeIndex).get('callActions') as FormArray;
    // actions.removeAt(actionIndex);
    console.log(callAction)
    if (callAction.value === 'Send Email') {
      this.handleCalendarLink(outcomeIndex, actionIndex, callAction.value);
    }
  }

  async handleCalendarLink(outcomeIndex: number, actionIndex: number, action) {
    try {
      this.isLoading = true;

      // Fetch existing user tokens
      const userTokens = await this.fetchUserTokens(this.profile.user.id);

      if (userTokens.length > 0) {
        this.existingAccounts = userTokens;
        const dialogRef = this.dialog.open(GoogleAccountPopupComponent, {
          panelClass: 'add-edit-staff-dialog',
          disableClose: true,
          autoFocus: true,
          width: "400px",
          data: {
            existingAccounts: this.existingAccounts,
            projectId: this.agentConfigurationForm.controls['id'].value
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log(result)
          if (result && typeof result === 'object') {
            this.selectExistingAccount(result, outcomeIndex, actionIndex, action);
          } else {
            if (result) {
              this.linkCalenderWithNewAccount(outcomeIndex, actionIndex, action);
            }
          }
        });

        this.isLoading = false;
      } else {
        // Proceed with original flow
        await this.linkCalenderWithNewAccount(outcomeIndex, actionIndex, action);
      }
    } catch (error) {
      console.error('Error handling calendar link:', error);
      this.isLoading = false;
      this.notify.showMessage('Error checking existing accounts!', 2000);
    }
  }

  private async fetchUserTokens(userId: string): Promise<UserToken[]> {
    try {
      const response = await this.http.get<UserToken[]>(API_AUTH + `/v1/user-tokens/${userId}`).toPromise();
      return response || [];
    } catch (error) {
      console.error('Error fetching user tokens:', error);
      throw error;
    }
  }

  private async linkCalenderWithNewAccount(outcomeIndex: number, actionIndex: number, action) {
    const authInstance = gapi.auth2.getAuthInstance();
    try {
      const response = await authInstance.grantOfflineAccess({
        prompt: 'consent',
      });

      const authCode = response.code;
      console.log('Authorization Code:', authCode);

      const event = await this.http.post<{ idToken: string, refreshToken: string, email: string }>(
        API_AUTH + '/v1/google/exchange-token',
        {
          code: authCode,
          allowFreeDomain: true
        },
      ).toPromise();

      if (event && event.refreshToken) {
        console.log('Refresh token:', event.refreshToken);
        this.saveRefreshToken(this.profile.user.id, event.email, event.refreshToken);
        // this.calendarIntegrated = true;
        const actions = this.outcomes.at(outcomeIndex).get('callActions') as FormArray;
        if (actions && actions.at(actionIndex)) {
          actions.at(actionIndex).patchValue({
            calendarIntegrated: true,
            from_email: event.email,
            refresh_token: event.refreshToken
          });
        } else {
          console.error("Invalid action index or actions array is undefined.");
        }
        this.cdr.detectChanges();

        const projectData = {
          entityId: this.profile.entity.id,
          userId: this.profile.user.id,
          userName: this.profile.user.userMeta.name,
          projectId: this.agentConfigurationForm.controls['id'].value,
          googleCalendarToken: event.refreshToken,
        };

        await this.jobService.updateProject(projectData).toPromise();

        this.isLoading = false;
        this.notify.showMessage('Google account linked successfully!', 2000);
        this.getProjectDetailsById(this.agentConfigurationForm.controls['id'].value, true);
      } else {
        throw new Error('Refresh token not received');
      }
    } catch (error) {
      console.error('Error:', error);
      this.isLoading = false;
      this.notify.showMessage('Error while updating project!', 2000);
    }
  }

  saveRefreshToken(userId: string, email: string, refreshToken: string): void {
    const userTokenDto = { userId, email, googleRefreshToken: refreshToken };
    const authToken = localStorage.getItem("jwtToken");

    const headers = new HttpHeaders({
      'Authorization': '${authToken}',
      'Content-Type': 'application/json'
    });

    this.http.post(API_AUTH + '/v1/user-tokens/save', userTokenDto, { headers })
      .subscribe({
        next: () => console.log("Refresh token stored successfully!"),
        error: (err) => console.error("Failed to store refresh token:", err)
      });
  }

  async selectExistingAccount(account: UserToken, outcomeIndex: number, actionIndex: number, action: any) {
    console.log(account, outcomeIndex, actionIndex)
    const actions = this.outcomes.at(outcomeIndex).get('callActions') as FormArray;
    if (actions && actions.at(actionIndex)) {
      actions.at(actionIndex).patchValue({
        from_email: account.email,
        refresh_token: account.googleRefreshToken
      });
    } else {
      console.error("Invalid action index or actions array is undefined.");
    }

    console.log(actions);
    try {
      this.isLoading = true;

      const projectData = {
        entityId: this.profile.entity.id,
        userId: this.profile.user.id,
        userName: this.profile.user.userMeta.name,
        projectId: this.agentConfigurationForm.controls['id'].value,
        googleCalendarToken: account.googleRefreshToken,
      };

      await this.jobService.updateProject(projectData).toPromise();

      // this.calendarIntegrated = true;
      const actions = this.outcomes.at(outcomeIndex).get('callActions') as FormArray;
      if (actions && actions.at(actionIndex)) {
        actions.at(actionIndex).patchValue({ calendarIntegrated: true });
      } else {
        console.error("Invalid action index or actions array is undefined.");
      }
      this.isLoading = false;
      this.notify.showMessage('Google account linked successfully!', 2000);
      this.getProjectDetailsById(this.agentConfigurationForm.controls['id'].value, true);
    } catch (error) {
      console.error('Error updating with existing account:', error);
      this.isLoading = false;
      this.notify.showMessage('Error while updating project!', 2000);
    }
  }

  useNewAccount(outcomeIndex: number, actionIndex: number, action) {
    this.linkCalenderWithNewAccount(outcomeIndex, actionIndex, action);
  }

  closeModal() {
    this.isLoading = false;
  }

  onCallActionChange(event: MatSelectChange) {
    // if (event.value === 'Send Email') {
    //   console.log("hello");
    //   this.handleCalendarLink();
    // }
  }


  toSnakeCase(text: string): string {
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '_')  // Replace spaces with underscores
      .replace(/[^a-z0-9_]/g, ''); // Remove non-alphanumeric characters
  }

  selectAppearance(appearance: any) {

  }

  get userQuestions(): FormArray {
    return this.agentConfigurationForm.get('userQuestions') as FormArray;
  }

  get userVariables(): FormArray {
    return this.agentConfigurationForm.get('userVariables') as FormArray;
  }

  async onEditAIEnter(event: KeyboardEvent) {
    console.log("onEditAIEnter", event);
    event.preventDefault();
    const editAI = this.scriptFormGroup.get('editAI').value;
    const finalPrompt = this.scriptFormGroup.get('finalPrompt').value;
    if (!editAI || !finalPrompt) return;

    this.notify.showMessage('AI editing started...', 2000);
    this.aiEditInProgress = true;
    this.cdr.detectChanges();

    const input = `<your task> take input the below edit that the user is requesting: <user input start>${editAI}</user input end> And apply it on the below text: <prompt start>${finalPrompt}</prompt end> <output format> only output the updated finalPrompt string and nothing else, do not use \`\`\` just output the final string in plain text format.`;

    // Get required variables
    const entityId = this.profile.entity.id;
    const projectId = this.workflowData.project_id;
    const agentId = this.workflowData.agent_id;
    const baseUrl = environment.projectAPI;
    const apiKey = environment.projectAPIKey;

    const url = `${baseUrl}ai-edit?entityId=${entityId}&projectId=${projectId}&agentId=${agentId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': apiKey
    });
    const body = {
      model: 'gpt-4o',
      input
    };

    try {
      const response: any = await this.http.post(url, body, { headers }).toPromise();
      if (response && response.output_text) {
        this.previousFinalPrompt = this.scriptFormGroup.get('finalPrompt').value; // Store old value
        this.scriptFormGroup.get('finalPrompt').setValue(response.output_text);
        this.scriptFormGroup.get('editAI').setValue('');
        this.notify.showMessage('AI edit complete!', 2000);
      }
    } catch (error) {
      console.error('AI edit failed:', error);
      this.notify.showMessage('AI edit failed. Please try again.', 2000);
    } finally {
      this.aiEditInProgress = false;
      this.cdr.detectChanges();
    }
  }

  undoFinalPromptEdit() {
    if (this.previousFinalPrompt !== undefined && this.previousFinalPrompt !== null && this.previousFinalPrompt !== '') {
      this.scriptFormGroup.get('finalPrompt').setValue(this.previousFinalPrompt);
      this.previousFinalPrompt = '';
      this.notify.showMessage('Undo successful!', 2000);
    }
  }

  openTrainAIDialog() {
    try {
      // Prepare data for the test agent dialog
      const agentId = 'd3c7e4a5-6a7b-4a5f-8c3b-5e9c8b3c8f8e';
      const projectId = (this.workflowData && this.workflowData.project_id) || (this.selectedProject && this.selectedProject.project_id);
      const voiceControl = this.agentConfigurationForm.get('voice');
      const ttsControl = this.agentConfigurationForm.get('tts');
      const languageControl = this.agentConfigurationForm.get('language');
      const agentType = 'train';
      const userPromptControl = this.agentConfigurationForm.get('userPrompt');
      const userQuestionsControl = this.agentConfigurationForm.get('userQuestions');
      const userVariablesControl = this.agentConfigurationForm.get('userVariables');
      const finalPromptControl = this.scriptFormGroup.get('finalPrompt');

      const dialogData = {
        agentId: agentId,
        agentType: agentType,
        entityId: this.profile.entity.id,
        projectId: projectId,
        tts: (ttsControl && ttsControl.value) || 'elevenlabs',
        language: (languageControl && languageControl.value) || 'hi',
        voice: (voiceControl && voiceControl.value) || 'female',
        dialogTitle: 'Train AI',
        customParams: {
          userPrompt: (userPromptControl && userPromptControl.value) || '',
          userQuestions: (userQuestionsControl && userQuestionsControl.value) || [],
          userVariables: (userVariablesControl && userVariablesControl.value) || [],
          finalPrompt: (finalPromptControl && finalPromptControl.value) || ''
        }
      };

      console.log('Opening Train AI dialog with data:', dialogData);

      const dialogRef = this.dialog.open(TestAgentDialogComponent, {
        width: '90vw',
        height: '90vh',
        maxWidth: '600px',
        maxHeight: '500px',
        data: dialogData,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('Train AI dialog closed with result:', result);

        // Always fetch the latest project data when dialog is closed
        const currentProjectId = (this.workflowData && this.workflowData.project_id) || (this.selectedProject && this.selectedProject.project_id);
        if (currentProjectId) {
          this.fetchLatestProjectData(currentProjectId);
        }

        if (result && result.updatedScript) {
          // Update the script with the result from training
          this.previousFinalPrompt = this.scriptFormGroup.get('finalPrompt').value;
          this.scriptFormGroup.get('finalPrompt').setValue(result.updatedScript);
          this.notify.showMessage('AI training completed! Script updated.', 2000);
        }
      });

    } catch (error) {
      console.error('Error opening Train AI dialog:', error);
      this.notify.showMessage('Error opening Train AI dialog. Please try again.', 2000);
    }
  }

  openScriptEditorDialog() {
    const dialogRef = this.dialog.open(ScriptEditorDialogComponent, {
      width: '600px',
      data: {
        scriptFormGroup: this.scriptFormGroup,
        aiEditInProgress: this.aiEditInProgress,
        previousFinalPrompt: this.previousFinalPrompt,
        undoFinalPromptEdit: this.undoFinalPromptEdit.bind(this),
        dialogTitle: 'Edit Call Script'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.saved) {
        this.saveFinalPrompt({ successMessage: 'Call script saved!' }).catch(() => { });
      }
    });
  }

  openWhatsAppScriptEditorDialog() {
    const dialogRef = this.dialog.open(ScriptEditorDialogComponent, {
      width: '600px',
      data: {
        scriptFormGroup: this.scriptFormGroup,
        aiEditInProgress: false,
        previousFinalPrompt: null,
        undoFinalPromptEdit: null,
        formControlName: 'whatsappChatPrompt',
        dialogTitle: 'Edit WhatsApp Script',
        placeholder: 'Describe WhatsApp chat script of the agent'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.saved) {
        this.saveFinalPrompt({ successMessage: 'WhatsApp Script saved!' }).catch(() => { });
      }
    });
  }

  async startVoiceRecording() {
    if (this.isRecording) return;
    this.isRecording = true;
    this.notify.showMessage('Voice recording started...', 2000);
    this.cdr.detectChanges();
    this.audioChunks = [];
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new (window as any).MediaRecorder(stream);
      this.mediaRecorder.ondataavailable = (event: any) => {
        if (event.data.size > 0) {
          this.audioChunks.push(event.data);
        }
      };
      this.mediaRecorder.onstop = async () => {
        const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64Audio = (reader.result as string).split(',')[1];
          await this.sendAudioForTranscription(base64Audio);
        };
        reader.readAsDataURL(audioBlob);
        this.isRecording = false;
        this.cdr.detectChanges();
        this.notify.showMessage('Voice recording stopped.', 2000);
      };
      this.mediaRecorder.start();
      // Auto-stop after 30s
      this.recordTimeout = setTimeout(() => {
        this.stopVoiceRecording();
      }, 30000);
    } catch (err) {
      this.isRecording = false;
      this.cdr.detectChanges();
      this.notify.showMessage('Could not start recording. Please allow mic access.', 2000);
    }
  }

  stopVoiceRecording() {
    if (this.mediaRecorder && this.isRecording) {
      this.mediaRecorder.stop();
      if (this.recordTimeout) clearTimeout(this.recordTimeout);
    }
  }

  async sendAudioForTranscription(base64Audio: string) {
    this.isTranscribing = true;
    // Use the same entityId, projectId, agentId, and API key logic as edit AI endpoint
    const entityId = this.profile.entity.id;
    const projectId = this.workflowData.project_id;
    const agentId = this.workflowData.agent_id;
    const baseUrl = environment.projectAPI;
    const apiKey = environment.projectAPIKey;
    const url = `${baseUrl}ai-voice-transcribe?entityId=${entityId}&projectId=${projectId}&agentId=${agentId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': apiKey
    });
    const body = {
      data: base64Audio
    };
    try {
      const response: any = await this.http.post(url, body, { headers }).toPromise();
      if (response && response.text) {
        this.scriptFormGroup.get('editAI').setValue(response.text);
        this.cdr.detectChanges();
        this.notify.showMessage('Transcription complete!', 2000);
      }
      this.isTranscribing = false;
    } catch (error) {
      this.notify.showMessage('Transcription failed. Please try again.', 2000);
      this.isTranscribing = false;
    }
  }

  private matchIcpProfileKey(variableName: string): string | null {
    if (!this.selectedProject || !this.selectedProject.icp_profile) return null;
    const keys = Object.keys(this.selectedProject.icp_profile);
    const normalizedVar = variableName.replace(/[\s_]/g, '').toLowerCase();
    for (const key of keys) {
      if (key.replace(/[\s_]/g, '').toLowerCase() === normalizedVar) {
        return key;
      }
    }
    return null;
  }


  private fetchLatestProjectData(projectId: string) {
    if (!projectId) {
      console.warn('No project ID provided for fetching latest data');
      return;
    }

    console.log('Fetching latest project data for project ID:', projectId);

    this.jobService.getProjectById(this.profile.entity.id, projectId).subscribe(
      (response) => {
        console.log('✅ Latest project data retrieved:', response);

        if (response && response.final_prompt) {
          // Update the final prompt with the latest data
          const currentFinalPrompt = this.scriptFormGroup.get('finalPrompt').value;
          const newFinalPrompt = response.final_prompt;

          // Only update if the final prompt has actually changed
          if (currentFinalPrompt !== newFinalPrompt) {
            console.log('Updating final prompt from:', currentFinalPrompt, 'to:', newFinalPrompt);
            this.scriptFormGroup.get('finalPrompt').setValue(newFinalPrompt);
            this.notify.showMessage('Script updated with latest changes from training!', 2000);
          } else {
            console.log('Final prompt unchanged, no update needed');
          }
        } else {
          console.log('No final_prompt found in response or response is empty');
        }

        // Also update the selectedProject reference with latest data
        this.selectedProject = response;
      },
      (error) => {
        console.error('❌ Failed to fetch latest project data:', error);
        this.notify.showMessage('Failed to fetch latest project data. Please refresh manually.', 2000);
      }
    );
  }
  testAgent() {
    console.log('Project Details:', this.selectedProject);
    console.log('Profile:', this.profile);

    // Log all available properties in projectDetails
    if (this.selectedProject) {
      console.log('Available properties in projectDetails:');
      Object.keys(this.selectedProject).forEach(key => {
        console.log(`${key}:`, this.selectedProject[key]);
      });
    }

    // Try to get client info from different possible sources
    const clientName = this.selectedProject && (
      this.selectedProject.client_name ||
      this.selectedProject.clientName ||
      this.selectedProject.name ||
      'Test Client'
    );

    const clientEmail = this.selectedProject && (
      this.selectedProject.client_email ||
      this.selectedProject.clientEmail ||
      this.selectedProject.email ||
      'test@example.com'
    );

    const clientNumber = this.selectedProject && (
      this.selectedProject.client_number ||
      this.selectedProject.clientNumber ||
      this.selectedProject.phone ||
      '+1234567890'
    );

    const dialogData = {
      projectId: this.selectedProject && this.selectedProject.project_id,
      entityId: this.profile && this.profile.entity && this.profile.entity.id,
      agentId: this.selectedProject && this.selectedProject.agent_id,
      clientName: clientName,
      clientEmail: clientEmail,
      clientNumber: clientNumber,
      tts: this.selectedProject && this.selectedProject.tts || "elevenlabs",
      language: this.selectedProject && this.selectedProject.language || "hi",
      voice: this.selectedProject && this.selectedProject.voice || "female",
      plivoCallerIds: (() => {
        const project = this.selectedProject;
        if (!project) return [];
        if (project.plivo_caller_ids && Array.isArray(project.plivo_caller_ids)) {
          return project.plivo_caller_ids;
        }
        if (project.plivoCallerIds && Array.isArray(project.plivoCallerIds)) {
          return project.plivoCallerIds;
        }
        if (project.plivo_caller_id) {
          return [project.plivo_caller_id];
        }
        if (project.plivoCallerId) {
          return [project.plivoCallerId];
        }
        return [];
      })(),
      customParams: this.selectedProject && this.selectedProject.custom_params || {}
    };

    console.log('Dialog Data being passed:', dialogData);

    const dialogRef = this.dialog.open(TestAgentDialogComponent, {
      width: '600px',
      height: '500px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: false,
      autoFocus: true,
      data: dialogData
    });

    dialogRef.afterOpened().subscribe(() => {
      console.log('Test Agent dialog opened successfully');
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Test Agent dialog closed:', result);
    });
  }

  getAllAgentsList() {
    const entityId = this.profile && this.profile.entity && this.profile.entity.id;
    // Prefer entity library agents for bind dropdowns; keep legacy list for compat.
    this.enterpriseAdminService.getAllAgentsByEntityId(entityId, 200, 1).subscribe({
      next: (response) => {
        const items = (response && response.items) || [];
        this.agentsList = items;
        this.partitionLibraryAgents(items);
        console.log('✅ Agents list retrieved successfully:', this.agentsList);
      },
      error: (error) => {
        console.error('❌ Failed to fetch library agents, falling back:', error);
        this.jobService.getAllAgentsList(entityId, 'sales').subscribe({
          next: (agents) => {
            this.agentsList = agents || [];
            this.partitionLibraryAgents(this.agentsList);
          },
          error: () => {
            this.agentsList = [];
            this.partitionLibraryAgents([]);
          }
        });
      }
    });
  }

  private normalizeLibraryAgentType(raw: string): string {
    const t = (raw || '').toLowerCase().replace(/-/g, '_');
    if (t.includes('whatsapp') || t === 'wa') {
      return 'whatsapp';
    }
    if (t.includes('inbound')) {
      return 'voice_inbound';
    }
    if (t.includes('outbound') || t.includes('voice')) {
      return 'voice_outbound';
    }
    return t || '';
  }

  partitionLibraryAgents(items: any[]) {
    const list = Array.isArray(items) ? items : [];
    this.outboundAgents = list.filter(a => {
      const t = this.normalizeLibraryAgentType(a.agent_type || a.agentType);
      return t === 'voice_outbound' || t === 'outbound' || !t;
    });
    this.inboundAgents = list.filter(a => {
      const t = this.normalizeLibraryAgentType(a.agent_type || a.agentType);
      return t === 'voice_inbound' || t === 'inbound' || t === 'voice_outbound' || a.use_as_inbound;
    });
    this.whatsappAgents = list.filter(a => {
      const t = this.normalizeLibraryAgentType(a.agent_type || a.agentType);
      return t === 'whatsapp';
    });
  }

  populateAgentBindForm(project: any) {
    if (!this.agentBindForm || !project) {
      return;
    }
    const outboundId = project.call_agent_outbound_id || project.callAgentOutboundId || '';
    let inboundId = project.call_agent_inbound_id || project.callAgentInboundId || '';
    const whatsappId = project.whatsapp_agent_id || project.whatsappAgentId || '';
    if (inboundId && outboundId && inboundId === outboundId) {
      inboundId = '__use_outbound__';
    }
    this.agentBindForm.patchValue({
      enableOutbound: !!(project.enable_call_agent_outbound || outboundId),
      enableInbound: !!(project.enable_call_agent_inbound || inboundId),
      enableWhatsapp: !!(project.enable_whatsapp_agent || whatsappId),
      callAgentOutboundId: outboundId,
      callAgentInboundId: inboundId,
      whatsappAgentId: whatsappId
    });
  }

  saveAgentBindings(advanceStepper = true) {
    const entityId = this.profile && this.profile.entity && this.profile.entity.id;
    const projectId = (this.selectedProject && this.selectedProject.project_id)
      || (this.agentConfigurationForm && this.agentConfigurationForm.get('id')
        && this.agentConfigurationForm.get('id').value);
    if (!entityId || !projectId) {
      this.isLoading = false;
      this.notify.showMessage('Project context missing', 2500);
      return;
    }

    const bind = this.agentBindForm.getRawValue();
    let inboundId = bind.callAgentInboundId;
    if (inboundId === '__use_outbound__') {
      inboundId = bind.callAgentOutboundId || '';
    }

    this.isLoading = true;
    this.enterpriseAdminService.bindProjectAgents({
      entityId,
      projectId,
      enableOutbound: !!bind.enableOutbound,
      enableInbound: !!bind.enableInbound,
      enableWhatsapp: !!bind.enableWhatsapp,
      callAgentOutboundId: bind.enableOutbound ? (bind.callAgentOutboundId || '') : '',
      callAgentInboundId: bind.enableInbound ? (inboundId || '') : '',
      whatsappAgentId: bind.enableWhatsapp ? (bind.whatsappAgentId || '') : ''
    }).subscribe(
      res => {
        this.isLoading = false;
        if (res && res.success === false) {
          this.notify.showMessage((res && res.error) || 'Failed to bind agents', 2500);
          return;
        }
        this.notify.showMessage('Agents bound to project', 2000);
        if (advanceStepper && this.stepper) {
          this.stepper.next();
        }
      },
      err => {
        this.isLoading = false;
        console.error(err);
        this.notify.showMessage('Failed to bind agents', 2500);
      }
    );
  }

  getPhoneNumbers() {
    this.jobService.listPhoneNumbers().subscribe({
      next: (response: any) => {
        console.log("response", response);
        // Filter only phone numbers with active status
        this.phoneNumbers = (response.content || []).filter((phone: any) => phone.status === 'active');
      },
      error: (err) => {

      }
    });
  }

  openBuyPhoneNumberDialog() {
    const dialogRef = this.dialog.open(PhoneNumbersComponent, {
      width: '512px',
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        console.log(result.message);
        // Refresh the phone numbers list after successful purchase
        this.getPhoneNumbers();
      }
    });
  }

  onPlivoCallerIdChange(event: MatSelectChange) {
    const selectedValues = Array.isArray(event.value) ? event.value : [event.value];

    // Check if 'buy_new' is in the selection
    if (selectedValues.includes('buy_new')) {
      // Remove 'buy_new' from the selection
      const filteredValues = selectedValues.filter(val => val !== 'buy_new');
      this.agentConfigurationForm.get('plivoCallerIds').setValue(filteredValues);
      this.openBuyPhoneNumberDialog();
    }
  }

  onAgentChange(event: MatSelectChange) {
    const selectedAgentId = event.value;
    const matchedAgent = this.agentsList.find(function (agent) { return agent.agent_id === selectedAgentId; });
    if (!matchedAgent) return;

    this.selectedAgent = matchedAgent;

    const agentIdControl = this.agentConfigurationForm.get('agentId');
    const agentNameControl = this.agentConfigurationForm.get('agentName');

    if (agentIdControl) agentIdControl.setValue(this.selectedAgent.agent_id);
    if (agentNameControl) agentNameControl.setValue(this.selectedAgent.agent_name);

    // Always reset and re-create userVariables fields based on selected agent
    const userVariablesControl = this.agentConfigurationForm.get('userVariables');
    console.log("userVariablesControl", userVariablesControl)
    if (userVariablesControl && userVariablesControl instanceof FormArray) {
      userVariablesControl.clear();

      if (Array.isArray(this.selectedAgent.variable_inputs) && this.selectedAgent.variable_inputs.length > 0) {
        const staticDefaults = [
          'Arya',
          this.profile.entity.entityMeta.name
        ];
        for (let i = 0; i < this.selectedAgent.variable_inputs.length; i++) {
          let defaultValue = '';
          if (i === 0) {
            defaultValue = staticDefaults[0];
          } else if (i === 1) {
            defaultValue = staticDefaults[1];
          } else if (i === 2 && this.selectedProject && this.selectedProject.icp_profile && this.selectedProject.icp_profile.position) {
            defaultValue = this.selectedProject.icp_profile.position.value || '';
          } else if (i === 3 && this.selectedProject && this.selectedProject.icp_profile && this.selectedProject.icp_profile.experience) {
            defaultValue = this.selectedProject.icp_profile.experience.value || '';
          }
          userVariablesControl.push(new FormControl(defaultValue, Validators.required));
        }
        this.inputFocusedStates = new Array(this.selectedAgent.variable_inputs.length).fill(false);
      }
      // Don't create any FormControl if variable_inputs is empty or doesn't exist
    }

    // Details are already present from agentsList; avoid extra API call
  }

  fetchWebsiteDetails() {


  }

  onStepChange(event: any) {
    // NOTE: Do NOT repopulate Step 1 from `selectedProject` here.
    // The reactive form retains its state across stepper navigation (Material keeps
    // every step in the DOM), so the user's in-memory selections are already intact.
    // Re-running populateFormFromProject() on every back-navigation overwrote those
    // selections with stale data and could blank out the voice dropdown when the
    // fallback voice key isn't part of the current language's availableVoices list.
  }


  restoreStep1Form() {
    this.populateFormFromProject();
  }

  // WhatsApp Authentication Methods
  authenticateWhatsapp() {
    const projectId = this.agentConfigurationForm.controls['id'].value;
    if (!projectId) {
      console.error('No project ID available');
      return;
    }

    const body = {
      entity_id: this.profile.entity.id,
      project_id: projectId,
      project_name: this.agentConfigurationForm.controls['projectName'].value || 'Your Project Name'
    };

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    console.log('Creating WhatsApp session:', body);

    // Step 1: Create session
    this.http.post<WhatsAppResponse>(API_WHATSAPP_SESSION, body, { headers, observe: 'response' }).subscribe({
      next: (response) => {
        console.log('Session created - Response:', response.body);
        this.whatsappResponse = response.body;

        // Step 2: After session is created, fetch QR code
        if (response.body) {
          this.whatsappSessionId = response.body.session_id || projectId;
          // Call fetchWhatsAppQR to get QR code and show popup
          this.fetchWhatsAppQR();
        } else {
          this.notify.showMessage('Session created but no response received', 2000);
        }
      },
      error: (err) => {
        console.error('Error creating WhatsApp session:', err);
        this.notify.showMessage('Failed to create WhatsApp session', 2000);
      }
    });
  }

  fetchWhatsAppQR() {
    const projectId = this.agentConfigurationForm.controls['id'].value;
    if (!projectId) {
      console.error('No project ID available for QR fetch');
      return;
    }

    const params = new URLSearchParams({
      project_id: projectId,
      entity_id: this.profile.entity.id
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true',
      'Accept': 'image/png,image/*,*/*'
    });

    console.log('Fetching WhatsApp QR code...');

    // Step 3: Fetch QR code (binary PNG image) and display in popup
    this.http.get(`${API_WHATSAPP_QR}?${params.toString()}`, {
      headers,
      responseType: 'blob'
    }).subscribe({
      next: (response: Blob) => {
        console.log('QR Code response received:', response);
        console.log('Blob size:', response.size, 'Blob type:', response.type);

        // Create a new blob with explicit PNG type
        const pngBlob = new Blob([response], { type: 'image/png' });

        // Create object URL from blob
        const blobUrl = URL.createObjectURL(pngBlob);
        console.log('Created blob URL:', blobUrl);

        // Sanitize the blob URL for Angular
        this.qrCodeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);

        // Show the popup with QR code
        this.showWhatsappQRPopup = true;

        // Start polling for connection status
        this.startWhatsAppStatusPolling();
      },
      error: (err) => {
        console.error('Error fetching QR code:', err);
        this.notify.showMessage('Failed to fetch QR code', 2000);
      }
    });
  }

  showWhatsappQRDialog() {
    this.showWhatsappQRPopup = true;
  }

  closeWhatsappQRDialog() {
    this.showWhatsappQRPopup = false;
    // Revoke object URL to prevent memory leaks
    let urlString: string = '';
    if (typeof this.qrCodeUrl === 'string') {
      urlString = this.qrCodeUrl;
    } else if (this.qrCodeUrl) {
      urlString = (this.qrCodeUrl as any).changingThisBreaksApplicationSecurity || '';
    }
    if (urlString && urlString.startsWith('blob:')) {
      URL.revokeObjectURL(urlString);
    }
    this.qrCodeUrl = '';
    this.whatsappSessionId = '';
    this.stopWhatsAppStatusPolling();
  }

  checkWhatsAppStatus() {
    const projectId = this.agentConfigurationForm.controls['id'].value;
    if (!projectId) {
      console.log('No project ID available for WhatsApp status check');
      return;
    }

    const params = new URLSearchParams({
      project_id: projectId,
      entity_id: this.profile.entity.id
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const statusUrl = `${API_WHATSAPP_STATUS}?${params.toString()}`;
    console.log('statusUrl', statusUrl);

    this.http.get(statusUrl, { headers }).subscribe({
      next: (response: any) => {
        console.log('WhatsApp status response:', response);
        this.whatsappStatus = response;

        // Check authenticated status from data.data.authenticated
        if (response && response.data && response.data.data) {
          const statusData = response.data.data;
          this.isWhatsappConnected = statusData.authenticated === true;
          // Store phone number if available
          if (statusData.phone) {
            this.whatsappStatus.phone = statusData.phone;
          }
        } else {
          // Fallback for old format
          this.isWhatsappConnected = false;
        }
      },
      error: (err) => {
        console.error('Status check failed:', err);
        this.isWhatsappConnected = false;
      }
    });
  }

  startWhatsAppStatusPolling() {
    console.log('Starting WhatsApp status polling...');
    this.whatsappStatusInterval = setInterval(() => {
      this.pollWhatsAppStatus();
    }, 3000); // Poll every 3 seconds
  }

  stopWhatsAppStatusPolling() {
    if (this.whatsappStatusInterval) {
      console.log('Stopping WhatsApp status polling...');
      clearInterval(this.whatsappStatusInterval);
      this.whatsappStatusInterval = null;
    }
  }

  pollWhatsAppStatus() {
    const projectId = this.agentConfigurationForm.controls['id'].value;
    if (!projectId) return;

    const params = new URLSearchParams({
      project_id: projectId,
      entity_id: this.profile.entity.id
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const statusUrl = `${API_WHATSAPP_STATUS}?${params.toString()}`;

    this.http.get(statusUrl, { headers }).subscribe({
      next: (response: any) => {
        console.log('Polling - WhatsApp status:', response);
        this.whatsappStatus = response;
        const wasConnected = this.isWhatsappConnected;

        // Check authenticated status from data.data.authenticated
        if (response && response.data && response.data.data) {
          const statusData = response.data.data;
          this.isWhatsappConnected = statusData.authenticated === true;
          // Store phone number if available
          if (statusData.phone) {
            this.whatsappStatus.phone = statusData.phone;
          }
        } else {
          // Fallback for old format
          this.isWhatsappConnected = false;
        }

        // If just connected, close the popup
        if (this.isWhatsappConnected && !wasConnected) {
          console.log('WhatsApp connected! Closing popup...');
          this.closeWhatsappQRDialog();
        }
      },
      error: (err) => {
        console.error('Polling status check failed:', err);
      }
    });
  }

  // Inbound Agent API Methods

  async getInboundBearerToken(): Promise<string> {
    const url = `${environment.pipecatAPI}/auth/login`;
    const credentials = {
      username: 'dev',
      password: '696zNilL^8!H9LXT'
    };

    try {
      const response: any = await this.http.post(url, credentials, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }).toPromise();

      if (response && response.access_token) {
        this.inboundBearerToken = response.access_token;
        console.log('🔑 NEW TOKEN RECEIVED:', {
          token: this.inboundBearerToken,
          exp: response.expires_in || 'unknown'
        });
        return response.access_token;
      } else {
        console.error('❌ No access_token in response:', response);
        throw new Error('No token received');
      }
    } catch (error) {
      console.error('Error getting bearer token:', error);
      this.notify.showMessage('Failed to get bearer token for inbound agent', 2000);
      throw error;
    }
  }

  async createOrUpdateInboundConfig(config: any): Promise<any> {
    console.log('🚀 createOrUpdateInboundConfig - Token check:', {
      hasToken: !!this.inboundBearerToken,
      tokenStart: this.inboundBearerToken
    });

    if (!this.inboundBearerToken) {
      console.log('🔑 No token found, fetching new one...');
      await this.getInboundBearerToken();
    }

    const url = `${environment.pipecatAPI}/config/phone`;

    try {
      console.log('📤 Using token for POST /config/phone:', this.inboundBearerToken);

      const response = await this.http.post(url, config, {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.inboundBearerToken}`,
          'Content-Type': 'application/json'
        })
      }).toPromise();

      console.log('✅ POST /config/phone SUCCESS:', response);
      return response;
    } catch (error) {
      // If token expired, get a new one and retry once
      if (error.status === 401) {
        console.log('Token expired, refreshing...');
        await this.getInboundBearerToken();

        // Retry with fresh token
        const response = await this.http.post(url, config, {
          headers: new HttpHeaders({
            'Authorization': `Bearer ${this.inboundBearerToken}`,
            'Content-Type': 'application/json'
          })
        }).toPromise();

        return response;
      }

      console.error('Error creating/updating inbound config:', error);
      this.notify.showMessage('Failed to create/update inbound configuration', 2000);
      throw error;
    }
  }

  async fetchInboundConfigs(): Promise<any> {
    console.log('🔍 fetchInboundConfigs - Token check:', {
      hasToken: !!this.inboundBearerToken,
      tokenStart: this.inboundBearerToken ? this.inboundBearerToken.substring(0, 20) + '...' : 'none'
    });

    if (!this.inboundBearerToken) {
      console.log('🔑 No token found, fetching new one...');
      await this.getInboundBearerToken();
    }

    const url = `${environment.pipecatAPI}/config/phones`;

    try {
      console.log('📥 Using token for GET /config/phones:', this.inboundBearerToken.substring(0, 20) + '...');

      const response = await this.http.get(url, {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${this.inboundBearerToken}`
        })
      }).toPromise();

      console.log('✅ GET /config/phones SUCCESS:', response);
      this.inboundConfigs = response as any[];
      return response;
    } catch (error) {
      // If token expired, get a new one and retry once
      if (error.status === 401) {
        console.log('Token expired, refreshing...');
        await this.getInboundBearerToken();

        // Retry with fresh token
        const response = await this.http.get(url, {
          headers: new HttpHeaders({
            'Authorization': `Bearer ${this.inboundBearerToken}`
          })
        }).toPromise();

        this.inboundConfigs = response as any[];
        return response;
      }

      console.error('Error fetching inbound configs:', error);
      this.notify.showMessage('Failed to fetch inbound configurations', 2000);
      throw error;
    }
  }

  onAgentTypeChange(event: MatSelectChange) {
    this.agentType = event.value;
    console.log('Agent type changed to:', this.agentType);

    // Update validation rules based on agent type
    this.updateValidationRules();

    // No need to make API calls just for changing the dropdown selection
    // API calls will happen when user actually saves the project
  }

  updateValidationRules() {
    const plivoCallerIdsControl = this.agentConfigurationForm.get('plivoCallerIds');

    // Same validation for both inbound and outbound - both need at least one phone number
    if (this.agentType === 'outbound' || this.agentType === 'inbound') {
      plivoCallerIdsControl.setValidators([
        Validators.required,
        (control) => {
          const value = control.value;
          if (!value || !Array.isArray(value) || value.length === 0) {
            return { required: true };
          }
          return null;
        }
      ]);
      plivoCallerIdsControl.updateValueAndValidity();
    }
  }

  private isInboundAgentType(): boolean {
    // Prefer explicit component selection; fall back to project data
    if (this.agentType) {
      return this.agentType === 'inbound';
    }
    if (this.selectedProject && this.selectedProject.agent_type) {
      return this.selectedProject.agent_type === 'inbound';
    }
    if (this.workflowData && this.workflowData.agent_type) {
      return this.workflowData.agent_type === 'inbound';
    }
    return false;
  }

  ngOnDestroy() {
    // Clean up WhatsApp polling interval
    this.stopWhatsAppStatusPolling();
    this.layoutService.clearPageNavigator();
    this.layoutService.clearProjectDetails();
  }

  // Voice and Language handling methods
  onLanguageChange(event: MatSelectChange) {
    const language = event.value;
    this.updateAvailableVoices(language);

    // Reset voice selection and voiceId when language changes
    this.agentConfigurationForm.get('voice').setValue('');
    this.agentConfigurationForm.get('voiceId').setValue('');
  }

  onVoiceChange(event: MatSelectChange) {
    const voiceKey = event.value;
    const voiceInfo = this.voiceMapping[voiceKey];

    if (voiceInfo) {
      // Automatically set the provider and voiceId based on voice selection
      this.agentConfigurationForm.get('tts').setValue(voiceInfo.provider);
      this.agentConfigurationForm.get('voiceId').setValue(voiceInfo.voiceId);
      console.log(`Selected voice: ${voiceInfo.name} (${voiceInfo.provider}) with voiceId: ${voiceInfo.voiceId}`);
    }
  }

  updateAvailableVoices(language: string) {
    this.availableVoices = [];

    // Filter voices based on language
    Object.keys(this.voiceMapping).forEach(key => {
      if (key.includes(`_${language}_`)) {
        const voiceInfo = this.voiceMapping[key];
        const providerSuffix = this.getProviderSuffix(voiceInfo.provider);
        this.availableVoices.push({
          value: key,
          label: `${voiceInfo.name} - ${providerSuffix}`
        });
      }
    });

    console.log(`Available voices for ${language}:`, this.availableVoices);
  }

  getProviderSuffix(provider: string): string {
    switch (provider) {
      case 'elevenlabs': return 'EL';
      case 'google': return 'GO';
      case 'sarvam': return 'SA';
      case 'smallest': return 'SM';
      case 'gemini': return 'GE';
      default: return '';
    }
  }

  getVoiceIdFromSelection(): string {
    const voiceKey = this.agentConfigurationForm.get('voice').value;
    const voiceInfo = this.voiceMapping[voiceKey];
    return voiceInfo ? voiceInfo.voiceId : 'ZUrEGyu8GFMwnHbvLhv2'; // Default fallback
  }

  getVoiceKeyFromProject(project: any): string {
    if (!project) return 'monika_hi_female'; // Default fallback

    const language = project.language || 'hi';
    const tts = project.tts || 'elevenlabs';

    console.log(`🔍 Project details - language: "${project.language}" -> "${language}", tts: "${project.tts}" -> "${tts}"`);

    // First, try to match by voice_id if available (most accurate)
    if (project.voice_id) {
      // Several languages share the same voiceId (e.g. monika_en_female and
      // monika_hi_female both map to 'ZUrEGyu8GFMwnHbvLhv2'). A plain find() returns
      // whichever key is declared first, which can be a different language than the
      // project. That key is then absent from availableVoices (filtered by language),
      // leaving the Voice dropdown blank. So prefer a voiceId match that ALSO matches
      // the project's language before falling back to the first match.
      const voiceIdMatches = Object.keys(this.voiceMapping).filter(key => {
        const voiceInfo = this.voiceMapping[key];
        return voiceInfo && voiceInfo.voiceId === project.voice_id;
      });

      const voiceKeyByVoiceId =
        voiceIdMatches.find(key => key.includes(`_${language}_`)) || voiceIdMatches[0];

      if (voiceKeyByVoiceId) {
        console.log(`🔍 Found voice by voice_id: ${project.voice_id} -> ${voiceKeyByVoiceId}`);
        return voiceKeyByVoiceId;
      } else {
        console.log(`🔍 No voice found matching voice_id: ${project.voice_id}, falling back to other method`);
      }
    }

    // Extract gender from voice field - it might be stored as 'male'/'female' or as a voice name
    let gender = 'female'; // Default
    if (project.voice) {
      const voice = project.voice.toLowerCase().trim();
      console.log(`🔍 Raw project.voice: "${project.voice}", normalized: "${voice}"`);

      // Check for exact matches first
      if (voice === 'male') {
        gender = 'male';
        console.log(`🔍 Detected gender: male (exact match)`);
      } else if (voice === 'female') {
        gender = 'female';
        console.log(`🔍 Detected gender: female (exact match)`);
      } else if (voice.includes('male')) {
        gender = 'male';
        console.log(`🔍 Detected gender: male (contains 'male')`);
      } else if (voice.includes('female')) {
        gender = 'female';
        console.log(`🔍 Detected gender: female (contains 'female')`);
      } else {
        console.log(`🔍 No gender detected, using default: female`);
      }
    } else {
      console.log(`🔍 No project.voice field found, using default: female`);
    }

    console.log(`🔍 Final gender decision: ${gender}`);

    // Try to find matching voice key by language, gender, and provider
    const voiceKey = Object.keys(this.voiceMapping).find(key => {
      const voiceInfo = this.voiceMapping[key];
      const matchesLanguage = key.includes(`_${language}_`);
      const matchesGender = key.includes(`_${gender}`);
      const matchesProvider = voiceInfo.provider === tts;

      console.log(`🔍 Checking key: ${key}, language: ${matchesLanguage}, gender: ${matchesGender}, provider: ${matchesProvider} (${voiceInfo.provider} === ${tts})`);

      return matchesLanguage && matchesGender && matchesProvider;
    });

    console.log(`🔍 Voice mapping search: language=${language}, gender=${gender}, tts=${tts}, found=${voiceKey}`);
    console.log(`🔍 Project voice field: "${project.voice}"`);

    return voiceKey || 'monika_hi_female'; // Default fallback
  }

  getGenderFromVoiceSelection(): string {
    const voiceKey = this.agentConfigurationForm.get('voice').value;
    return voiceKey.includes('_male') ? 'male' : 'female';
  }

  // WhatsApp Image Upload Methods
  onWhatsAppImageSelect(event: any, outcomeIndex: number, actionIndex: number) {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      this.notify.showMessage('Please select a valid image file (jpg, jpeg, png, gif, webp)', 3000);
      return;
    }

    const actionKey = `${outcomeIndex}_${actionIndex}`;
    this.whatsappImageUploading[actionKey] = true;

    const projectId = this.agentConfigurationForm && this.agentConfigurationForm.controls && this.agentConfigurationForm.controls['id'] ? this.agentConfigurationForm.controls['id'].value : null;
    const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : null;

    if (!projectId || !entityId) {
      this.notify.showMessage('Project ID or Entity ID not available', 3000);
      this.whatsappImageUploading[actionKey] = false;
      return;
    }

    // Step 1: Get upload URL
    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const requestBody = {
      projectId: projectId,
      entityId: entityId,
      filename: file.name,
      contentType: file.type
    };

    this.http.post(API_WHATSAPP_UPLOAD_IMAGE, requestBody, { headers }).subscribe({
      next: (response: any) => {
        if (response && response.uploadUrl && response.imageUrl) {
          // Step 2: Upload file to S3
          this.uploadFileToS3(file, response.uploadUrl, response.imageUrl, actionKey, file.type);
        } else {
          this.whatsappImageUploading[actionKey] = false;
          this.notify.showMessage('Failed to get upload URL', 3000);
        }
      },
      error: (err) => {
        this.whatsappImageUploading[actionKey] = false;
        console.error('Error getting upload URL:', err);
        this.notify.showMessage('Failed to get upload URL. Please try again.', 3000);
      }
    });
  }

  uploadFileToS3(file: File, uploadUrl: string, imageUrl: string, actionKey: string, contentType: string) {
    // Use fetch to upload directly to S3 (bypass Angular HTTP interceptors)
    fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': contentType
      }
    })
      .then((response) => {
        this.whatsappImageUploading[actionKey] = false;
        if (response.ok) {
          // Store the imageUrl for this action
          this.whatsappImageUrls[actionKey] = imageUrl;

          // Also store in the form control
          const [outcomeIndex, actionIndex] = actionKey.split('_').map(Number);
          const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
          if (outcomes && outcomes.at(outcomeIndex)) {
            const callActions = outcomes.at(outcomeIndex).get('callActions') as FormArray;
            if (callActions && callActions.at(actionIndex)) {
              callActions.at(actionIndex).get('image_url').setValue(imageUrl);
            }
          }

          this.notify.showMessage('Image uploaded successfully', 2000);
        } else {
          this.notify.showMessage('Failed to upload image to S3', 3000);
        }
      })
      .catch((error) => {
        this.whatsappImageUploading[actionKey] = false;
        console.error('Error uploading to S3:', error);
        this.notify.showMessage('Failed to upload image. Please try again.', 3000);
      });
  }

  getWhatsAppImageUrl(outcomeIndex: number, actionIndex: number): string {
    const actionKey = `${outcomeIndex}_${actionIndex}`;
    // First check the stored imageUrls
    if (this.whatsappImageUrls[actionKey]) {
      return this.whatsappImageUrls[actionKey];
    }
    // Fallback to form control value
    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
    if (outcomes && outcomes.at(outcomeIndex)) {
      const callActions = outcomes.at(outcomeIndex).get('callActions') as FormArray;
      if (callActions && callActions.at(actionIndex)) {
        const imageUrl = callActions.at(actionIndex).get('image_url').value;
        if (imageUrl) {
          this.whatsappImageUrls[actionKey] = imageUrl; // Cache it
          return imageUrl;
        }
      }
    }
    return '';
  }

  isWhatsAppImageUploading(outcomeIndex: number, actionIndex: number): boolean {
    const actionKey = `${outcomeIndex}_${actionIndex}`;
    return this.whatsappImageUploading[actionKey] || false;
  }

  removeWhatsAppImage(outcomeIndex: number, actionIndex: number) {
    const actionKey = `${outcomeIndex}_${actionIndex}`;
    delete this.whatsappImageUrls[actionKey];
    // Also clear from form control
    const outcomes = this.workflowOutcomeForm.get('outcomes') as FormArray;
    if (outcomes && outcomes.at(outcomeIndex)) {
      const callActions = outcomes.at(outcomeIndex).get('callActions') as FormArray;
      if (callActions && callActions.at(actionIndex)) {
        callActions.at(actionIndex).get('image_url').setValue('');
      }
    }
  }
}
